let path = `https://browardstormviewerblobs.z13.web.core.windows.net/public`;

/*
This file contains all the photo urls for each location. 
Not all scenarios have 360 photos at every location. 
*/

export const photoLocations = {
 "Saint Ambrose 2": {
  scenario: {
   "Baseline Scenario RP2": {
    url: `${path}/Saint Ambrose - RP2.jpg`,
   },
   "Baseline Scenario RP3": {
    url: `${path}/Saint Ambrose - RP3.jpg`,
   },
   "Baseline Scenario RP4": {
    url: `${path}/Saint Ambrose - RP4.jpg`,
   },
   "Baseline Scenario RP6": {
    url: `${path}/Saint Ambrose - RP6.jpg`,
   },
   "Baseline Scenario RP7": {
    url: `${path}/Saint Ambrose - RP7.jpg`,
   },
   "Baseline Scenario RP8": {
    url: `${path}/Saint Ambrose - RP8.jpg`,
   },
   "Baseline Scenario RP9": {
    url: `${path}/Saint Ambrose - RP9.jpg`,
   },
   "Baseline Scenario RP10": {
    url: `${path}/Saint Ambrose - RP10.jpg`,
   },
   "Baseline Scenario RP11": {
    url: `${path}/Saint Ambrose - RP11.jpg`,
   },
   "Baseline Scenario RP12": {
    url: `${path}/Saint Ambrose - RP12.jpg`,
   },
   "Baseline Scenario RP13": {
    url: `${path}/Saint Ambrose - RP13.jpg`,
   },
   "Baseline Scenario RP15": {
    url: `${path}/Saint Ambrose - RP15.jpg`,
   },
   "Baseline Scenario RP16": {
    url: `${path}/Saint Ambrose - RP16.jpg`,
   },
   "Baseline Scenario RP17": {
    url: `${path}/Saint Ambrose - RP17.jpg`,
   },
   "Baseline Scenario RP18": {
    url: `${path}/Saint Ambrose - RP18.jpg`,
   },
   "Baseline Scenario RP30": {
    url: `${path}/Saint Ambrose - RP30.jpg`,
   },
   "Baseline Scenario RP35": {
    url: `${path}/Saint Ambrose - RP35.jpg`,
   },
   "Baseline Scenario RP38": {
    url: `${path}/Saint Ambrose - RP38.jpg`,
   },
   "Baseline Scenario RP42": {
    url: `${path}/Saint Ambrose - RP42.jpg`,
   },
   "Baseline Scenario RP46": {
    url: `${path}/Saint Ambrose - RP46.jpg`,
   },
   "Baseline Scenario RP47": {
    url: `${path}/Saint Ambrose - RP47.jpg`,
   },
   "Baseline Scenario RP49": {
    url: `${path}/Saint Ambrose - RP49.jpg`,
   },
   "Baseline Scenario VA1": {
    url: `${path}/Saint Ambrose - VA1.jpg`,
   },
   "Baseline Scenario VA3": {
    url: `${path}/Saint Ambrose - VA3.jpg`,
   },

   "Adaptation Suite AS5 RP2": {
    url: `${path}/Saint Ambrose - AS5_RP2.jpg`,
   },
   "Adaptation Suite AS5 RP3": {
    url: `${path}/Saint Ambrose - AS5_RP3.jpg`,
   },
   "Adaptation Suite AS5 RP4": {
    url: `${path}/Saint Ambrose - AS5_RP4.jpg`,
   },
   "Adaptation Suite AS5 RP6": {
    url: `${path}/Saint Ambrose - AS5_RP6.jpg`,
   },
   "Adaptation Suite AS5 RP7": {
    url: `${path}/Saint Ambrose - AS5_RP7.jpg`,
   },
   "Adaptation Suite AS5 RP8": {
    url: `${path}/Saint Ambrose - AS5_RP8.jpg`,
   },
   "Adaptation Suite AS5 RP9": {
    url: `${path}/Saint Ambrose - AS5_RP9.jpg`,
   },
   "Adaptation Suite AS5 RP10": {
    url: `${path}/Saint Ambrose - AS5_RP10.jpg`,
   },
   "Adaptation Suite AS5 RP11": {
    url: `${path}/Saint Ambrose - AS5_RP11.jpg`,
   },
   "Adaptation Suite AS5 RP12": {
    url: `${path}/Saint Ambrose - AS5_RP12.jpg`,
   },
   "Adaptation Suite AS5 RP13": {
    url: `${path}/Saint Ambrose - AS5_RP13.jpg`,
   },
   "Adaptation Suite AS5 RP15": {
    url: `${path}/Saint Ambrose - AS5_RP15.jpg`,
   },
   "Adaptation Suite AS5 RP16": {
    url: `${path}/Saint Ambrose - AS5_RP16.jpg`,
   },
   "Adaptation Suite AS5 RP17": {
    url: `${path}/Saint Ambrose - AS5_RP17.jpg`,
   },
   " Adaptation Suite AS5 RP18": {
    url: `${path}/Saint Ambrose - AS5_RP18.jpg`,
   },
   "Adaptation Suite AS5 RP30": {
    url: `${path}/Saint Ambrose - AS5_RP30.jpg`,
   },
   "Adaptation Suite AS5 RP35": {
    url: `${path}/Saint Ambrose - AS5_RP35.jpg`,
   },
   "Adaptation Suite AS5 RP38": {
    url: `${path}/Saint Ambrose - AS5_RP38.jpg`,
   },
   "Adaptation Suite AS5 RP42": {
    url: `${path}/Saint Ambrose - AS5_RP42.jpg`,
   },
   "Adaptation Suite AS5 RP46": {
    url: `${path}/Saint Ambrose - AS5_RP46.jpg`,
   },
   "Adaptation Suite AS5 RP47": {
    url: `${path}/Saint Ambrose - AS5_RP47.jpg`,
   },
   "Adaptation Suite AS5 RP49": {
    url: `${path}/Saint Ambrose - AS5_RP49.jpg`,
   },

   "AS5b RP2": {
    url: `${path}/Saint Ambrose - AS5b_RP2.jpg`,
   },
   "Adaptation Suite AS5b RP3": {
    url: `${path}/Saint Ambrose - AS5b_RP3.jpg`,
   },
   "Adaptation Suite AS5b RP4": {
    url: `${path}/Saint Ambrose - AS5b_RP4.jpg`,
   },
   "Adaptation Suite AS5b RP6": {
    url: `${path}/Saint Ambrose - AS5b_RP6.jpg`,
   },
   "Adaptation Suite AS5b RP7": {
    url: `${path}/Saint Ambrose - AS5b_RP7.jpg`,
   },
   "Adaptation Suite AS5b RP8": {
    url: `${path}/Saint Ambrose - AS5b_RP8.jpg`,
   },
   "Adaptation Suite AS5b RP9": {
    url: `${path}/Saint Ambrose - AS5b_RP9.jpg`,
   },
   "Adaptation Suite AS5b RP10": {
    url: `${path}/Saint Ambrose - AS5b_RP10.jpg`,
   },
   "Adaptation Suite AS5b RP11": {
    url: `${path}/Saint Ambrose - AS5b_RP11.jpg`,
   },
   "Adaptation Suite AS5b RP12": {
    url: `${path}/Saint Ambrose - AS5b_RP12.jpg`,
   },
   "Adaptation Suite AS5b RP13": {
    url: `${path}/Saint Ambrose - AS5b_RP13.jpg`,
   },
   "Adaptation Suite AS5b RP15": {
    url: `${path}/Saint Ambrose - AS5b_RP15.jpg`,
   },
   "Adaptation Suite AS5b RP16": {
    url: `${path}/Saint Ambrose - AS5b_RP16.jpg`,
   },
   "Adaptation Suite AS5b RP17": {
    url: `${path}/Saint Ambrose - AS5b_RP17.jpg`,
   },
   "Adaptation Suite AS5b RP18": {
    url: `${path}/Saint Ambrose - AS5b_RP18.jpg`,
   },
   "Adaptation Suite AS5b RP42": {
    url: `${path}/Saint Ambrose - AS5b_RP42.jpg`,
   },
   "Adaptation Suite AS5b RP47": {
    url: `${path}/Saint Ambrose - AS5b_RP47.jpg`,
   },
   "Adaptation Suite AS5b RP49": {
    url: `${path}/Saint Ambrose - AS5b_RP49.jpg`,
   },
  },
  baseline: {
   url: `${path}/Saint Ambrose - High Resolution.jpg`,
  },
 },
 "Deerfield Mall 1": {
  scenario: {
   "Baseline Scenario RP2": {
    url: `${path}/Deerfield Mall - rp2_c.jpg`,
   },
   "Baseline Scenario RP3": {
    url: `${path}/Deerfield Mall - rp3_c.jpg`,
   },
   "Baseline Scenario RP6": {
    url: `${path}/Deerfield Mall - rp6_c.jpg`,
   },
   "Baseline Scenario RP8": {
    url: `${path}/Deerfield Mall - rp8_c.jpg`,
   },
   "Baseline Scenario RP9": {
    url: `${path}/Deerfield Mall - rp9_c.jpg`,
   },
   "Baseline Scenario RP11": {
    url: `${path}/Deerfield Mall - rp11.jpg`,
   },
   "Baseline Scenario RP12": {
    url: `${path}/Deerfield Mall - rp12.jpg`,
   },
   "Baseline Scenario RP15": {
    url: `${path}/Deerfield Mall - rp15.jpg`,
   },
   "Baseline Scenario RP17": {
    url: `${path}/Deerfield Mall - rp17.jpg`,
   },
   "Baseline Scenario RP18": {
    url: `${path}/Deerfield Mall - rp18.jpg`,
   },
   "Baseline Scenario RP49": {
    url: `${path}/Deerfield Mall - rp49.jpg`,
   },
   "Baseline Scenario VA3": {
    url: `${path}/Deerfield Mall - va3_c.jpg`,
   },

   "Adaptation Suite AS5 RP3": {
    url: `${path}/Deerfield Mall - AS5_RP3.jpg`,
   },

   "AS5b RP2": {
    url: `${path}/Deerfield Mall - AS5b_RP2.jpg`,
   },
   "Adaptation Suite AS5b RP3": {
    url: `${path}/Deerfield Mall - AS5b_RP3.jpg`,
   },
   "Adaptation Suite AS5b RP4": {
    url: `${path}/Deerfield Mall - AS5b_RP4.jpg`,
   },
   "Adaptation Suite AS5b RP6": {
    url: `${path}/Deerfield Mall - AS5b_RP6.jpg`,
   },
   "Adaptation Suite AS5b RP7": {
    url: `${path}/Deerfield Mall - AS5b_RP7.jpg`,
   },
   "Adaptation Suite AS5b RP8": {
    url: `${path}/Deerfield Mall - AS5b_RP8.jpg`,
   },
   "Adaptation Suite AS5b RP9": {
    url: `${path}/Deerfield Mall - AS5b_RP9.jpg`,
   },
   "Adaptation Suite AS5b RP10": {
    url: `${path}/Deerfield Mall - AS5b_RP10.jpg`,
   },
   "Adaptation Suite AS5b RP11": {
    url: `${path}/Deerfield Mall - AS5b_RP11.jpg`,
   },
   "Adaptation Suite AS5b RP12": {
    url: `${path}/Deerfield Mall - AS5b_RP12.jpg`,
   },
   "Adaptation Suite AS5b RP15": {
    url: `${path}/Deerfield Mall - AS5b_RP15.jpg`,
   },
   "Adaptation Suite AS5b RP16": {
    url: `${path}/Deerfield Mall - AS5b_RP16.jpg`,
   },
   "Adaptation Suite AS5b RP17": {
    url: `${path}/Deerfield Mall - AS5b_RP17.jpg`,
   },
   "Adaptation Suite AS5b RP18": {
    url: `${path}/Deerfield Mall - AS5b_RP18.jpg`,
   },
   "Adaptation Suite AS5b RP30": {
    url: `${path}/Deerfield Mall - AS5b_RP30.jpg`,
   },
   "Adaptation Suite AS5b RP35": {
    url: `${path}/Deerfield Mall - AS5b_RP35.jpg`,
   },
   "Adaptation Suite AS5b RP38": {
    url: `${path}/Deerfield Mall - AS5b_RP38.jpg`,
   },
   "Adaptation Suite AS5b RP42": {
    url: `${path}/Deerfield Mall - AS5b_RP42.jpg`,
   },
   "Adaptation Suite AS5b RP46": {
    url: `${path}/Deerfield Mall - AS5b_RP46.jpg`,
   },
   "Adaptation Suite AS5b RP47": {
    url: `${path}/Deerfield Mall - AS5b_RP47.jpg`,
   },
   "Adaptation Suite AS5b RP49": {
    url: `${path}/Deerfield Mall - AS5b_RP49.jpg`,
   },
  },
  baseline: {
   url: `${path}/Deerfield Mall .jpg`,
  },
 },
 "Parkland Enrichment and Recreation Center 3": {
  scenario: {
   "Baseline Scenario RP2": {
    url: `${path}/Parkland Enrichment and Recreation Center - rp2.jpg`,
   },
   "Baseline Scenario RP3": {
    url: `${path}/Parkland Enrichment and Recreation Center - rp3.jpg`,
   },
   "Baseline Scenario RP4": {
    url: `${path}/Parkland Enrichment and Recreation Center - rp4.jpg`,
   },
   "Baseline Scenario RP6": {
    url: `${path}/Parkland Enrichment and Recreation Center - rp6.jpg`,
   },
   "Baseline Scenario RP7": {
    url: `${path}/Parkland Enrichment and Recreation Center - rp7.jpg`,
   },
   "Baseline Scenario RP8": {
    url: `${path}/Parkland Enrichment and Recreation Center - rp8.jpg`,
   },
   "Baseline Scenario RP9": {
    url: `${path}/Parkland Enrichment and Recreation Center - rp9.jpg`,
   },
   "Baseline Scenario RP10": {
    url: `${path}/Parkland Enrichment and Recreation Center - rp10.jpg`,
   },
   "Baseline Scenario RP11": {
    url: `${path}/Parkland Enrichment and Recreation Center - rp11.jpg`,
   },
   "Baseline Scenario RP12": {
    url: `${path}/Parkland Enrichment and Recreation Center - rp12.jpg`,
   },
   "Baseline Scenario RP13": {
    url: `${path}/Parkland Enrichment and Recreation Center - rp13.jpg`,
   },
   "Baseline Scenario RP15": {
    url: `${path}/Parkland Enrichment and Recreation Center - rp15.jpg`,
   },
   "Baseline Scenario RP16": {
    url: `${path}/Parkland Enrichment and Recreation Center - rp16.jpg`,
   },
   "Baseline Scenario RP17": {
    url: `${path}/Parkland Enrichment and Recreation Center - rp17.jpg`,
   },
   "Baseline Scenario RP18": {
    url: `${path}/Parkland Enrichment and Recreation Center - rp18.jpg`,
   },
   "Baseline Scenario RP30": {
    url: `${path}/Parkland Enrichment and Recreation Center - rp30.jpg`,
   },
   "Baseline Scenario RP35": {
    url: `${path}/Parkland Enrichment and Recreation Center - rp35.jpg`,
   },
   "Baseline Scenario RP38": {
    url: `${path}/Parkland Enrichment and Recreation Center - rp38.jpg`,
   },
   "Baseline Scenario RP42": {
    url: `${path}/Parkland Enrichment and Recreation Center - rp42.jpg`,
   },
   "Baseline Scenario RP46": {
    url: `${path}/Parkland Enrichment and Recreation Center - rp46.jpg`,
   },
   "Baseline Scenario RP47": {
    url: `${path}/Parkland Enrichment and Recreation Center - rp47.jpg`,
   },
   "Baseline Scenario RP49": {
    url: `${path}/Parkland Enrichment and Recreation Center - rp49.jpg`,
   },
   "Baseline Scenario VA1": {
    url: `${path}/Parkland Enrichment and Recreation Center - va1.jpg`,
   },
   "Baseline Scenario VA3": {
    url: `${path}/Parkland Enrichment and Recreation Center - va3.jpg`,
   },

   "Adaptation Suite AS5 RP2": {
    url: `${path}/Parkland Enrichment and Recreation Center - AS5_RP2.jpg`,
   },
   "Adaptation Suite AS5 RP3": {
    url: `${path}/Parkland Enrichment and Recreation Center - AS5_RP3.jpg`,
   },
   "Adaptation Suite AS5 RP4": {
    url: `${path}/Parkland Enrichment and Recreation Center - AS5_RP4.jpg`,
   },
   "Adaptation Suite AS5 RP6": {
    url: `${path}/Parkland Enrichment and Recreation Center - AS5_RP6.jpg`,
   },
   "Adaptation Suite AS5 RP7": {
    url: `${path}/Parkland Enrichment and Recreation Center - AS5_RP7.jpg`,
   },
   "Adaptation Suite AS5 RP8": {
    url: `${path}/Parkland Enrichment and Recreation Center - AS5_RP8.jpg`,
   },
   "Adaptation Suite AS5 RP9": {
    url: `${path}/Parkland Enrichment and Recreation Center - AS5_RP9.jpg`,
   },
   "Adaptation Suite AS5 RP10": {
    url: `${path}/Parkland Enrichment and Recreation Center - AS5_RP10.jpg`,
   },
   "Adaptation Suite AS5 RP11": {
    url: `${path}/Parkland Enrichment and Recreation Center - AS5_RP11.jpg`,
   },
   "Adaptation Suite AS5 RP12": {
    url: `${path}/Parkland Enrichment and Recreation Center - AS5_RP12.jpg`,
   },
   "Adaptation Suite AS5 RP13": {
    url: `${path}/Parkland Enrichment and Recreation Center - AS5_RP13.jpg`,
   },
   "Adaptation Suite AS5 RP15": {
    url: `${path}/Parkland Enrichment and Recreation Center - AS5_RP15.jpg`,
   },
   "Adaptation Suite AS5 RP16": {
    url: `${path}/Parkland Enrichment and Recreation Center - AS5_RP16.jpg`,
   },
   "Adaptation Suite AS5 RP17": {
    url: `${path}/Parkland Enrichment and Recreation Center - AS5_RP17.jpg`,
   },
   " Adaptation Suite AS5 RP18": {
    url: `${path}/Parkland Enrichment and Recreation Center - AS5_RP18.jpg`,
   },
   "Adaptation Suite AS5 RP30": {
    url: `${path}/Parkland Enrichment and Recreation Center - AS5_RP30.jpg`,
   },
   "Adaptation Suite AS5 RP35": {
    url: `${path}/Parkland Enrichment and Recreation Center - AS5_RP35.jpg`,
   },
   "Adaptation Suite AS5 RP38": {
    url: `${path}/Parkland Enrichment and Recreation Center - AS5_RP38.jpg`,
   },
   "Adaptation Suite AS5 RP42": {
    url: `${path}/Parkland Enrichment and Recreation Center - AS5_RP42.jpg`,
   },
   "Adaptation Suite AS5 RP46": {
    url: `${path}/Parkland Enrichment and Recreation Center - AS5_RP46.jpg`,
   },
   "Adaptation Suite AS5 RP47": {
    url: `${path}/Parkland Enrichment and Recreation Center - AS5_RP47.jpg`,
   },
   "Adaptation Suite AS5 RP49": {
    url: `${path}/Parkland Enrichment and Recreation Center - AS5_RP49.jpg`,
   },

   "AS5b RP2": {
    url: `${path}/Parkland Enrichment and Recreation Center - AS5b_RP2.jpg`,
   },
   "Adaptation Suite AS5b RP3": {
    url: `${path}/Parkland Enrichment and Recreation Center - AS5b_RP3.jpg`,
   },
   "Adaptation Suite AS5b RP4": {
    url: `${path}/Parkland Enrichment and Recreation Center - AS5b_RP4.jpg`,
   },
   "Adaptation Suite AS5b RP6": {
    url: `${path}/Parkland Enrichment and Recreation Center - AS5b_RP6.jpg`,
   },
   "Adaptation Suite AS5b RP7": {
    url: `${path}/Parkland Enrichment and Recreation Center - AS5b_RP7.jpg`,
   },
   "Adaptation Suite AS5b RP8": {
    url: `${path}/Parkland Enrichment and Recreation Center - AS5b_RP8.jpg`,
   },
   "Adaptation Suite AS5b RP9": {
    url: `${path}/Parkland Enrichment and Recreation Center - AS5b_RP9.jpg`,
   },
   "Adaptation Suite AS5b RP10": {
    url: `${path}/Parkland Enrichment and Recreation Center - AS5b_RP10.jpg`,
   },
   "Adaptation Suite AS5b RP11": {
    url: `${path}/Parkland Enrichment and Recreation Center - AS5b_RP11.jpg`,
   },
   "Adaptation Suite AS5b RP12": {
    url: `${path}/Parkland Enrichment and Recreation Center - AS5b_RP12.jpg`,
   },
   "Adaptation Suite AS5b RP13": {
    url: `${path}/Parkland Enrichment and Recreation Center - AS5b_RP13.jpg`,
   },
   "Adaptation Suite AS5b RP15": {
    url: `${path}/Parkland Enrichment and Recreation Center - AS5b_RP15.jpg`,
   },
   "Adaptation Suite AS5b RP16": {
    url: `${path}/Parkland Enrichment and Recreation Center - AS5b_RP16.jpg`,
   },
   "Adaptation Suite AS5b RP17": {
    url: `${path}/Parkland Enrichment and Recreation Center - AS5b_RP17.jpg`,
   },
   "Adaptation Suite AS5b RP18": {
    url: `${path}/Parkland Enrichment and Recreation Center - AS5b_RP18.jpg`,
   },
   "Adaptation Suite AS5b RP30": {
    url: `${path}/Parkland Enrichment and Recreation Center - AS5b_RP30.jpg`,
   },
   "Adaptation Suite AS5b RP35": {
    url: `${path}/Parkland Enrichment and Recreation Center - AS5b_RP35.jpg`,
   },
   "Adaptation Suite AS5b RP38": {
    url: `${path}/Parkland Enrichment and Recreation Center - AS5b_RP38.jpg`,
   },
   "Adaptation Suite AS5b RP42": {
    url: `${path}/Parkland Enrichment and Recreation Center - AS5b_RP42.jpg`,
   },
   "Adaptation Suite AS5b RP46": {
    url: `${path}/Parkland Enrichment and Recreation Center - AS5b_RP46.jpg`,
   },
   "Adaptation Suite AS5b RP47": {
    url: `${path}/Parkland Enrichment and Recreation Center - AS5b_RP47.jpg`,
   },
   "Adaptation Suite AS5b RP49": {
    url: `${path}/Parkland Enrichment and Recreation Center - AS5b_RP49.jpg`,
   },
  },
  baseline: {
   url: `${path}/Parkland Enrichment and Recreation Center.jpg`,
  },
 },
 "Coral Springs Performing Arts 5": {
  scenario: {
   "Baseline Scenario RP2": {
    url: `${path}/Coral Springs Performing Arts -rp2_c.jpg`,
   },
   "Baseline Scenario RP3": {
    url: `${path}/Coral Springs Performing Arts -rp3_c.jpg`,
   },
   "Baseline Scenario RP4": {
    url: `${path}/Coral Springs Performing Arts -rp4.jpg`,
   },
   "Baseline Scenario RP6": {
    url: `${path}/Coral Springs Performing Arts -rp6_c.jpg`,
   },
   "Baseline Scenario RP7": {
    url: `${path}/Coral Springs Performing Arts -rp7.jpg`,
   },
   "Baseline Scenario RP8": {
    url: `${path}/Coral Springs Performing Arts -rp8_c.jpg`,
   },
   "Baseline Scenario RP9": {
    url: `${path}/Coral Springs Performing Arts -rp9_c.jpg`,
   },
   "Baseline Scenario RP10": {
    url: `${path}/Coral Springs Performing Arts -rp10.jpg`,
   },
   "Baseline Scenario RP11": {
    url: `${path}/Coral Springs Performing Arts -rp11.jpg`,
   },
   "Baseline Scenario RP12": {
    url: `${path}/Coral Springs Performing Arts -rp12.jpg`,
   },
   "Baseline Scenario RP13": {
    url: `${path}/Coral Springs Performing Arts -rp13.jpg`,
   },
   "Baseline Scenario RP15": {
    url: `${path}/Coral Springs Performing Arts -rp15.jpg`,
   },
   "Baseline Scenario RP16": {
    url: `${path}/Coral Springs Performing Arts -rp16.jpg`,
   },
   "Baseline Scenario RP17": {
    url: `${path}/Coral Springs Performing Arts -rp17.jpg`,
   },
   "Baseline Scenario RP18": {
    url: `${path}/Coral Springs Performing Arts -rp18.jpg`,
   },
   "Baseline Scenario RP30": {
    url: `${path}/Coral Springs Performing Arts -rp30.jpg`,
   },
   "Baseline Scenario RP35": {
    url: `${path}/Coral Springs Performing Arts -rp35.jpg`,
   },
   "Baseline Scenario RP38": {
    url: `${path}/Coral Springs Performing Arts -rp38.jpg`,
   },
   "Baseline Scenario RP42": {
    url: `${path}/Coral Springs Performing Arts -rp42.jpg`,
   },
   "Baseline Scenario RP46": {
    url: `${path}/Coral Springs Performing Arts -rp46.jpg`,
   },
   "Baseline Scenario RP47": {
    url: `${path}/Coral Springs Performing Arts -rp47.jpg`,
   },
   "Baseline Scenario RP49": {
    url: `${path}/Coral Springs Performing Arts -rp49.jpg`,
   },
   "Baseline Scenario VA1": {
    url: `${path}/Coral Springs Performing Arts -va1_c.jpg`,
   },
   "Baseline Scenario VA3": {
    url: `${path}/Coral Springs Performing Arts -va3_c.jpg`,
   },

   "Adaptation Suite AS5 RP2": {
    url: `${path}/Coral Springs Performing Arts - AS5_RP2.jpg`,
   },
   "Adaptation Suite AS5 RP3": {
    url: `${path}/Coral Springs Performing Arts - AS5_RP3.jpg`,
   },
   "Adaptation Suite AS5 RP4": {
    url: `${path}/Coral Springs Performing Arts - AS5_RP4.jpg`,
   },
   "Adaptation Suite AS5 RP6": {
    url: `${path}/Coral Springs Performing Arts - AS5_RP6.jpg`,
   },
   "Adaptation Suite AS5 RP7": {
    url: `${path}/Coral Springs Performing Arts - AS5_RP7.jpg`,
   },
   "Adaptation Suite AS5 RP8": {
    url: `${path}/Coral Springs Performing Arts - AS5_RP8.jpg`,
   },
   "Adaptation Suite AS5 RP9": {
    url: `${path}/Coral Springs Performing Arts - AS5_RP9.jpg`,
   },
   "Adaptation Suite AS5 RP10": {
    url: `${path}/Coral Springs Performing Arts - AS5_RP10.jpg`,
   },
   "Adaptation Suite AS5 RP11": {
    url: `${path}/Coral Springs Performing Arts - AS5_RP11.jpg`,
   },
   "Adaptation Suite AS5 RP12": {
    url: `${path}/Coral Springs Performing Arts - AS5_RP12.jpg`,
   },
   "Adaptation Suite AS5 RP13": {
    url: `${path}/Coral Springs Performing Arts - AS5_RP13.jpg`,
   },
   "Adaptation Suite AS5 RP15": {
    url: `${path}/Coral Springs Performing Arts - AS5_RP15.jpg`,
   },
   "Adaptation Suite AS5 RP16": {
    url: `${path}/Coral Springs Performing Arts - AS5_RP16.jpg`,
   },
   "Adaptation Suite AS5 RP17": {
    url: `${path}/Coral Springs Performing Arts - AS5_RP17.jpg`,
   },
   " Adaptation Suite AS5 RP18": {
    url: `${path}/Coral Springs Performing Arts - AS5_RP18.jpg`,
   },
   "Adaptation Suite AS5 RP42": {
    url: `${path}/Coral Springs Performing Arts - AS5_RP42.jpg`,
   },
   "Adaptation Suite AS5 RP47": {
    url: `${path}/Coral Springs Performing Arts - AS5_RP47.jpg`,
   },
   "Adaptation Suite AS5 RP49": {
    url: `${path}/Coral Springs Performing Arts - AS5_RP49.jpg`,
   },
   "Adaptation Suite AS5 RP30": {
    url: `${path}/Coral Springs Performing Arts -AS5_RP30.jpg`,
   },
   "Adaptation Suite AS5 RP35": {
    url: `${path}/Coral Springs Performing Arts -AS5_RP35.jpg`,
   },
   "Adaptation Suite AS5 RP38": {
    url: `${path}/Coral Springs Performing Arts -AS5_RP38.jpg`,
   },
   "Adaptation Suite AS5 RP46": {
    url: `${path}/Coral Springs Performing Arts -AS5_RP46.jpg`,
   },

   "AS5b RP2": {
    url: `${path}/Coral Springs Performing Arts - AS5b_RP2.jpg`,
   },
   "Adaptation Suite AS5b RP3": {
    url: `${path}/Coral Springs Performing Arts - AS5b_RP3.jpg`,
   },
   "Adaptation Suite AS5b RP4": {
    url: `${path}/Coral Springs Performing Arts - AS5b_RP4.jpg`,
   },
   "Adaptation Suite AS5b RP6": {
    url: `${path}/Coral Springs Performing Arts - AS5b_RP6.jpg`,
   },
   "Adaptation Suite AS5b RP7": {
    url: `${path}/Coral Springs Performing Arts - AS5b_RP7.jpg`,
   },
   "Adaptation Suite AS5b RP8": {
    url: `${path}/Coral Springs Performing Arts - AS5b_RP8.jpg`,
   },
   "Adaptation Suite AS5b RP9": {
    url: `${path}/Coral Springs Performing Arts - AS5b_RP9.jpg`,
   },
   "Adaptation Suite AS5b RP10": {
    url: `${path}/Coral Springs Performing Arts - AS5b_RP10.jpg`,
   },
   "Adaptation Suite AS5b RP11": {
    url: `${path}/Coral Springs Performing Arts - AS5b_RP11.jpg`,
   },
   "Adaptation Suite AS5b RP12": {
    url: `${path}/Coral Springs Performing Arts - AS5b_RP12.jpg`,
   },
   "Adaptation Suite AS5b RP13": {
    url: `${path}/Coral Springs Performing Arts - AS5b_RP13.jpg`,
   },
   "Adaptation Suite AS5b RP15": {
    url: `${path}/Coral Springs Performing Arts - AS5b_RP15.jpg`,
   },
   "Adaptation Suite AS5b RP16": {
    url: `${path}/Coral Springs Performing Arts - AS5b_RP16.jpg`,
   },
   "Adaptation Suite AS5b RP17": {
    url: `${path}/Coral Springs Performing Arts - AS5b_RP17.jpg`,
   },
   "Adaptation Suite AS5b RP18": {
    url: `${path}/Coral Springs Performing Arts - AS5b_RP18.jpg`,
   },
   "Adaptation Suite AS5b RP42": {
    url: `${path}/Coral Springs Performing Arts - AS5b_RP42.jpg`,
   },
   "Adaptation Suite AS5b RP47": {
    url: `${path}/Coral Springs Performing Arts - AS5b_RP47.jpg`,
   },
   "Adaptation Suite AS5b RP49": {
    url: `${path}/Coral Springs Performing Arts - AS5b_RP49.jpg`,
   },
   "Adaptation Suite AS5b RP30": {
    url: `${path}/Coral Springs Performing Arts -AS5b_RP30.jpg`,
   },
   "Adaptation Suite AS5b RP35": {
    url: `${path}/Coral Springs Performing Arts -AS5b_RP35.jpg`,
   },
   "Adaptation Suite AS5b RP38": {
    url: `${path}/Coral Springs Performing Arts -AS5b_RP38.jpg`,
   },
   "Adaptation Suite AS5b RP46": {
    url: `${path}/Coral Springs Performing Arts -AS5b_RP46.jpg`,
   },
  },

  baseline: {
   url: `${path}/Coral Springs Performing Arts.jpg`,
  },
 },
 "Broward College North Campus 4": {
  scenario: {
   "Baseline Scenario RP2": {
    url: `${path}/Broward College_rp2.jpg`,
   },
   "Baseline Scenario RP3": {
    url: `${path}/Broward College_rp3.jpg`,
   },
   "Baseline Scenario RP4": {
    url: `${path}/Broward College_rp4.jpg`,
   },
   "Baseline Scenario RP6": {
    url: `${path}/Broward College_rp6.jpg`,
   },
   "Baseline Scenario RP7": {
    url: `${path}/Broward College_rp7.jpg`,
   },
   "Baseline Scenario RP8": {
    url: `${path}/Broward College_rp8.jpg`,
   },
   "Baseline Scenario RP9": {
    url: `${path}/Broward College_rp9.jpg`,
   },
   "Baseline Scenario RP42": {
    url: `${path}/Broward College_r42.jpg`,
   },
   "Baseline Scenario RP10": {
    url: `${path}/Broward College_rp10.jpg`,
   },
   "Baseline Scenario RP11": {
    url: `${path}/Broward College_rp11.jpg`,
   },
   "Baseline Scenario RP12": {
    url: `${path}/Broward College_rp12.jpg`,
   },
   "Baseline Scenario RP13": {
    url: `${path}/Broward College_rp13.jpg`,
   },
   "Baseline Scenario RP15": {
    url: `${path}/Broward College_rp15.jpg`,
   },
   "Baseline Scenario RP16": {
    url: `${path}/Broward College_rp16.jpg`,
   },
   "Baseline Scenario RP17": {
    url: `${path}/Broward College_rp17.jpg`,
   },
   "Baseline Scenario RP18": {
    url: `${path}/Broward College_rp18.jpg`,
   },
   "Baseline Scenario RP30": {
    url: `${path}/Broward College_rp30.jpg`,
   },
   "Baseline Scenario RP35": {
    url: `${path}/Broward College_rp35.jpg`,
   },
   "Baseline Scenario RP38": {
    url: `${path}/Broward College_rp38.jpg`,
   },
   "Baseline Scenario RP42": {
    url: `${path}/Broward College_rp42.jpg`,
   },
   "Baseline Scenario RP46": {
    url: `${path}/Broward College_rp46.jpg`,
   },
   "Baseline Scenario RP47": {
    url: `${path}/Broward College_rp47.jpg`,
   },
   "Baseline Scenario RP49": {
    url: `${path}/Broward College_rp49.jpg`,
   },
   "Baseline Scenario VA1": {
    url: `${path}/Broward College_va1.jpg`,
   },
   "Baseline Scenario VA3": {
    url: `${path}/Broward College_va3.jpg`,
   },

   "Adaptation Suite AS5 RP2": {
    url: `${path}/Broward College_AS5_RP2.jpg`,
   },
   "Adaptation Suite AS5 RP3": {
    url: `${path}/Broward College_AS5_RP3.jpg`,
   },
   "Adaptation Suite AS5 RP4": {
    url: `${path}/Broward College_AS5_RP4.jpg`,
   },
   "Adaptation Suite AS5 RP6": {
    url: `${path}/Broward College_AS5_RP6.jpg`,
   },
   "Adaptation Suite AS5 RP7": {
    url: `${path}/Broward College_AS5_RP7.jpg`,
   },
   "Adaptation Suite AS5 RP8": {
    url: `${path}/Broward College_AS5_RP8.jpg`,
   },
   "Adaptation Suite AS5 RP9": {
    url: `${path}/Broward College_AS5_RP9.jpg`,
   },
   "Adaptation Suite AS5 RP10": {
    url: `${path}/Broward College_AS5_RP10.jpg`,
   },
   "Adaptation Suite AS5 RP11": {
    url: `${path}/Broward College_AS5_RP11.jpg`,
   },
   "Adaptation Suite AS5 RP12": {
    url: `${path}/Broward College_AS5_RP12.jpg`,
   },
   "Adaptation Suite AS5 RP13": {
    url: `${path}/Broward College_AS5_RP13.jpg`,
   },
   "Adaptation Suite AS5 RP15": {
    url: `${path}/Broward College_AS5_RP15.jpg`,
   },
   "Adaptation Suite AS5 RP16": {
    url: `${path}/Broward College_AS5_RP16.jpg`,
   },
   "Adaptation Suite AS5 RP17": {
    url: `${path}/Broward College_AS5_RP17.jpg`,
   },
   " Adaptation Suite AS5 RP18": {
    url: `${path}/Broward College_AS5_RP18.jpg`,
   },
   "Adaptation Suite AS5 RP42": {
    url: `${path}/Broward College_AS5_RP42.jpg`,
   },
   "Adaptation Suite AS5 RP46": {
    url: `${path}/Broward College_AS5_RP46.jpg`,
   },
   "Adaptation Suite AS5 RP47": {
    url: `${path}/Broward College_AS5_RP47.jpg`,
   },
   "Adaptation Suite AS5 RP49": {
    url: `${path}/Broward College_AS5_RP49.jpg`,
   },

   "AS5b RP2": {
    url: `${path}/Broward College_AS5b_RP2.jpg`,
   },
   "Adaptation Suite AS5b RP3": {
    url: `${path}/Broward College_AS5b_RP3.jpg`,
   },
   "Adaptation Suite AS5b RP4": {
    url: `${path}/Broward College_AS5b_RP4.jpg`,
   },
   "Adaptation Suite AS5b RP6": {
    url: `${path}/Broward College_AS5b_RP6.jpg`,
   },
   "Adaptation Suite AS5b RP7": {
    url: `${path}/Broward College_AS5b_RP7.jpg`,
   },
   "Adaptation Suite AS5b RP8": {
    url: `${path}/Broward College_AS5b_RP8.jpg`,
   },
   "Adaptation Suite AS5b RP9": {
    url: `${path}/Broward College_AS5b_RP9.jpg`,
   },
   "Adaptation Suite AS5b RP10": {
    url: `${path}/Broward College_AS5b_RP10.jpg`,
   },
   "Adaptation Suite AS5b RP11": {
    url: `${path}/Broward College_AS5b_RP11.jpg`,
   },
   "Adaptation Suite AS5b RP12": {
    url: `${path}/Broward College_AS5b_RP12.jpg`,
   },
   "Adaptation Suite AS5b RP13": {
    url: `${path}/Broward College_AS5b_RP13.jpg`,
   },
   "Adaptation Suite AS5b RP15": {
    url: `${path}/Broward College_AS5b_RP15.jpg`,
   },
   "Adaptation Suite AS5b RP16": {
    url: `${path}/Broward College_AS5b_RP16.jpg`,
   },
   "Adaptation Suite AS5b RP17": {
    url: `${path}/Broward College_AS5b_RP17.jpg`,
   },
   "Adaptation Suite AS5b RP18": {
    url: `${path}/Broward College_AS5b_RP18.jpg`,
   },
   "Adaptation Suite AS5b RP42": {
    url: `${path}/Broward College_AS5b_RP42.jpg`,
   },
   "Adaptation Suite AS5b RP46": {
    url: `${path}/Broward College_AS5b_RP46.jpg`,
   },
   "Adaptation Suite AS5b RP47": {
    url: `${path}/Broward College_AS5b_RP47.jpg`,
   },
   "Adaptation Suite AS5b RP49": {
    url: `${path}/Broward College_AS5b_RP49.jpg`,
   },
  },
  baseline: {
   url: `${path}/Broward College - High Resolution.jpg`,
  },
 },
 "Alsdorf Park 1": {
  scenario: {
   "Baseline Scenario RP2": {
    url: `${path}/Alsdorf Park - rp2_c.jpg`,
   },
   "Baseline Scenario RP3": {
    url: `${path}/Alsdorf Park - rp3_c.jpg`,
   },
   "Baseline Scenario RP4": {
    url: `${path}/Alsdorf Park - rp4.jpg`,
   },
   "Baseline Scenario RP6": {
    url: `${path}/Alsdorf Park - rp6.jpg`,
   },
   "Baseline Scenario RP7": {
    url: `${path}/Alsdorf Park - rp7.jpg`,
   },
   "Baseline Scenario RP8": {
    url: `${path}/Alsdorf Park - rp8.jpg`,
   },
   "Baseline Scenario RP9": {
    url: `${path}/Alsdorf Park - rp9.jpg`,
   },
   "Baseline Scenario RP10": {
    url: `${path}/Alsdorf Park - rp10.jpg`,
   },
   "Baseline Scenario RP42": {
    url: `${path}/Alsdorf Park - r42.jpg`,
   },
   "Baseline Scenario RP11": {
    url: `${path}/Alsdorf Park - rp11.jpg`,
   },
   "Baseline Scenario RP12": {
    url: `${path}/Alsdorf Park - rp12.jpg`,
   },
   "Baseline Scenario RP13": {
    url: `${path}/Alsdorf Park - rp13.jpg`,
   },
   "Baseline Scenario RP15": {
    url: `${path}/Alsdorf Park - rp15.jpg`,
   },
   "Baseline Scenario RP16": {
    url: `${path}/Alsdorf Park - rp16.jpg`,
   },
   "Baseline Scenario RP17": {
    url: `${path}/Alsdorf Park - rp17.jpg`,
   },
   "Baseline Scenario RP18": {
    url: `${path}/Alsdorf Park - rp18.jpg`,
   },
   "Baseline Scenario RP30": {
    url: `${path}/Alsdorf Park - rp30.jpg`,
   },
   "Baseline Scenario RP35": {
    url: `${path}/Alsdorf Park - rp35.jpg`,
   },
   "Baseline Scenario RP38": {
    url: `${path}/Alsdorf Park - rp38.jpg`,
   },
   "Baseline Scenario RP46": {
    url: `${path}/Alsdorf Park - rp46.jpg`,
   },
   "Baseline Scenario RP47": {
    url: `${path}/Alsdorf Park - rp47.jpg`,
   },
   "Baseline Scenario RP49": {
    url: `${path}/Alsdorf Park - rp49.jpg`,
   },
   "Baseline Scenario VA1": {
    url: `${path}/Alsdorf Park - va1_c.jpg`,
   },
   "Baseline Scenario VA3": {
    url: `${path}/Alsdorf Park - va3_c.jpg`,
   },

   "Adaptation Suite AS5 RP2": {
    url: `${path}/Alsdorf Park - AS5_RP2.jpg`,
   },
   "Adaptation Suite AS5 RP3": {
    url: `${path}/Alsdorf Park - AS5_RP3.jpg`,
   },
   "Adaptation Suite AS5 RP4": {
    url: `${path}/Alsdorf Park - AS5_RP4.jpg`,
   },
   "Adaptation Suite AS5 RP6": {
    url: `${path}/Alsdorf Park - AS5_RP6.jpg`,
   },
   "Adaptation Suite AS5 RP7": {
    url: `${path}/Alsdorf Park - AS5_RP7.jpg`,
   },
   "Adaptation Suite AS5 RP8": {
    url: `${path}/Alsdorf Park - AS5_RP8.jpg`,
   },
   "Adaptation Suite AS5 RP9": {
    url: `${path}/Alsdorf Park - AS5_RP9.jpg`,
   },
   "Adaptation Suite AS5 RP10": {
    url: `${path}/Alsdorf Park - AS5_RP10.jpg`,
   },
   "Adaptation Suite AS5 RP11": {
    url: `${path}/Alsdorf Park - AS5_RP11.jpg`,
   },
   "Adaptation Suite AS5 RP12": {
    url: `${path}/Alsdorf Park - AS5_RP12.jpg`,
   },
   "Adaptation Suite AS5 RP13": {
    url: `${path}/Alsdorf Park - AS5_RP13.jpg`,
   },
   "Adaptation Suite AS5 RP14": {
    url: `${path}/Alsdorf Park - AS5_RP14.jpg`,
   },
   "Adaptation Suite AS5 RP15": {
    url: `${path}/Alsdorf Park - AS5_RP15.jpg`,
   },
   "Adaptation Suite AS5 RP16": {
    url: `${path}/Alsdorf Park - AS5_RP16.jpg`,
   },
   "Adaptation Suite AS5 RP17": {
    url: `${path}/Alsdorf Park - AS5_RP17.jpg`,
   },
   " Adaptation Suite AS5 RP18": {
    url: `${path}/Alsdorf Park - AS5_RP18.jpg`,
   },
   "Adaptation Suite AS5 RP30": {
    url: `${path}/Alsdorf Park - AS5_rp30.jpg`,
   },
   "Adaptation Suite AS5 RP35": {
    url: `${path}/Alsdorf Park - AS5_rp35.jpg`,
   },
   "Adaptation Suite AS5 RP38": {
    url: `${path}/Alsdorf Park - AS5_rp38.jpg`,
   },
   "Adaptation Suite AS5 RP42": {
    url: `${path}/Alsdorf Park - AS5_rp42.jpg`,
   },
   "Adaptation Suite AS5 RP46": {
    url: `${path}/Alsdorf Park - AS5_rp46.jpg`,
   },
   "Adaptation Suite AS5 RP47": {
    url: `${path}/Alsdorf Park - AS5_rp47.jpg`,
   },
   "Adaptation Suite AS5 RP49": {
    url: `${path}/Alsdorf Park - AS5_RP49.jpg`,
   },

   "Adaptation Suite AS5b RP18": {
    url: `${path}/Alsdorf Park - AS5b_rp18.jpg`,
   },
  },
  baseline: {
   url: `${path}/Alsdorf Park - High Resolution.jpg`,
  },
 },
 "DRV PNK Stadium 2": {
  scenario: {
   "Baseline Scenario RP2": {
    url: `${path}/DRV PNK Stadium - RP2.jpg`,
   },
   "Baseline Scenario RP3": {
    url: `${path}/DRV PNK Stadium - RP3.jpg`,
   },
   "Baseline Scenario RP4": {
    url: `${path}/DRV PNK Stadium - RP4.jpg`,
   },
   "Baseline Scenario RP6": {
    url: `${path}/DRV PNK Stadium - RP6.jpg`,
   },
   "Baseline Scenario RP7": {
    url: `${path}/DRV PNK Stadium - RP7.jpg`,
   },
   "Baseline Scenario RP8": {
    url: `${path}/DRV PNK Stadium - RP8.jpg`,
   },
   "Baseline Scenario RP9": {
    url: `${path}/DRV PNK Stadium - RP9.jpg`,
   },
   "Baseline Scenario RP10": {
    url: `${path}/DRV PNK Stadium - RP10.jpg`,
   },
   "Baseline Scenario RP11": {
    url: `${path}/DRV PNK Stadium - RP11.jpg`,
   },
   "Baseline Scenario RP12": {
    url: `${path}/DRV PNK Stadium - RP12.jpg`,
   },
   "Baseline Scenario RP13": {
    url: `${path}/DRV PNK Stadium - RP13.jpg`,
   },
   "Baseline Scenario RP15": {
    url: `${path}/DRV PNK Stadium - RP15.jpg`,
   },
   "Baseline Scenario RP16": {
    url: `${path}/DRV PNK Stadium - RP16.jpg`,
   },
   "Baseline Scenario RP17": {
    url: `${path}/DRV PNK Stadium - RP17.jpg`,
   },
   "Baseline Scenario RP18": {
    url: `${path}/DRV PNK Stadium - RP18.jpg`,
   },
   "Baseline Scenario RP30": {
    url: `${path}/DRV PNK Stadium - RP30.jpg`,
   },
   "Baseline Scenario RP35": {
    url: `${path}/DRV PNK Stadium - RP35.jpg`,
   },
   "Baseline Scenario RP38": {
    url: `${path}/DRV PNK Stadium - RP38.jpg`,
   },
   "Baseline Scenario RP42": {
    url: `${path}/DRV PNK Stadium - RP42.jpg`,
   },
   "Baseline Scenario RP46": {
    url: `${path}/DRV PNK Stadium - RP46.jpg`,
   },
   "Baseline Scenario RP47": {
    url: `${path}/DRV PNK Stadium - RP47.jpg`,
   },
   "Baseline Scenario RP49": {
    url: `${path}/DRV PNK Stadium - RP49.jpg`,
   },
   "Baseline Scenario VA1": {
    url: `${path}/DRV PNK Stadium - VA1.jpg`,
   },
   "Baseline Scenario VA3": {
    url: `${path}/DRV PNK Stadium - VA3.jpg`,
   },

   "Adaptation Suite AS5 RP2": {
    url: `${path}/DRV PNK Stadium - AS5_RP2.jpg`,
   },
   "Adaptation Suite AS5 RP3": {
    url: `${path}/DRV PNK Stadium - AS5_RP3.jpg`,
   },
   "Adaptation Suite AS5 RP4": {
    url: `${path}/DRV PNK Stadium - AS5_RP4.jpg`,
   },
   "Adaptation Suite AS5 RP6": {
    url: `${path}/DRV PNK Stadium - AS5_RP6.jpg`,
   },
   "Adaptation Suite AS5 RP7": {
    url: `${path}/DRV PNK Stadium - AS5_RP7.jpg`,
   },
   "Adaptation Suite AS5 RP8": {
    url: `${path}/DRV PNK Stadium - AS5_RP8.jpg`,
   },
   "Adaptation Suite AS5 RP9": {
    url: `${path}/DRV PNK Stadium - AS5_RP9.jpg`,
   },
   "Adaptation Suite AS5 RP10": {
    url: `${path}/DRV PNK Stadium - AS5_RP10.jpg`,
   },
   "Adaptation Suite AS5 RP11": {
    url: `${path}/DRV PNK Stadium - AS5_RP11.jpg`,
   },
   "Adaptation Suite AS5 RP12": {
    url: `${path}/DRV PNK Stadium - AS5_RP12.jpg`,
   },
   "Adaptation Suite AS5 RP13": {
    url: `${path}/DRV PNK Stadium - AS5_RP13.jpg`,
   },
   "Adaptation Suite AS5 RP15": {
    url: `${path}/DRV PNK Stadium - AS5_RP15.jpg`,
   },
   "Adaptation Suite AS5 RP16": {
    url: `${path}/DRV PNK Stadium - AS5_RP16.jpg`,
   },
   "Adaptation Suite AS5 RP17": {
    url: `${path}/DRV PNK Stadium - AS5_RP17.jpg`,
   },
   " Adaptation Suite AS5 RP18": {
    url: `${path}/DRV PNK Stadium - AS5_RP18.jpg`,
   },
   "Adaptation Suite AS5 RP30": {
    url: `${path}/DRV PNK Stadium - AS5_RP30.jpg`,
   },
   "Adaptation Suite AS5 RP35": {
    url: `${path}/DRV PNK Stadium - AS5_RP35.jpg`,
   },
   "Adaptation Suite AS5 RP38": {
    url: `${path}/DRV PNK Stadium - AS5_RP38.jpg`,
   },
   "Adaptation Suite AS5 RP42": {
    url: `${path}/DRV PNK Stadium - AS5_RP42.jpg`,
   },
   "Adaptation Suite AS5 RP46": {
    url: `${path}/DRV PNK Stadium - AS5_RP46.jpg`,
   },
   "Adaptation Suite AS5 RP47": {
    url: `${path}/DRV PNK Stadium - AS5_RP47.jpg`,
   },
   "Adaptation Suite AS5 RP49": {
    url: `${path}/DRV PNK Stadium - AS5_RP49.jpg`,
   },

   "AS5b RP2": {
    url: `${path}/DRV PNK Stadium - AS5b_RP2.jpg`,
   },
   "Adaptation Suite AS5b RP3": {
    url: `${path}/DRV PNK Stadium - AS5b_RP3.jpg`,
   },
   "Adaptation Suite AS5b RP4": {
    url: `${path}/DRV PNK Stadium - AS5b_RP4.jpg`,
   },
   "Adaptation Suite AS5b RP6": {
    url: `${path}/DRV PNK Stadium - AS5b_RP6.jpg`,
   },
   "Adaptation Suite AS5b RP7": {
    url: `${path}/DRV PNK Stadium - AS5b_RP7.jpg`,
   },
   "Adaptation Suite AS5b RP8": {
    url: `${path}/DRV PNK Stadium - AS5b_RP8.jpg`,
   },
   "Adaptation Suite AS5b RP9": {
    url: `${path}/DRV PNK Stadium - AS5b_RP9.jpg`,
   },
   "Adaptation Suite AS5b RP10": {
    url: `${path}/DRV PNK Stadium - AS5b_RP10.jpg`,
   },
   "Adaptation Suite AS5b RP11": {
    url: `${path}/DRV PNK Stadium - AS5b_RP11.jpg`,
   },
   "Adaptation Suite AS5b RP12": {
    url: `${path}/DRV PNK Stadium - AS5b_RP12.jpg`,
   },
   "Adaptation Suite AS5b RP13": {
    url: `${path}/DRV PNK Stadium - AS5b_RP13.jpg`,
   },
   "Adaptation Suite AS5b RP15": {
    url: `${path}/DRV PNK Stadium - AS5b_RP15.jpg`,
   },
   "Adaptation Suite AS5b RP16": {
    url: `${path}/DRV PNK Stadium - AS5b_RP16.jpg`,
   },
   "Adaptation Suite AS5b RP17": {
    url: `${path}/DRV PNK Stadium - AS5b_RP17.jpg`,
   },
   "Adaptation Suite AS5b RP18": {
    url: `${path}/DRV PNK Stadium - AS5b_RP18.jpg`,
   },
   "Adaptation Suite AS5b RP30": {
    url: `${path}/DRV PNK Stadium - AS5b_RP30.jpg`,
   },
   "Adaptation Suite AS5b RP35": {
    url: `${path}/DRV PNK Stadium - AS5b_RP35.jpg`,
   },
   "Adaptation Suite AS5b RP38": {
    url: `${path}/DRV PNK Stadium - AS5b_RP38.jpg`,
   },
   "Adaptation Suite AS5b RP42": {
    url: `${path}/DRV PNK Stadium - AS5b_RP42.jpg`,
   },
   "Adaptation Suite AS5b RP46": {
    url: `${path}/DRV PNK Stadium - AS5b_RP46.jpg`,
   },
   "Adaptation Suite AS5b RP47": {
    url: `${path}/DRV PNK Stadium - AS5b_RP47.jpg`,
   },
   "Adaptation Suite AS5b RP49": {
    url: `${path}/DRV PNK Stadium - AS5b_RP49.jpg`,
   },
  },
  baseline: {
   url: `${path}/DRV PNK Stadium - High Resolution.jpg`,
  },
 },
 "Commercial Boulevard 3": {
  scenario: {
   "Baseline Scenario RP2": {
    url: `${path}/Commercial Boulevard - rp2_c.jpg`,
   },
   "Baseline Scenario RP3": {
    url: `${path}/Commercial Boulevard - rp3_c.jpg`,
   },
   "Baseline Scenario RP4": {
    url: `${path}/Commercial Boulevard - rp4.jpg`,
   },
   "Baseline Scenario RP6": {
    url: `${path}/Commercial Boulevard - rp6_c.jpg`,
   },
   "Baseline Scenario RP7": {
    url: `${path}/Commercial Boulevard - rp7.jpg`,
   },
   "Baseline Scenario RP8": {
    url: `${path}/Commercial Boulevard - rp8_c.jpg`,
   },
   "Baseline Scenario RP9": {
    url: `${path}/Commercial Boulevard - rp9_c.jpg`,
   },
   "Baseline Scenario RP10": {
    url: `${path}/Commercial Boulevard - rp10.jpg`,
   },
   "Baseline Scenario RP11": {
    url: `${path}/Commercial Boulevard - rp11.jpg`,
   },
   "Baseline Scenario RP12": {
    url: `${path}/Commercial Boulevard - rp12.jpg`,
   },
   "Baseline Scenario RP13": {
    url: `${path}/Commercial Boulevard - rp13.jpg`,
   },
   "Baseline Scenario RP15": {
    url: `${path}/Commercial Boulevard - rp15.jpg`,
   },
   "Baseline Scenario RP16": {
    url: `${path}/Commercial Boulevard - rp16.jpg`,
   },
   "Baseline Scenario RP17": {
    url: `${path}/Commercial Boulevard - rp17.jpg`,
   },
   "Baseline Scenario RP18": {
    url: `${path}/Commercial Boulevard - rp18.jpg`,
   },
   "Baseline Scenario RP38": {
    url: `${path}/Commercial Boulevard - rp38.jpg`,
   },
   "Baseline Scenario RP42": {
    url: `${path}/Commercial Boulevard - rp42.jpg`,
   },
   "Baseline Scenario RP47": {
    url: `${path}/Commercial Boulevard - rp47.jpg`,
   },
   "Baseline Scenario RP49": {
    url: `${path}/Commercial Boulevard - rp49.jpg`,
   },
   "Baseline Scenario VA3": {
    url: `${path}/Commercial Boulevard - va3_c.jpg`,
   },

   "Adaptation Suite AS5 RP2": {
    url: `${path}/Commercial Boulevard - AS5_RP2.jpg`,
   },
   "Adaptation Suite AS5 RP3": {
    url: `${path}/Commercial Boulevard - AS5_RP3.jpg`,
   },
   "Adaptation Suite AS5 RP4": {
    url: `${path}/Commercial Boulevard -  AS5_RP4.jpg`,
   },
   "Adaptation Suite AS5 RP6": {
    url: `${path}/Commercial Boulevard - AS5_RP6.jpg`,
   },
   "Adaptation Suite AS5 RP7": {
    url: `${path}/Commercial Boulevard -  AS5_RP7.jpg`,
   },
   "Adaptation Suite AS5 RP8": {
    url: `${path}/Commercial Boulevard - AS5_RP8.jpg`,
   },
   "Adaptation Suite AS5 RP9": {
    url: `${path}/Commercial Boulevard - AS5_RP9.jpg`,
   },
   "Adaptation Suite AS5 RP10": {
    url: `${path}/Commercial Boulevard -  AS5_RP10.jpg`,
   },
   "Adaptation Suite AS5 RP11": {
    url: `${path}/Commercial Boulevard - AS5_RP11.jpg`,
   },
   "Adaptation Suite AS5 RP12": {
    url: `${path}/Commercial Boulevard - AS5_RP12.jpg`,
   },
   "Adaptation Suite AS5 RP13": {
    url: `${path}/Commercial Boulevard -  AS5_RP13.jpg`,
   },
   "Adaptation Suite AS5 RP15": {
    url: `${path}/Commercial Boulevard - AS5_RP15.jpg`,
   },
   "Adaptation Suite AS5 RP16": {
    url: `${path}/Commercial Boulevard -  AS5_RP16.jpg`,
   },
   "Adaptation Suite AS5 RP17": {
    url: `${path}/Commercial Boulevard - AS5_RP17.jpg`,
   },
   " Adaptation Suite AS5 RP18": {
    url: `${path}/Commercial Boulevard - AS5_RP18.jpg`,
   },
   "Adaptation Suite AS5 RP35": {
    url: `${path}/Commercial Boulevard - AS5_RP35.jpg`,
   },
   "Adaptation Suite AS5 RP38": {
    url: `${path}/Commercial Boulevard - AS5_RP38.jpg`,
   },
   "Adaptation Suite AS5 RP42": {
    url: `${path}/Commercial Boulevard - AS5_RP42.jpg`,
   },
   "Adaptation Suite AS5 RP46": {
    url: `${path}/Commercial Boulevard - AS5_RP46.jpg`,
   },
   "Adaptation Suite AS5 RP47": {
    url: `${path}/Commercial Boulevard - AS5_RP47.jpg`,
   },
   "Adaptation Suite AS5 RP49": {
    url: `${path}/Commercial Boulevard - AS5_RP49.jpg`,
   },

   "AS5b RP2": {
    url: `${path}/Commercial Boulevard - AS5b_RP2.jpg`,
   },
   "Adaptation Suite AS5b RP3": {
    url: `${path}/Commercial Boulevard - AS5b_RP3.jpg`,
   },
   "Adaptation Suite AS5b RP4": {
    url: `${path}/Commercial Boulevard - AS5b_RP4.jpg`,
   },
   "Adaptation Suite AS5b RP6": {
    url: `${path}/Commercial Boulevard - AS5b_RP6.jpg`,
   },
   "Adaptation Suite AS5b RP7": {
    url: `${path}/Commercial Boulevard - AS5b_RP7.jpg`,
   },
   "Adaptation Suite AS5b RP8": {
    url: `${path}/Commercial Boulevard - AS5b_RP8.jpg`,
   },
   "Adaptation Suite AS5b RP9": {
    url: `${path}/Commercial Boulevard - AS5b_RP9.jpg`,
   },
   "Adaptation Suite AS5b RP10": {
    url: `${path}/Commercial Boulevard - AS5b_RP10.jpg`,
   },
   "Adaptation Suite AS5b RP11": {
    url: `${path}/Commercial Boulevard - AS5b_RP11.jpg`,
   },
   "Adaptation Suite AS5b RP12": {
    url: `${path}/Commercial Boulevard - AS5b_RP12.jpg`,
   },
   "Adaptation Suite AS5b RP13": {
    url: `${path}/Commercial Boulevard - AS5b_RP13.jpg`,
   },
   "Adaptation Suite AS5b RP15": {
    url: `${path}/Commercial Boulevard - AS5b_RP15.jpg`,
   },
   "Adaptation Suite AS5b RP16": {
    url: `${path}/Commercial Boulevard - AS5b_RP16.jpg`,
   },
   "Adaptation Suite AS5b RP17": {
    url: `${path}/Commercial Boulevard - AS5b_RP17.jpg`,
   },
   "Adaptation Suite AS5b RP18": {
    url: `${path}/Commercial Boulevard - AS5b_RP18.jpg`,
   },
   "Adaptation Suite AS5b RP35": {
    url: `${path}/Commercial Boulevard - AS5b_RP35.jpg`,
   },
   "Adaptation Suite AS5b RP38": {
    url: `${path}/Commercial Boulevard - AS5b_RP38.jpg`,
   },
   "Adaptation Suite AS5b RP42": {
    url: `${path}/Commercial Boulevard -  AS5b_RP42.jpg`,
   },
   "Adaptation Suite AS5b RP46": {
    url: `${path}/Commercial Boulevard - AS5b_RP46.jpg`,
   },
   "Adaptation Suite AS5b RP47": {
    url: `${path}/Commercial Boulevard -  AS5b_RP47.jpg`,
   },
   "Adaptation Suite AS5b RP49": {
    url: `${path}/Commercial Boulevard -  AS5b_RP49.jpg`,
   },
  },
  baseline: {
   url: `${path}/Commercial Boulevard.jpg`,
  },
 },
 "Sawgrass Mills Mall 1": {
  scenario: {
   "Baseline Scenario RP3": {
    url: `${path}/Sawgrass Mills Mall - RP3.jpg`,
   },
   "Baseline Scenario RP6": {
    url: `${path}/Sawgrass Mills Mall - RP6.jpg`,
   },
   "Baseline Scenario RP9": {
    url: `${path}/Sawgrass Mills Mall - RP9.jpg`,
   },
   "Baseline Scenario RP12": {
    url: `${path}/Sawgrass Mills Mall - RP12.jpg`,
   },
   "Baseline Scenario RP15": {
    url: `${path}/Sawgrass Mills Mall - RP15.jpg`,
   },
   "Baseline Scenario RP18": {
    url: `${path}/Sawgrass Mills Mall - RP18.jpg`,
   },
   "Baseline Scenario RP49": {
    url: `${path}/Sawgrass Mills Mall - RP49.jpg`,
   },
  },
  baseline: {
   url: `${path}/Sawgrass Mills Mall - High Resolution.jpg`,
  },
 },
 "Swap Shop 2": {
  scenario: {
   "Baseline Scenario RP2": {
    url: `${path}/Swap Shop - RP2.jpg`,
   },
   "Baseline Scenario RP3": {
    url: `${path}/Swap Shop - RP3.jpg`,
   },
   "Baseline Scenario RP4": {
    url: `${path}/Swap Shop - RP4.jpg`,
   },
   "Baseline Scenario RP6": {
    url: `${path}/Swap Shop - RP6.jpg`,
   },
   "Baseline Scenario RP7": {
    url: `${path}/Swap Shop - RP7.jpg`,
   },
   "Baseline Scenario RP8": {
    url: `${path}/Swap Shop - RP8.jpg`,
   },
   "Baseline Scenario RP9": {
    url: `${path}/Swap Shop - RP9.jpg`,
   },
   "Baseline Scenario RP10": {
    url: `${path}/Swap Shop - RP10.jpg`,
   },
   "Baseline Scenario RP11": {
    url: `${path}/Swap Shop - RP11.jpg`,
   },
   "Baseline Scenario RP12": {
    url: `${path}/Swap Shop - RP12.jpg`,
   },
   "Baseline Scenario RP13": {
    url: `${path}/Swap Shop - RP13.jpg`,
   },
   "Baseline Scenario RP15": {
    url: `${path}/Swap Shop - RP15.jpg`,
   },
   "Baseline Scenario RP16": {
    url: `${path}/Swap Shop - RP16.jpg`,
   },
   "Baseline Scenario RP17": {
    url: `${path}/Swap Shop - RP17.jpg`,
   },
   "Baseline Scenario RP18": {
    url: `${path}/Swap Shop - RP18.jpg`,
   },
   "Baseline Scenario RP30": {
    url: `${path}/Swap Shop - RP30.jpg`,
   },
   "Baseline Scenario RP35": {
    url: `${path}/Swap Shop - RP35.jpg`,
   },
   "Baseline Scenario RP38": {
    url: `${path}/Swap Shop - RP38.jpg`,
   },
   "Baseline Scenario RP42": {
    url: `${path}/Swap Shop - RP42.jpg`,
   },
   "Baseline Scenario RP46": {
    url: `${path}/Swap Shop - RP46.jpg`,
   },
   "Baseline Scenario RP47": {
    url: `${path}/Swap Shop - RP47.jpg`,
   },
   "Baseline Scenario RP49": {
    url: `${path}/Swap Shop - RP49.jpg`,
   },
   "Baseline Scenario VA1": {
    url: `${path}/Swap Shop - VA1.jpg`,
   },
   "Baseline Scenario VA3": {
    url: `${path}/Swap Shop - VA3.jpg`,
   },

   "Adaptation Suite AS5 RP2": {
    url: `${path}/Swap Shop - AS5_RP2.jpg`,
   },
   "Adaptation Suite AS5 RP3": {
    url: `${path}/Swap Shop - AS5_RP3.jpg`,
   },
   "Adaptation Suite AS5 RP4": {
    url: `${path}/Swap Shop - AS5_RP4.jpg`,
   },
   "Adaptation Suite AS5 RP6": {
    url: `${path}/Swap Shop - AS5_RP6.jpg`,
   },
   "Adaptation Suite AS5 RP7": {
    url: `${path}/Swap Shop - AS5_RP7.jpg`,
   },
   "Adaptation Suite AS5 RP8": {
    url: `${path}/Swap Shop - AS5_RP8.jpg`,
   },
   "Adaptation Suite AS5 RP9": {
    url: `${path}/Swap Shop - AS5_RP9.jpg`,
   },
   "Adaptation Suite AS5 RP10": {
    url: `${path}/Swap Shop - AS5_RP10.jpg`,
   },
   "Adaptation Suite AS5 RP11": {
    url: `${path}/Swap Shop - AS5_RP11.jpg`,
   },
   "Adaptation Suite AS5 RP12": {
    url: `${path}/Swap Shop - AS5_RP12.jpg`,
   },
   "Adaptation Suite AS5 RP13": {
    url: `${path}/Swap Shop - AS5_RP13.jpg`,
   },
   "Adaptation Suite AS5 RP15": {
    url: `${path}/Swap Shop - AS5_RP15.jpg`,
   },
   "Adaptation Suite AS5 RP16": {
    url: `${path}/Swap Shop - AS5_RP16.jpg`,
   },
   "Adaptation Suite AS5 RP17": {
    url: `${path}/Swap Shop - AS5_RP17.jpg`,
   },
   " Adaptation Suite AS5 RP18": {
    url: `${path}/Swap Shop - AS5_RP18.jpg`,
   },
   "Adaptation Suite AS5 RP30": {
    url: `${path}/Swap Shop - AS5_RP30.jpg`,
   },
   "Adaptation Suite AS5 RP35": {
    url: `${path}/Swap Shop - AS5_RP35.jpg`,
   },
   "Adaptation Suite AS5 RP38": {
    url: `${path}/Swap Shop - AS5_RP38.jpg`,
   },
   "Adaptation Suite AS5 RP42": {
    url: `${path}/Swap Shop - AS5_RP42.jpg`,
   },
   "Adaptation Suite AS5 RP46": {
    url: `${path}/Swap Shop - AS5_RP46.jpg`,
   },
   "Adaptation Suite AS5 RP47": {
    url: `${path}/Swap Shop - AS5_RP47.jpg`,
   },
   "Adaptation Suite AS5 RP49": {
    url: `${path}/Swap Shop - AS5_RP49.jpg`,
   },

   "AS5b RP2": {
    url: `${path}/Swap Shop - AS5b_RP2.jpg`,
   },
   "Adaptation Suite AS5b RP3": {
    url: `${path}/Swap Shop - AS5b_RP3.jpg`,
   },
   "Adaptation Suite AS5b RP4": {
    url: `${path}/Swap Shop - AS5b_RP4.jpg`,
   },
   "Adaptation Suite AS5b RP6": {
    url: `${path}/Swap Shop - AS5b_RP6.jpg`,
   },
   "Adaptation Suite AS5b RP7": {
    url: `${path}/Swap Shop - AS5b_RP7.jpg`,
   },
   "Adaptation Suite AS5b RP8": {
    url: `${path}/Swap Shop - AS5b_RP8.jpg`,
   },
   "Adaptation Suite AS5b RP9": {
    url: `${path}/Swap Shop - AS5b_RP9.jpg`,
   },
   "Adaptation Suite AS5b RP10": {
    url: `${path}/Swap Shop - AS5b_RP10.jpg`,
   },
   "Adaptation Suite AS5b RP11": {
    url: `${path}/Swap Shop - AS5b_RP11.jpg`,
   },
   "Adaptation Suite AS5b RP12": {
    url: `${path}/Swap Shop - AS5b_RP12.jpg`,
   },
   "Adaptation Suite AS5b RP13": {
    url: `${path}/Swap Shop - AS5b_RP13.jpg`,
   },
   "Adaptation Suite AS5b RP15": {
    url: `${path}/Swap Shop - AS5b_RP15.jpg`,
   },
   "Adaptation Suite AS5b RP16": {
    url: `${path}/Swap Shop - AS5b_RP16.jpg`,
   },
   "Adaptation Suite AS5b RP17": {
    url: `${path}/Swap Shop - AS5b_RP17.jpg`,
   },
   "Adaptation Suite AS5b RP18": {
    url: `${path}/Swap Shop - AS5b_RP18.jpg`,
   },
   "Adaptation Suite AS5b RP30": {
    url: `${path}/Swap Shop - AS5b_RP30.jpg`,
   },
   "Adaptation Suite AS5b RP35": {
    url: `${path}/Swap Shop - AS5b_RP35.jpg`,
   },
   "Adaptation Suite AS5b RP38": {
    url: `${path}/Swap Shop - AS5b_RP38.jpg`,
   },
   "Adaptation Suite AS5b RP42": {
    url: `${path}/Swap Shop - AS5b_RP42.jpg`,
   },
   "Adaptation Suite AS5b RP46": {
    url: `${path}/Swap Shop - AS5b_RP46.jpg`,
   },
   "Adaptation Suite AS5b RP47": {
    url: `${path}/Swap Shop - AS5b_RP47.jpg`,
   },
   "Adaptation Suite AS5b RP49": {
    url: `${path}/Swap Shop - AS5b_RP49.jpg`,
   },
  },
  baseline: {
   url: `${path}/Swap Shop - High Resolution.jpg`,
  },
 },
 "Delevoe Park 2": {
  scenario: {
   "Baseline Scenario RP2": {
    url: `${path}/Delevoe Park - rp2_c.jpg`,
   },
   "Baseline Scenario RP3": {
    url: `${path}/Delevoe Park - rp3_c.jpg`,
   },
   "Baseline Scenario RP4": {
    url: `${path}/Delevoe Park - rp4_c.jpg`,
   },
   "Baseline Scenario RP6": {
    url: `${path}/Delevoe Park - rp6_c.jpg`,
   },
   "Baseline Scenario RP7": {
    url: `${path}/Delevoe Park - rp7_c.jpg`,
   },
   "Baseline Scenario RP8": {
    url: `${path}/Delevoe Park - rp8_c.jpg`,
   },
   "Baseline Scenario RP9": {
    url: `${path}/Delevoe Park - rp9_c.jpg`,
   },
   "Baseline Scenario RP10": {
    url: `${path}/Delevoe Park - rp10.jpg`,
   },
   "Baseline Scenario RP11": {
    url: `${path}/Delevoe Park - rp11.jpg`,
   },
   "Baseline Scenario RP12": {
    url: `${path}/Delevoe Park - rp12.jpg`,
   },
   "Baseline Scenario RP13": {
    url: `${path}/Delevoe Park - rp13.jpg`,
   },
   "Baseline Scenario RP15": {
    url: `${path}/Delevoe Park - rp15.jpg`,
   },
   "Baseline Scenario RP16": {
    url: `${path}/Delevoe Park - rp16.jpg`,
   },
   "Baseline Scenario RP17": {
    url: `${path}/Delevoe Park - rp17.jpg`,
   },
   "Baseline Scenario RP18": {
    url: `${path}/Delevoe Park - rp18.jpg`,
   },
   "Baseline Scenario RP38": {
    url: `${path}/Delevoe Park - rp38.jpg`,
   },
   "Baseline Scenario RP42": {
    url: `${path}/Delevoe Park - rp42.jpg`,
   },
   "Baseline Scenario RP46": {
    url: `${path}/Delevoe Park - rp46.jpg`,
   },
   "Baseline Scenario RP47": {
    url: `${path}/Delevoe Park - rp47.jpg`,
   },
   "Baseline Scenario RP49": {
    url: `${path}/Delevoe Park - rp49.jpg`,
   },

   "Adaptation Suite AS5 RP2": {
    url: `${path}/Delevoe Park - AS5_RP2.jpg`,
   },
   "Adaptation Suite AS5 RP3": {
    url: `${path}/Delevoe Park - AS5_RP3.jpg`,
   },
   "Adaptation Suite AS5 RP4": {
    url: `${path}/Delevoe Park - AS5_RP4.jpg`,
   },
   "Adaptation Suite AS5 RP6": {
    url: `${path}/Delevoe Park - AS5_RP6.jpg`,
   },
   "Adaptation Suite AS5 RP7": {
    url: `${path}/Delevoe Park - AS5_RP7.jpg`,
   },
   "Adaptation Suite AS5 RP8": {
    url: `${path}/Delevoe Park - AS5_RP8.jpg`,
   },
   "Adaptation Suite AS5 RP9": {
    url: `${path}/Delevoe Park - AS5_RP9.jpg`,
   },
   "Adaptation Suite AS5 RP10": {
    url: `${path}/Delevoe Park - AS5_RP10.jpg`,
   },
   "Adaptation Suite AS5 RP11": {
    url: `${path}/Delevoe Park - AS5_RP11.jpg`,
   },
   "Adaptation Suite AS5 RP12": {
    url: `${path}/Delevoe Park - AS5_RP12.jpg`,
   },
   "Adaptation Suite AS5 RP13": {
    url: `${path}/Delevoe Park - AS5_RP13.jpg`,
   },
   "Adaptation Suite AS5 RP15": {
    url: `${path}/Delevoe Park - AS5_RP15.jpg`,
   },
   "Adaptation Suite AS5 RP16": {
    url: `${path}/Delevoe Park - AS5_RP16.jpg`,
   },
   "Adaptation Suite AS5 RP17": {
    url: `${path}/Delevoe Park - AS5_RP17.jpg`,
   },
   " Adaptation Suite AS5 RP18": {
    url: `${path}/Delevoe Park - AS5_RP18.jpg`,
   },
   "Adaptation Suite AS5 RP38": {
    url: `${path}/Delevoe Park - AS5_RP38.jpg`,
   },
   "Adaptation Suite AS5 RP42": {
    url: `${path}/Delevoe Park - AS5_RP42.jpg`,
   },
   "Adaptation Suite AS5 RP47": {
    url: `${path}/Delevoe Park - AS5_RP47.jpg`,
   },
   "Adaptation Suite AS5 RP49": {
    url: `${path}/Delevoe Park - AS5_RP49.jpg`,
   },

   "AS5b RP2": {
    url: `${path}/Delevoe Park - AS5b_RP2.jpg`,
   },
   "Adaptation Suite AS5b RP3": {
    url: `${path}/Delevoe Park - AS5b_RP3.jpg`,
   },
   "Adaptation Suite AS5b RP4": {
    url: `${path}/Delevoe Park - AS5b_RP4.jpg`,
   },
   "Adaptation Suite AS5b RP6": {
    url: `${path}/Delevoe Park - AS5b_RP6.jpg`,
   },
   "Adaptation Suite AS5b RP7": {
    url: `${path}/Delevoe Park - AS5b_RP7.jpg`,
   },
   "Adaptation Suite AS5b RP8": {
    url: `${path}/Delevoe Park - AS5b_R8.jpg`,
   },
   "Adaptation Suite AS5b RP9": {
    url: `${path}/Delevoe Park - AS5b_RP9.jpg`,
   },
   "Adaptation Suite AS5b RP10": {
    url: `${path}/Delevoe Park - AS5b_RP10.jpg`,
   },
   "Adaptation Suite AS5b RP11": {
    url: `${path}/Delevoe Park - AS5b_RP11.jpg`,
   },
   "Adaptation Suite AS5b RP12": {
    url: `${path}/Delevoe Park - AS5b_RP12.jpg`,
   },
   "Adaptation Suite AS5b RP13": {
    url: `${path}/Delevoe Park - AS5b_RP13.jpg`,
   },
   "Adaptation Suite AS5b RP15": {
    url: `${path}/Delevoe Park - AS5b_RP15.jpg`,
   },
   "Adaptation Suite AS5b RP16": {
    url: `${path}/Delevoe Park - AS5b_RP16.jpg`,
   },
   "Adaptation Suite AS5b RP17": {
    url: `${path}/Delevoe Park - AS5b_RP17.jpg`,
   },
   "Adaptation Suite AS5b RP18": {
    url: `${path}/Delevoe Park - AS5b_RP18.jpg`,
   },
   "Adaptation Suite AS5b RP49": {
    url: `${path}/Delevoe Park - AS5b_RP49.jpg`,
   },
  },
  baseline: {
   url: `${path}/Delevoe Park.jpg`,
  },
 },
 "Las Olas 1": {
  // ft lauderdale point
  scenario: {
   "Baseline Scenario RP2": {
    url: `${path}/Las Olas - rp2.jpg`,
   },
   "Baseline Scenario RP3": {
    url: `${path}/Las Olas - rp3.jpg`,
   },
   "Baseline Scenario RP4": {
    url: `${path}/Las Olas - rp4.jpg`,
   },
   "Baseline Scenario RP6": {
    url: `${path}/Las Olas - rp6.jpg`,
   },
   "Baseline Scenario RP7": {
    url: `${path}/Las Olas - rp7.jpg`,
   },
   "Baseline Scenario RP8": {
    url: `${path}/Las Olas - rp8.jpg`,
   },
   "Baseline Scenario RP9": {
    url: `${path}/Las Olas - rp9.jpg`,
   },
   "Baseline Scenario RP10": {
    url: `${path}/Las Olas - rp10.jpg`,
   },
   "Baseline Scenario RP11": {
    url: `${path}/Las Olas - rp11.jpg`,
   },
   "Baseline Scenario RP12": {
    url: `${path}/Las Olas - rp12.jpg`,
   },
   "Baseline Scenario RP13": {
    url: `${path}/Las Olas - rp13.jpg`,
   },
   "Baseline Scenario RP15": {
    url: `${path}/Las Olas - rp15.jpg`,
   },
   "Baseline Scenario RP16": {
    url: `${path}/Las Olas - rp16.jpg`,
   },
   "Baseline Scenario RP17": {
    url: `${path}/Las Olas - rp17.jpg`,
   },
   "Baseline Scenario RP18": {
    url: `${path}/Las Olas - rp18.jpg`,
   },
   "Baseline Scenario RP30": {
    url: `${path}/Las Olas - rp30.jpg`,
   },
   "Baseline Scenario RP35": {
    url: `${path}/Las Olas - rp35.jpg`,
   },
   "Baseline Scenario RP38": {
    url: `${path}/Las Olas - rp38.jpg`,
   },
   "Baseline Scenario RP42": {
    url: `${path}/Las Olas - rp42.jpg`,
   },
   "Baseline Scenario RP46": {
    url: `${path}/Las Olas - rp46.jpg`,
   },
   "Baseline Scenario RP47": {
    url: `${path}/Las Olas - rp47.jpg`,
   },
   "Baseline Scenario RP49": {
    url: `${path}/Las Olas - rp49.jpg`,
   },
   "Baseline Scenario VA1": {
    url: `${path}/Las Olas - va1.jpg`,
   },
   "Baseline Scenario VA3": {
    url: `${path}/Las Olas - va3.jpg`,
   },

   "Adaptation Suite AS5 RP2": {
    url: `${path}/Las Olas - AS5_RP2.jpg`,
   },
   "Adaptation Suite AS5 RP3": {
    url: `${path}/Las Olas - AS5_RP3.jpg`,
   },
   "Adaptation Suite AS5 RP4": {
    url: `${path}/Las Olas - AS5_RP4.jpg`,
   },
   "Adaptation Suite AS5 RP6": {
    url: `${path}/Las Olas - AS5_RP6.jpg`,
   },
   "Adaptation Suite AS5 RP7": {
    url: `${path}/Las Olas - AS5_RP7.jpg`,
   },
   "Adaptation Suite AS5 RP8": {
    url: `${path}/Las Olas - AS5_RP8.jpg`,
   },
   "Adaptation Suite AS5 RP9": {
    url: `${path}/Las Olas - AS5_RP9.jpg`,
   },
   "Adaptation Suite AS5 RP10": {
    url: `${path}/Las Olas - AS5_RP10.jpg`,
   },
   "Adaptation Suite AS5 RP11": {
    url: `${path}/Las Olas - AS5_RP11.jpg`,
   },
   "Adaptation Suite AS5 RP12": {
    url: `${path}/Las Olas - AS5_RP12.jpg`,
   },
   "Adaptation Suite AS5 RP13": {
    url: `${path}/Las Olas - AS5_RP13.jpg`,
   },
   "Adaptation Suite AS5 RP15": {
    url: `${path}/Las Olas - AS5_RP15.jpg`,
   },
   "Adaptation Suite AS5 RP16": {
    url: `${path}/Las Olas - AS5_RP16.jpg`,
   },
   "Adaptation Suite AS5 RP17": {
    url: `${path}/Las Olas - AS5_RP17.jpg`,
   },
   " Adaptation Suite AS5 RP18": {
    url: `${path}/Las Olas - AS5_RP18.jpg`,
   },
   "Adaptation Suite AS5 RP30": {
    url: `${path}/Las Olas - AS5_RP30.jpg`,
   },
   "Adaptation Suite AS5 RP35": {
    url: `${path}/Las Olas - AS5_RP35.jpg`,
   },
   "Adaptation Suite AS5 RP38": {
    url: `${path}/Las Olas - AS5_RP38.jpg`,
   },
   "Adaptation Suite AS5 RP42": {
    url: `${path}/Las Olas - AS5_RP42.jpg`,
   },
   "Adaptation Suite AS5 RP46": {
    url: `${path}/Las Olas - AS5_RP46.jpg`,
   },
   "Adaptation Suite AS5 RP47": {
    url: `${path}/Las Olas - AS5_RP47.jpg`,
   },
   "Adaptation Suite AS5 RP49": {
    url: `${path}/Las Olas - AS5_RP49.jpg`,
   },

   "AS5b RP2": {
    url: `${path}/Las Olas - AS5b_RP2.jpg`,
   },
   "Adaptation Suite AS5b RP3": {
    url: `${path}/Las Olas - AS5b_RP3.jpg`,
   },
   "Adaptation Suite AS5b RP4": {
    url: `${path}/Las Olas - AS5b_RP4.jpg`,
   },
   "Adaptation Suite AS5b RP6": {
    url: `${path}/Las Olas - AS5b_RP6.jpg`,
   },
   "Adaptation Suite AS5b RP7": {
    url: `${path}/Las Olas - AS5b_RP7.jpg`,
   },
   "Adaptation Suite AS5b RP8": {
    url: `${path}/Las Olas - AS5b_RP8.jpg`,
   },
   "Adaptation Suite AS5b RP9": {
    url: `${path}/Las Olas - AS5b_RP9.jpg`,
   },
   "Adaptation Suite AS5b RP10": {
    url: `${path}/Las Olas - AS5b_RP10.jpg`,
   },
   "Adaptation Suite AS5b RP11": {
    url: `${path}/Las Olas - AS5b_RP11.jpg`,
   },
   "Adaptation Suite AS5b RP12": {
    url: `${path}/Las Olas - AS5b_RP12.jpg`,
   },
   "Adaptation Suite AS5b RP13": {
    url: `${path}/Las Olas - AS5b_RP13.jpg`,
   },
   "Adaptation Suite AS5b RP15": {
    url: `${path}/Las Olas - AS5b_RP15.jpg`,
   },
   "Adaptation Suite AS5b RP16": {
    url: `${path}/Las Olas - AS5b_RP16.jpg`,
   },
   "Adaptation Suite AS5b RP17": {
    url: `${path}/Las Olas - AS5b_RP17.jpg`,
   },
   "Adaptation Suite AS5b RP18": {
    url: `${path}/Las Olas - AS5b_RP18.jpg`,
   },
   "Adaptation Suite AS5b RP30": {
    url: `${path}/Las Olas - AS5b_RP30.jpg`,
   },
   "Adaptation Suite AS5b RP35": {
    url: `${path}/Las Olas - AS5b_RP35.jpg`,
   },
   "Adaptation Suite AS5b RP38": {
    url: `${path}/Las Olas - AS5b_RP38.jpg`,
   },
   "Adaptation Suite AS5b RP42": {
    url: `${path}/Las Olas - AS5b_RP42.jpg`,
   },
   "Adaptation Suite AS5b RP46": {
    url: `${path}/Las Olas - AS5b_RP46.jpg`,
   },
   "Adaptation Suite AS5b RP47": {
    url: `${path}/Las Olas - AS5b_RP47.jpg`,
   },
   "Adaptation Suite AS5b RP49": {
    url: `${path}/Las Olas - AS5b_RP49.jpg`,
   },
  },
  baseline: {
   url: `${path}/Las Olas - High Resolution.jpg`,
  },
 },
 "Marine Industry 3": {
  scenario: {
   "Baseline Scenario RP2": {
    url: `${path}/Marine Industry - rp2.jpg`,
   },
   "Baseline Scenario RP3": {
    url: `${path}/Marine Industry - rp3.jpg`,
   },
   "Baseline Scenario RP4": {
    url: `${path}/Marine Industry - rp4.jpg`,
   },
   "Baseline Scenario RP6": {
    url: `${path}/Marine Industry - rp6.jpg`,
   },
   "Baseline Scenario RP7": {
    url: `${path}/Marine Industry - rp7.jpg`,
   },
   "Baseline Scenario RP8": {
    url: `${path}/Marine Industry - rp8.jpg`,
   },
   "Baseline Scenario RP9": {
    url: `${path}/Marine Industry - rp9.jpg`,
   },
   "Baseline Scenario RP10": {
    url: `${path}/Marine Industry - rp10.jpg`,
   },
   "Baseline Scenario RP11": {
    url: `${path}/Marine Industry - rp11.jpg`,
   },
   "Baseline Scenario RP12": {
    url: `${path}/Marine Industry - rp12.jpg`,
   },
   "Baseline Scenario RP13": {
    url: `${path}/Marine Industry - rp13.jpg`,
   },
   "Baseline Scenario RP15": {
    url: `${path}/Marine Industry - rp15.jpg`,
   },
   "Baseline Scenario RP17": {
    url: `${path}/Marine Industry - rp17.jpg`,
   },
   "Baseline Scenario RP18": {
    url: `${path}/Marine Industry - rp18.jpg`,
   },
   "Baseline Scenario RP30": {
    url: `${path}/Marine Industry - rp30.jpg`,
   },
   "Baseline Scenario RP35": {
    url: `${path}/Marine Industry - rp35.jpg`,
   },
   "Baseline Scenario RP38": {
    url: `${path}/Marine Industry - rp38.jpg`,
   },
   "Baseline Scenario RP42": {
    url: `${path}/Marine Industry - rp42.jpg`,
   },
   "Baseline Scenario RP46": {
    url: `${path}/Marine Industry - rp46.jpg`,
   },
   "Baseline Scenario RP47": {
    url: `${path}/Marine Industry - rp47.jpg`,
   },
   "Baseline Scenario RP49": {
    url: `${path}/Marine Industry - rp49.jpg`,
   },
   "Baseline Scenario VA1": {
    url: `${path}/Marine Industry - va1.jpg`,
   },
   "Baseline Scenario VA3": {
    url: `${path}/Marine Industry - va3.jpg`,
   },

   "Adaptation Suite AS5 RP2": {
    url: `${path}/Marine Industry - AS5_RP2.jpg`,
   },
   "Adaptation Suite AS5 RP3": {
    url: `${path}/Marine Industry - AS5_RP3.jpg`,
   },
   "Adaptation Suite AS5 RP4": {
    url: `${path}/Marine Industry - AS5_RP4.jpg`,
   },
   "Adaptation Suite AS5 RP6": {
    url: `${path}/Marine Industry - AS5_RP6.jpg`,
   },
   "Adaptation Suite AS5 RP7": {
    url: `${path}/Marine Industry - AS5_RP7.jpg`,
   },
   "Adaptation Suite AS5 RP8": {
    url: `${path}/Marine Industry - AS5_RP8.jpg`,
   },
   "Adaptation Suite AS5 RP9": {
    url: `${path}/Marine Industry - AS5_RP9.jpg`,
   },
   "Adaptation Suite AS5 RP10": {
    url: `${path}/Marine Industry - AS5_RP10.jpg`,
   },
   "Adaptation Suite AS5 RP11": {
    url: `${path}/Marine Industry - AS5_RP11.jpg`,
   },
   "Adaptation Suite AS5 RP12": {
    url: `${path}/Marine Industry - AS5_RP12.jpg`,
   },
   "Adaptation Suite AS5 RP13": {
    url: `${path}/Marine Industry - AS5_RP13.jpg`,
   },
   "Adaptation Suite AS5 RP15": {
    url: `${path}/Marine Industry - AS5_RP15.jpg`,
   },
   "Adaptation Suite AS5 RP16": {
    url: `${path}/Marine Industry - AS5_RP16.jpg`,
   },
   "Adaptation Suite AS5 RP17": {
    url: `${path}/Marine Industry - AS5_RP17.jpg`,
   },
   " Adaptation Suite AS5 RP18": {
    url: `${path}/Marine Industry - AS5_RP18.jpg`,
   },
   "Adaptation Suite AS5 RP30": {
    url: `${path}/Marine Industry - AS5_RP30.jpg`,
   },
   "Adaptation Suite AS5 RP35": {
    url: `${path}/Marine Industry - AS5_RP35.jpg`,
   },
   "Adaptation Suite AS5 RP38": {
    url: `${path}/Marine Industry - AS5_RP38.jpg`,
   },
   "Adaptation Suite AS5 RP42": {
    url: `${path}/Marine Industry - AS5_RP42.jpg`,
   },
   "Adaptation Suite AS5 RP46": {
    url: `${path}/Marine Industry - AS5_RP46.jpg`,
   },
   "Adaptation Suite AS5 RP47": {
    url: `${path}/Marine Industry - AS5_RP47.jpg`,
   },
   "Adaptation Suite AS5 RP49": {
    url: `${path}/Marine Industry - AS5_RP49.jpg`,
   },

   "AS5b RP2": {
    url: `${path}/Marine Industry - AS5b_RP2.jpg`,
   },
   "Adaptation Suite AS5b RP3": {
    url: `${path}/Marine Industry - AS5b_RP3.jpg`,
   },
   "Adaptation Suite AS5b RP4": {
    url: `${path}/Marine Industry - AS5b_RP4.jpg`,
   },
   "Adaptation Suite AS5b RP6": {
    url: `${path}/Marine Industry - AS5b_RP6.jpg`,
   },
   "Adaptation Suite AS5b RP7": {
    url: `${path}/Marine Industry - AS5b_RP7.jpg`,
   },
   "Adaptation Suite AS5b RP8": {
    url: `${path}/Marine Industry - AS5b_RP8.jpg`,
   },
   "Adaptation Suite AS5b RP9": {
    url: `${path}/Marine Industry - AS5b_RP9.jpg`,
   },
   "Adaptation Suite AS5b RP10": {
    url: `${path}/Marine Industry - AS5b_RP10.jpg`,
   },
   "Adaptation Suite AS5b RP11": {
    url: `${path}/Marine Industry - AS5b_RP11.jpg`,
   },
   "Adaptation Suite AS5b RP12": {
    url: `${path}/Marine Industry - AS5b_RP12.jpg`,
   },
   "Adaptation Suite AS5b RP13": {
    url: `${path}/Marine Industry - AS5b_RP13.jpg`,
   },
   "Adaptation Suite AS5b RP15": {
    url: `${path}/Marine Industry - AS5b_RP15.jpg`,
   },
   "Adaptation Suite AS5b RP16": {
    url: `${path}/Marine Industry - AS5b_RP16.jpg`,
   },
   "Adaptation Suite AS5b RP17": {
    url: `${path}/Marine Industry - AS5b_RP17.jpg`,
   },
   "Adaptation Suite AS5b RP18": {
    url: `${path}/Marine Industry - AS5b_RP18.jpg`,
   },
   "Adaptation Suite AS5b RP30": {
    url: `${path}/Marine Industry - AS5b_RP30.jpg`,
   },
   "Adaptation Suite AS5b RP35": {
    url: `${path}/Marine Industry - AS5b_RP35.jpg`,
   },
   "Adaptation Suite AS5b RP38": {
    url: `${path}/Marine Industry - AS5b_RP38.jpg`,
   },
   "Adaptation Suite AS5b RP42": {
    url: `${path}/Marine Industry - AS5b_RP42.jpg`,
   },
   "Adaptation Suite AS5b RP46": {
    url: `${path}/Marine Industry - AS5b_RP46.jpg`,
   },
   "Adaptation Suite AS5b RP47": {
    url: `${path}/Marine Industry - AS5b_RP47.jpg`,
   },
   "Adaptation Suite AS5b RP49": {
    url: `${path}/Marine Industry - AS5b_RP49.jpg`,
   },
  },
  baseline: {
   url: `${path}/Marine Industry.jpg`,
  },
 },
 "Industrial Area 2": {
  scenario: {
   "Baseline Scenario RP2": {
    url: `${path}/Industrial Area - rp2.jpg`,
   },
   "Baseline Scenario RP3": {
    url: `${path}/Industrial Area - rp3.jpg`,
   },
   "Baseline Scenario RP4": {
    url: `${path}/Industrial Area - rp4.jpg`,
   },
   "Baseline Scenario RP6": {
    url: `${path}/Industrial Area - rp6.jpg`,
   },
   "Baseline Scenario RP7": {
    url: `${path}/Industrial Area - rp7.jpg`,
   },
   "Baseline Scenario RP8": {
    url: `${path}/Industrial Area - rp8.jpg`,
   },
   "Baseline Scenario RP9": {
    url: `${path}/Industrial Area - rp9.jpg`,
   },
   "Baseline Scenario RP10": {
    url: `${path}/Industrial Area - rp10.jpg`,
   },
   "Baseline Scenario RP11": {
    url: `${path}/Industrial Area - rp11.jpg`,
   },
   "Baseline Scenario RP12": {
    url: `${path}/Industrial Area - rp12.jpg`,
   },
   "Baseline Scenario RP13": {
    url: `${path}/Industrial Area - rp13.jpg`,
   },
   "Baseline Scenario RP15": {
    url: `${path}/Industrial Area - rp15.jpg`,
   },
   "Baseline Scenario RP16": {
    url: `${path}/Industrial Area - rp16.jpg`,
   },
   "Baseline Scenario RP17": {
    url: `${path}/Industrial Area - rp17.jpg`,
   },
   "Baseline Scenario RP18": {
    url: `${path}/Industrial Area - rp18.jpg`,
   },
   "Baseline Scenario RP30": {
    url: `${path}/Industrial Area - rp30.jpg`,
   },
   "Baseline Scenario RP35": {
    url: `${path}/Industrial Area - rp35.jpg`,
   },
   "Baseline Scenario RP38": {
    url: `${path}/Industrial Area - rp38.jpg`,
   },
   "Baseline Scenario RP42": {
    url: `${path}/Industrial Area - rp42.jpg`,
   },
   "Baseline Scenario RP46": {
    url: `${path}/Industrial Area - rp46.jpg`,
   },
   "Baseline Scenario RP47": {
    url: `${path}/Industrial Area - rp47.jpg`,
   },
   "Baseline Scenario RP49": {
    url: `${path}/Industrial Area - rp49.jpg`,
   },
   "Baseline Scenario VA1": {
    url: `${path}/Industrial Area - va1.jpg`,
   },
   "Baseline Scenario VA3": {
    url: `${path}/Industrial Area - va3.jpg`,
   },

   "Adaptation Suite AS5 RP2": {
    url: `${path}/Industrial Area - AS5_RP2.jpg`,
   },
   "Adaptation Suite AS5 RP3": {
    url: `${path}/Industrial Area - AS5_RP3.jpg`,
   },
   "Adaptation Suite AS5 RP4": {
    url: `${path}/Industrial Area - AS5_RP4.jpg`,
   },
   "Adaptation Suite AS5 RP6": {
    url: `${path}/Industrial Area - AS5_RP6.jpg`,
   },
   "Adaptation Suite AS5 RP7": {
    url: `${path}/Industrial Area - AS5_RP7.jpg`,
   },
   "Adaptation Suite AS5 RP8": {
    url: `${path}/Industrial Area - AS5_RP8.jpg`,
   },
   "Adaptation Suite AS5 RP9": {
    url: `${path}/Industrial Area - AS5_RP9.jpg`,
   },
   "Adaptation Suite AS5 RP10": {
    url: `${path}/Industrial Area - AS5_RP10.jpg`,
   },
   "Adaptation Suite AS5 RP11": {
    url: `${path}/Industrial Area - AS5_RP11.jpg`,
   },
   "Adaptation Suite AS5 RP12": {
    url: `${path}/Industrial Area - AS5_RP12.jpg`,
   },
   "Adaptation Suite AS5 RP13": {
    url: `${path}/Industrial Area - AS5_RP13.jpg`,
   },
   "Adaptation Suite AS5 RP15": {
    url: `${path}/Industrial Area - AS5_RP15.jpg`,
   },
   "Adaptation Suite AS5 RP16": {
    url: `${path}/Industrial Area - AS5_RP16.jpg`,
   },
   "Adaptation Suite AS5 RP17": {
    url: `${path}/Industrial Area - AS5_RP17.jpg`,
   },
   " Adaptation Suite AS5 RP18": {
    url: `${path}/Industrial Area - AS5_RP18.jpg`,
   },
   "Adaptation Suite AS5 RP30": {
    url: `${path}/Industrial Area - AS5_RP30.jpg`,
   },
   "Adaptation Suite AS5 RP35": {
    url: `${path}/Industrial Area - AS5_RP35.jpg`,
   },
   "Adaptation Suite AS5 RP38": {
    url: `${path}/Industrial Area - AS5_RP38.jpg`,
   },
   "Adaptation Suite AS5 RP42": {
    url: `${path}/Industrial Area - AS5_RP42.jpg`,
   },
   "Adaptation Suite AS5 RP46": {
    url: `${path}/Industrial Area - AS5_RP46.jpg`,
   },
   "Adaptation Suite AS5 RP47": {
    url: `${path}/Industrial Area - AS5_RP47.jpg`,
   },
   "Adaptation Suite AS5 RP49": {
    url: `${path}/Industrial Area - AS5_RP49.jpg`,
   },

   "AS5b RP2": {
    url: `${path}/Industrial Area - AS5b_RP2.jpg`,
   },
   "Adaptation Suite AS5b RP3": {
    url: `${path}/Industrial Area - AS5b_RP3.jpg`,
   },
   "Adaptation Suite AS5b RP4": {
    url: `${path}/Industrial Area - AS5b_RP4.jpg`,
   },
   "Adaptation Suite AS5b RP6": {
    url: `${path}/Industrial Area - AS5b_RP6.jpg`,
   },
   "Adaptation Suite AS5b RP7": {
    url: `${path}/Industrial Area - AS5b_RP7.jpg`,
   },
   "Adaptation Suite AS5b RP8": {
    url: `${path}/Industrial Area - AS5b_RP8.jpg`,
   },
   "Adaptation Suite AS5b RP9": {
    url: `${path}/Industrial Area - AS5b_RP9.jpg`,
   },
   "Adaptation Suite AS5b RP10": {
    url: `${path}/Industrial Area - AS5b_RP10.jpg`,
   },
   "Adaptation Suite AS5b RP11": {
    url: `${path}/Industrial Area - AS5b_RP11.jpg`,
   },
   "Adaptation Suite AS5b RP12": {
    url: `${path}/Industrial Area - AS5b_RP12.jpg`,
   },
   "Adaptation Suite AS5b RP13": {
    url: `${path}/Industrial Area - AS5b_RP13.jpg`,
   },
   "Adaptation Suite AS5b RP15": {
    url: `${path}/Industrial Area - AS5b_RP15.jpg`,
   },
   "Adaptation Suite AS5b RP16": {
    url: `${path}/Industrial Area - AS5b_RP16.jpg`,
   },
   "Adaptation Suite AS5b RP17": {
    url: `${path}/Industrial Area - AS5b_RP17.jpg`,
   },
   "Adaptation Suite AS5b RP18": {
    url: `${path}/Industrial Area - AS5b_RP18.jpg`,
   },
   "Adaptation Suite AS5b RP30": {
    url: `${path}/Industrial Area - AS5b_RP30.jpg`,
   },
   "Adaptation Suite AS5b RP35": {
    url: `${path}/Industrial Area - AS5b_RP35.jpg`,
   },
   "Adaptation Suite AS5b RP38": {
    url: `${path}/Industrial Area - AS5b_RP38.jpg`,
   },
   "Adaptation Suite AS5b RP42": {
    url: `${path}/Industrial Area - AS5b_RP42.jpg`,
   },
   "Adaptation Suite AS5b RP46": {
    url: `${path}/Industrial Area - AS5b_RP46.jpg`,
   },
   "Adaptation Suite AS5b RP47": {
    url: `${path}/Industrial Area - AS5b_RP47.jpg`,
   },
   "Adaptation Suite AS5b RP49": {
    url: `${path}/Industrial Area - AS5b_RP49.jpg`,
   },
  },
  baseline: {
   url: `${path}/Industrial Area .jpg`,
  },
 },
 "Perimeter Road 1": {
  // dania beach point
  scenario: {
   "Baseline Scenario RP3": {
    url: `${path}/Perimeter Rd - Scenario_rp3.jpg`,
   },
   "Baseline Scenario RP6": {
    url: `${path}/Perimeter Rd - Scenario_rp6.jpg`,
   },
   "Baseline Scenario RP9": {
    url: `${path}/Perimeter Rd - Scenario_rp9.jpg`,
   },
   "Baseline Scenario RP12": {
    url: `${path}/Perimeter Rd - Scenario_rp12.jpg`,
   },
   "Baseline Scenario RP13": {
    url: `${path}/Perimeter Rd - Scenario_rp13.jpg`,
   },
   "Baseline Scenario RP15": {
    url: `${path}/Perimeter Rd - Scenario_rp15.jpg`,
   },
   "Baseline Scenario RP16": {
    url: `${path}/Perimeter Rd - Scenario_rp16.jpg`,
   },
   "Baseline Scenario RP17": {
    url: `${path}/Perimeter Rd - Scenario_rp17.jpg`,
   },
   "Baseline Scenario RP18": {
    url: `${path}/Perimeter Rd - Scenario_rp18.jpg`,
   },
   "Baseline Scenario RP49": {
    url: `${path}/Perimeter Rd - Scenario_rp49.jpg`,
   },

   "Adaptation Suite AS5 RP13": {
    url: `${path}/Perimeter Rd - AS5_RP13.jpg`,
   },
   "Adaptation Suite AS5 RP15": {
    url: `${path}/Perimeter Rd - AS5_RP15.jpg`,
   },
   "Adaptation Suite AS5 RP16": {
    url: `${path}/Perimeter Rd - AS5_RP16.jpg`,
   },
   "Adaptation Suite AS5 RP17": {
    url: `${path}/Perimeter Rd - AS5_RP17.jpg`,
   },
   "Adaptation Suite AS5 RP18": {
    url: `${path}/Perimeter Rd - AS5_RP18.jpg`,
   },
  },
  baseline: {
   url: `${path}/Perimeter Rd - High Resolution.jpg`,
  },
 },
 "Griffin Road 2": {
  scenario: {
   "Baseline Scenario RP2": {
    url: `${path}/Griffin Road - rp2.jpg`,
   },
   "Baseline Scenario RP3": {
    url: `${path}/Griffin Road - rp3.jpg`,
   },
   "Baseline Scenario RP4": {
    url: `${path}/Griffin Road - rp4.jpg`,
   },
   "Baseline Scenario RP6": {
    url: `${path}/Griffin Road - rp6.jpg`,
   },
   "Baseline Scenario RP7": {
    url: `${path}/Griffin Road - rp7.jpg`,
   },
   "Baseline Scenario RP8": {
    url: `${path}/Griffin Road - rp8.jpg`,
   },
   "Baseline Scenario RP9": {
    url: `${path}/Griffin Road - rp9.jpg`,
   },
   "Baseline Scenario RP10": {
    url: `${path}/Griffin Road - rp10.jpg`,
   },
   "Baseline Scenario RP11": {
    url: `${path}/Griffin Road - rp11.jpg`,
   },
   "Baseline Scenario RP12": {
    url: `${path}/Griffin Road - rp12.jpg`,
   },
   "Baseline Scenario RP13": {
    url: `${path}/Griffin Road - rp13.jpg`,
   },
   "Baseline Scenario RP15": {
    url: `${path}/Griffin Road - rp15.jpg`,
   },
   "Baseline Scenario RP16": {
    url: `${path}/Griffin Road - rp16.jpg`,
   },
   "Baseline Scenario RP17": {
    url: `${path}/Griffin Road - rp17.jpg`,
   },
   "Baseline Scenario RP18": {
    url: `${path}/Griffin Road - rp18.jpg`,
   },
   "Baseline Scenario RP30": {
    url: `${path}/Griffin Road - rp30.jpg`,
   },
   "Baseline Scenario RP35": {
    url: `${path}/Griffin Road - rp35.jpg`,
   },
   "Baseline Scenario RP38": {
    url: `${path}/Griffin Road - rp38.jpg`,
   },
   "Baseline Scenario RP42": {
    url: `${path}/Griffin Road - rp42.jpg`,
   },
   "Baseline Scenario RP46": {
    url: `${path}/Griffin Road - rp46.jpg`,
   },
   "Baseline Scenario RP47": {
    url: `${path}/Griffin Road - rp47.jpg`,
   },
   "Baseline Scenario RP49": {
    url: `${path}/Griffin Road - rp49.jpg`,
   },
   "Baseline Scenario VA1": {
    url: `${path}/Griffin Road - va1.jpg`,
   },
   "Baseline Scenario VA3": {
    url: `${path}/Griffin Road - va3.jpg`,
   },

   "Adaptation Suite AS5 RP2": {
    url: `${path}/Griffin Road - AS5_RP2.jpg`,
   },
   "Adaptation Suite AS5 RP3": {
    url: `${path}/Griffin Road - AS5_RP3.jpg`,
   },
   "Adaptation Suite AS5 RP4": {
    url: `${path}/Griffin Road - AS5_RP4.jpg`,
   },
   "Adaptation Suite AS5 RP6": {
    url: `${path}/Griffin Road - AS5_RP6.jpg`,
   },
   "Adaptation Suite AS5 RP7": {
    url: `${path}/Griffin Road - AS5_RP7.jpg`,
   },
   "Adaptation Suite AS5 RP8": {
    url: `${path}/Griffin Road - AS5_RP8.jpg`,
   },
   "Adaptation Suite AS5 RP9": {
    url: `${path}/Griffin Road - AS5_RP9.jpg`,
   },
   "Adaptation Suite AS5 RP10": {
    url: `${path}/Griffin Road - AS5_RP10.jpg`,
   },
   "Adaptation Suite AS5 RP11": {
    url: `${path}/Griffin Road - AS5_RP11.jpg`,
   },
   "Adaptation Suite AS5 RP12": {
    url: `${path}/Griffin Road - AS5_RP12.jpg`,
   },
   "Adaptation Suite AS5 RP13": {
    url: `${path}/Griffin Road - AS5_RP13.jpg`,
   },
   "Adaptation Suite AS5 RP15": {
    url: `${path}/Griffin Road - AS5_RP15.jpg`,
   },
   "Adaptation Suite AS5 RP16": {
    url: `${path}/Griffin Road - AS5_RP16.jpg`,
   },
   "Adaptation Suite AS5 RP17": {
    url: `${path}/Griffin Road - AS5_RP17.jpg`,
   },
   " Adaptation Suite AS5 RP18": {
    url: `${path}/Griffin Road - AS5_RP18.jpg`,
   },
   "Adaptation Suite AS5 RP30": {
    url: `${path}/Griffin Road - AS5_RP30.jpg`,
   },
   "Adaptation Suite AS5 RP35": {
    url: `${path}/Griffin Road - AS5_RP35.jpg`,
   },
   "Adaptation Suite AS5 RP38": {
    url: `${path}/Griffin Road - AS5_RP38.jpg`,
   },
   "Adaptation Suite AS5 RP42": {
    url: `${path}/Griffin Road - AS5_RP42.jpg`,
   },
   "Adaptation Suite AS5 RP46": {
    url: `${path}/Griffin Road - AS5_RP46.jpg`,
   },
   "Adaptation Suite AS5 RP47": {
    url: `${path}/Griffin Road - AS5_RP47.jpg`,
   },
   "Adaptation Suite AS5 RP49": {
    url: `${path}/Griffin Road - AS5_RP49.jpg`,
   },

   "AS5b RP2": {
    url: `${path}/Griffin Road - AS5b_RP2.jpg`,
   },
   "Adaptation Suite AS5b RP3": {
    url: `${path}/Griffin Road - AS5b_RP3.jpg`,
   },
   "Adaptation Suite AS5b RP4": {
    url: `${path}/Griffin Road - AS5b_RP4.jpg`,
   },
   "Adaptation Suite AS5b RP6": {
    url: `${path}/Griffin Road - AS5b_RP6.jpg`,
   },
   "Adaptation Suite AS5b RP7": {
    url: `${path}/Griffin Road - AS5b_RP7.jpg`,
   },
   "Adaptation Suite AS5b RP8": {
    url: `${path}/Griffin Road - AS5b_RP8.jpg`,
   },
   "Adaptation Suite AS5b RP9": {
    url: `${path}/Griffin Road - AS5b_RP9.jpg`,
   },
   "Adaptation Suite AS5b RP10": {
    url: `${path}/Griffin Road - AS5b_RP10.jpg`,
   },
   "Adaptation Suite AS5b RP11": {
    url: `${path}/Griffin Road - AS5b_RP11.jpg`,
   },
   "Adaptation Suite AS5b RP12": {
    url: `${path}/Griffin Road - AS5b_RP12.jpg`,
   },
   "Adaptation Suite AS5b RP13": {
    url: `${path}/Griffin Road - AS5b_RP13.jpg`,
   },
   "Adaptation Suite AS5b RP15": {
    url: `${path}/Griffin Road - AS5b_RP15.jpg`,
   },
   "Adaptation Suite AS5b RP16": {
    url: `${path}/Griffin Road - AS5b_RP16.jpg`,
   },
   "Adaptation Suite AS5b RP17": {
    url: `${path}/Griffin Road - AS5b_RP17.jpg`,
   },
   "Adaptation Suite AS5b RP18": {
    url: `${path}/Griffin Road - AS5b_RP18.jpg`,
   },
   "Adaptation Suite AS5b RP30": {
    url: `${path}/Griffin Road - AS5b_RP30.jpg`,
   },
   "Adaptation Suite AS5b RP35": {
    url: `${path}/Griffin Road - AS5b_RP35.jpg`,
   },
   "Adaptation Suite AS5b RP38": {
    url: `${path}/Griffin Road - AS5b_RP38.jpg`,
   },
   "Adaptation Suite AS5b RP42": {
    url: `${path}/Griffin Road - AS5b_RP42.jpg`,
   },
   "Adaptation Suite AS5b RP46": {
    url: `${path}/Griffin Road - AS5b_RP46.jpg`,
   },
   "Adaptation Suite AS5b RP47": {
    url: `${path}/Griffin Road - AS5b_RP47.jpg`,
   },
   "Adaptation Suite AS5b RP49": {
    url: `${path}/Griffin Road - AS5b_RP49.jpg`,
   },
  },
  baseline: {
   url: `${path}/Griffin Road.jpg`,
  },
 },
 "Wheelabrator Landfill 2": {
  scenario: {
   "Baseline Scenario RP2": {
    url: `${path}/Wheelabrator Landfill - RP2.jpg`,
   },
   "Baseline Scenario RP3": {
    url: `${path}/Wheelabrator Landfill - RP3.jpg`,
   },
   "Baseline Scenario RP4": {
    url: `${path}/Wheelabrator Landfill - RP4.jpg`,
   },
   "Baseline Scenario RP6": {
    url: `${path}/Wheelabrator Landfill - RP6.jpg`,
   },
   "Baseline Scenario RP7": {
    url: `${path}/Wheelabrator Landfill - RP7.jpg`,
   },
   "Baseline Scenario RP8": {
    url: `${path}/Wheelabrator Landfill - RP8.jpg`,
   },
   "Baseline Scenario RP9": {
    url: `${path}/Wheelabrator Landfill - RP9.jpg`,
   },
   "Baseline Scenario RP10": {
    url: `${path}/Wheelabrator Landfill - RP10.jpg`,
   },
   "Baseline Scenario RP11": {
    url: `${path}/Wheelabrator Landfill - RP11.jpg`,
   },
   "Baseline Scenario RP12": {
    url: `${path}/Wheelabrator Landfill - RP12.jpg`,
   },
   "Baseline Scenario RP13": {
    url: `${path}/Wheelabrator Landfill - RP13.jpg`,
   },
   "Baseline Scenario RP15": {
    url: `${path}/Wheelabrator Landfill - RP15.jpg`,
   },
   "Baseline Scenario RP16": {
    url: `${path}/Wheelabrator Landfill - RP16.jpg`,
   },
   "Baseline Scenario RP17": {
    url: `${path}/Wheelabrator Landfill - RP17.jpg`,
   },
   "Baseline Scenario RP18": {
    url: `${path}/Wheelabrator Landfill - RP18.jpg`,
   },
   "Baseline Scenario RP30": {
    url: `${path}/Wheelabrator Landfill - RP30.jpg`,
   },
   "Baseline Scenario RP35": {
    url: `${path}/Wheelabrator Landfill - RP35.jpg`,
   },
   "Baseline Scenario RP38": {
    url: `${path}/Wheelabrator Landfill - RP38.jpg`,
   },
   "Baseline Scenario RP42": {
    url: `${path}/Wheelabrator Landfill - RP42.jpg`,
   },
   "Baseline Scenario RP46": {
    url: `${path}/Wheelabrator Landfill - RP46.jpg`,
   },
   "Baseline Scenario RP47": {
    url: `${path}/Wheelabrator Landfill - RP47.jpg`,
   },
   "Baseline Scenario RP49": {
    url: `${path}/Wheelabrator Landfill - RP49.jpg`,
   },
   "Baseline Scenario VA1": {
    url: `${path}/Wheelabrator Landfill - VA1.jpg`,
   },
   "Baseline Scenario VA3": {
    url: `${path}/Wheelabrator Landfill - VA3.jpg`,
   },

   "Adaptation Suite AS5 RP2": {
    url: `${path}/Wheelabrator Landfill - AS5_RP2.jpg`,
   },
   "Adaptation Suite AS5 RP3": {
    url: `${path}/Wheelabrator Landfill - AS5_RP3.jpg`,
   },
   "Adaptation Suite AS5 RP4": {
    url: `${path}/Wheelabrator Landfill - AS5_RP4.jpg`,
   },
   "Adaptation Suite AS5 RP6": {
    url: `${path}/Wheelabrator Landfill - AS5_RP6.jpg`,
   },
   "Adaptation Suite AS5 RP7": {
    url: `${path}/Wheelabrator Landfill - AS5_RP7.jpg`,
   },
   "Adaptation Suite AS5 RP8": {
    url: `${path}/Wheelabrator Landfill - AS5_RP8.jpg`,
   },
   "Adaptation Suite AS5 RP9": {
    url: `${path}/Wheelabrator Landfill - AS5_RP9.jpg`,
   },
   "Adaptation Suite AS5 RP10": {
    url: `${path}/Wheelabrator Landfill - AS5_RP10.jpg`,
   },
   "Adaptation Suite AS5 RP11": {
    url: `${path}/Wheelabrator Landfill - AS5_RP11.jpg`,
   },
   "Adaptation Suite AS5 RP12": {
    url: `${path}/Wheelabrator Landfill - AS5_RP12.jpg`,
   },
   "Adaptation Suite AS5 RP13": {
    url: `${path}/Wheelabrator Landfill - AS5_RP13.jpg`,
   },
   "Adaptation Suite AS5 RP15": {
    url: `${path}/Wheelabrator Landfill - AS5_RP15.jpg`,
   },
   "Adaptation Suite AS5 RP16": {
    url: `${path}/Wheelabrator Landfill - AS5_RP16.jpg`,
   },
   "Adaptation Suite AS5 RP17": {
    url: `${path}/Wheelabrator Landfill - AS5_RP17.jpg`,
   },
   " Adaptation Suite AS5 RP18": {
    url: `${path}/Wheelabrator Landfill - AS5_RP18.jpg`,
   },
   "Adaptation Suite AS5 RP30": {
    url: `${path}/Wheelabrator Landfill - AS5_RP30.jpg`,
   },
   "Adaptation Suite AS5 RP35": {
    url: `${path}/Wheelabrator Landfill - AS5_RP35.jpg`,
   },
   "Adaptation Suite AS5 RP38": {
    url: `${path}/Wheelabrator Landfill - AS5_RP38.jpg`,
   },
   "Adaptation Suite AS5 RP42": {
    url: `${path}/Wheelabrator Landfill - AS5_RP42.jpg`,
   },
   "Adaptation Suite AS5 RP46": {
    url: `${path}/Wheelabrator Landfill - AS5_RP46.jpg`,
   },
   "Adaptation Suite AS5 RP47": {
    url: `${path}/Wheelabrator Landfill - AS5_RP47.jpg`,
   },
   "Adaptation Suite AS5 RP49": {
    url: `${path}/Wheelabrator Landfill - AS5_RP49.jpg`,
   },

   "AS5b RP2": {
    url: `${path}/Wheelabrator Landfill - AS5b_RP2.jpg`,
   },
   "Adaptation Suite AS5b RP3": {
    url: `${path}/Wheelabrator Landfill - AS5b_RP3.jpg`,
   },
   "Adaptation Suite AS5b RP4": {
    url: `${path}/Wheelabrator Landfill - AS5b_RP4.jpg`,
   },
   "Adaptation Suite AS5b RP6": {
    url: `${path}/Wheelabrator Landfill - AS5b_RP6.jpg`,
   },
   "Adaptation Suite AS5b RP7": {
    url: `${path}/Wheelabrator Landfill - AS5b_RP7.jpg`,
   },
   "Adaptation Suite AS5b RP8": {
    url: `${path}/Wheelabrator Landfill - AS5b_RP8.jpg`,
   },
   "Adaptation Suite AS5b RP9": {
    url: `${path}/Wheelabrator Landfill - AS5b_RP9.jpg`,
   },
   "Adaptation Suite AS5b RP10": {
    url: `${path}/Wheelabrator Landfill - AS5b_RP10.jpg`,
   },
   "Adaptation Suite AS5b RP11": {
    url: `${path}/Wheelabrator Landfill - AS5b_RP11.jpg`,
   },
   "Adaptation Suite AS5b RP12": {
    url: `${path}/Wheelabrator Landfill - AS5b_RP12.jpg`,
   },
   "Adaptation Suite AS5b RP13": {
    url: `${path}/Wheelabrator Landfill - AS5b_RP13.jpg`,
   },
   "Adaptation Suite AS5b RP15": {
    url: `${path}/Wheelabrator Landfill - AS5b_RP15.jpg`,
   },
   "Adaptation Suite AS5b RP16": {
    url: `${path}/Wheelabrator Landfill - AS5b_RP16.jpg`,
   },
   "Adaptation Suite AS5b RP17": {
    url: `${path}/Wheelabrator Landfill - AS5b_RP17.jpg`,
   },
   "Adaptation Suite AS5b RP18": {
    url: `${path}/Wheelabrator Landfill - AS5b_RP18.jpg`,
   },
   "Adaptation Suite AS5b RP30": {
    url: `${path}/Wheelabrator Landfill - AS5b_RP30.jpg`,
   },
   "Adaptation Suite AS5b RP35": {
    url: `${path}/Wheelabrator Landfill - AS5b_RP35.jpg`,
   },
   "Adaptation Suite AS5b RP38": {
    url: `${path}/Wheelabrator Landfill - AS5b_RP38.jpg`,
   },
   "Adaptation Suite AS5b RP42": {
    url: `${path}/Wheelabrator Landfill - AS5b_RP42.jpg`,
   },
   "Adaptation Suite AS5b RP46": {
    url: `${path}/Wheelabrator Landfill - AS5b_RP46.jpg`,
   },
   "Adaptation Suite AS5b RP47": {
    url: `${path}/Wheelabrator Landfill - AS5b_RP47.jpg`,
   },
   "Adaptation Suite AS5b RP49": {
    url: `${path}/Wheelabrator Landfill - AS5b_RP49.jpg`,
   },
  },
  baseline: {
   url: `${path}/Wheelabrator Landfill - High Resolution.jpg`,
  },
 },
 "Hard Rock 6": {
  scenario: {
   "Baseline Scenario RP2": {
    url: `${path}/Hard Rock - rp2.jpg`,
   },
   "Baseline Scenario RP3": {
    url: `${path}/Hard Rock - rp3.jpg`,
   },
   "Baseline Scenario RP4": {
    url: `${path}/Hard Rock - rp4.jpg`,
   },
   "Baseline Scenario RP6": {
    url: `${path}/Hard Rock - rp6.jpg`,
   },
   "Baseline Scenario RP7": {
    url: `${path}/Hard Rock - rp7.jpg`,
   },
   "Baseline Scenario RP8": {
    url: `${path}/Hard Rock - rp8.jpg`,
   },
   "Baseline Scenario RP9": {
    url: `${path}/Hard Rock - rp9.jpg`,
   },
   "Baseline Scenario RP10": {
    url: `${path}/Hard Rock - rp10.jpg`,
   },
   "Baseline Scenario RP11": {
    url: `${path}/Hard Rock - rp11.jpg`,
   },
   "Baseline Scenario RP12": {
    url: `${path}/Hard Rock - rp12.jpg`,
   },
   "Baseline Scenario RP13": {
    url: `${path}/Hard Rock - rp13.jpg`,
   },
   "Baseline Scenario RP15": {
    url: `${path}/Hard Rock - rp15.jpg`,
   },
   "Baseline Scenario RP16": {
    url: `${path}/Hard Rock - rp16.jpg`,
   },
   "Baseline Scenario RP17": {
    url: `${path}/Hard Rock - rp17.jpg`,
   },
   "Baseline Scenario RP18": {
    url: `${path}/Hard Rock - rp18.jpg`,
   },
   "Baseline Scenario RP30": {
    url: `${path}/Hard Rock - rp30.jpg`,
   },
   "Baseline Scenario RP35": {
    url: `${path}/Hard Rock - rp35.jpg`,
   },
   "Baseline Scenario RP38": {
    url: `${path}/Hard Rock - rp38.jpg`,
   },
   "Baseline Scenario RP42": {
    url: `${path}/Hard Rock - rp42.jpg`,
   },
   "Baseline Scenario RP46": {
    url: `${path}/Hard Rock - rp46.jpg`,
   },
   "Baseline Scenario RP47": {
    url: `${path}/Hard Rock - rp47.jpg`,
   },
   "Baseline Scenario RP49": {
    url: `${path}/Hard Rock - rp49.jpg`,
   },
   "Baseline Scenario VA1": {
    url: `${path}/Hard Rock - va1.jpg`,
   },
   "Baseline Scenario VA3": {
    url: `${path}/Hard Rock - va3.jpg`,
   },

   "Adaptation Suite AS5 RP2": {
    url: `${path}/Hard Rock - AS5_RP2.jpg`,
   },
   "Adaptation Suite AS5 RP3": {
    url: `${path}/Hard Rock - AS5_RP3.jpg`,
   },
   "Adaptation Suite AS5 RP4": {
    url: `${path}/Hard Rock - AS5_RP4.jpg`,
   },
   "Adaptation Suite AS5 RP6": {
    url: `${path}/Hard Rock - AS5_RP6.jpg`,
   },
   "Adaptation Suite AS5 RP7": {
    url: `${path}/Hard Rock - AS5_RP7.jpg`,
   },
   "Adaptation Suite AS5 RP8": {
    url: `${path}/Hard Rock - AS5_RP8.jpg`,
   },
   "Adaptation Suite AS5 RP9": {
    url: `${path}/Hard Rock - AS5_RP9.jpg`,
   },
   "Adaptation Suite AS5 RP10": {
    url: `${path}/Hard Rock - AS5_RP10.jpg`,
   },
   "Adaptation Suite AS5 RP11": {
    url: `${path}/Hard Rock - AS5_RP11.jpg`,
   },
   "Adaptation Suite AS5 RP12": {
    url: `${path}/Hard Rock - AS5_RP12.jpg`,
   },
   "Adaptation Suite AS5 RP13": {
    url: `${path}/Hard Rock - AS5_RP13.jpg`,
   },
   "Adaptation Suite AS5 RP15": {
    url: `${path}/Hard Rock - AS5_RP15.jpg`,
   },
   "Adaptation Suite AS5 RP16": {
    url: `${path}/Hard Rock - AS5_RP16.jpg`,
   },
   "Adaptation Suite AS5 RP17": {
    url: `${path}/Hard Rock - AS5_RP17.jpg`,
   },
   " Adaptation Suite AS5 RP18": {
    url: `${path}/Hard Rock - AS5_RP18.jpg`,
   },
   "Adaptation Suite AS5 RP30": {
    url: `${path}/Hard Rock - AS5_RP30.jpg`,
   },
   "Adaptation Suite AS5 RP35": {
    url: `${path}/Hard Rock - AS5_RP35.jpg`,
   },
   "Adaptation Suite AS5 RP38": {
    url: `${path}/Hard Rock - AS5_RP38.jpg`,
   },
   "Adaptation Suite AS5 RP42": {
    url: `${path}/Hard Rock - AS5_RP42.jpg`,
   },
   "Adaptation Suite AS5 RP46": {
    url: `${path}/Hard Rock - AS5_RP46.jpg`,
   },
   "Adaptation Suite AS5 RP47": {
    url: `${path}/Hard Rock - AS5_RP47.jpg`,
   },
   "Adaptation Suite AS5 RP49": {
    url: `${path}/Hard Rock - AS5_RP49.jpg`,
   },

   "AS5b RP2": {
    url: `${path}/Hard Rock - AS5b_RP2.jpg`,
   },
   "Adaptation Suite AS5b RP3": {
    url: `${path}/Hard Rock - AS5b_RP3.jpg`,
   },
   "Adaptation Suite AS5b RP4": {
    url: `${path}/Hard Rock - AS5b_RP4.jpg`,
   },
   "Adaptation Suite AS5b RP6": {
    url: `${path}/Hard Rock - AS5b_RP6.jpg`,
   },
   "Adaptation Suite AS5b RP7": {
    url: `${path}/Hard Rock - AS5b_RP7.jpg`,
   },
   "Adaptation Suite AS5b RP8": {
    url: `${path}/Hard Rock - AS5b_RP8.jpg`,
   },
   "Adaptation Suite AS5b RP9": {
    url: `${path}/Hard Rock - AS5b_RP9.jpg`,
   },
   "Adaptation Suite AS5b RP10": {
    url: `${path}/Hard Rock - AS5b_RP10.jpg`,
   },
   "Adaptation Suite AS5b RP11": {
    url: `${path}/Hard Rock - AS5b_RP11.jpg`,
   },
   "Adaptation Suite AS5b RP12": {
    url: `${path}/Hard Rock - AS5b_RP12.jpg`,
   },
   "Adaptation Suite AS5b RP13": {
    url: `${path}/Hard Rock - AS5b_RP13.jpg`,
   },
   "Adaptation Suite AS5b RP15": {
    url: `${path}/Hard Rock - AS5b_RP15.jpg`,
   },
   "Adaptation Suite AS5b RP16": {
    url: `${path}/Hard Rock - AS5b_RP16.jpg`,
   },
   "Adaptation Suite AS5b RP17": {
    url: `${path}/Hard Rock - AS5b_RP17.jpg`,
   },
   "Adaptation Suite AS5b RP18": {
    url: `${path}/Hard Rock - AS5b_RP18.jpg`,
   },
   "Adaptation Suite AS5b RP30": {
    url: `${path}/Hard Rock - AS5b_RP30.jpg`,
   },
   "Adaptation Suite AS5b RP35": {
    url: `${path}/Hard Rock - AS5b_RP35.jpg`,
   },
   "Adaptation Suite AS5b RP38": {
    url: `${path}/Hard Rock - AS5b_RP38.jpg`,
   },
   "Adaptation Suite AS5b RP42": {
    url: `${path}/Hard Rock - AS5b_RP42.jpg`,
   },
   "Adaptation Suite AS5b RP46": {
    url: `${path}/Hard Rock - AS5b_RP46.jpg`,
   },
   "Adaptation Suite AS5b RP47": {
    url: `${path}/Hard Rock - AS5b_RP47.jpg`,
   },
   "Adaptation Suite AS5b RP49": {
    url: `${path}/Hard Rock - AS5b_RP49.jpg`,
   },
  },
  baseline: {
   url: `${path}/Hard Rock  .jpg`,
  },
 },
 "Long Key Natural Area 6": {
  scenario: {
   "Baseline Scenario RP2": {
    url: `${path}/Long Key Natural Area - rp2.jpg`,
   },
   "Baseline Scenario RP3": {
    url: `${path}/Long Key Natural Area - rp3.jpg`,
   },
   "Baseline Scenario RP4": {
    url: `${path}/Long Key Natural Area - rp4.jpg`,
   },
   "Baseline Scenario RP6": {
    url: `${path}/Long Key Natural Area - rp6.jpg`,
   },
   "Baseline Scenario RP7": {
    url: `${path}/Long Key Natural Area - rp7.jpg`,
   },
   "Baseline Scenario RP8": {
    url: `${path}/Long Key Natural Area - rp8.jpg`,
   },
   "Baseline Scenario RP9": {
    url: `${path}/Long Key Natural Area - rp9.jpg`,
   },
   "Baseline Scenario RP10": {
    url: `${path}/Long Key Natural Area - rp10.jpg`,
   },
   "Baseline Scenario RP11": {
    url: `${path}/Long Key Natural Area - rp11.jpg`,
   },
   "Baseline Scenario RP12": {
    url: `${path}/Long Key Natural Area - rp12.jpg`,
   },
   "Baseline Scenario RP13": {
    url: `${path}/Long Key Natural Area - rp13.jpg`,
   },
   "Baseline Scenario RP15": {
    url: `${path}/Long Key Natural Area - rp15.jpg`,
   },
   "Baseline Scenario RP16": {
    url: `${path}/Long Key Natural Area - rp16.jpg`,
   },
   "Baseline Scenario RP17": {
    url: `${path}/Long Key Natural Area - rp17.jpg`,
   },
   "Baseline Scenario RP18": {
    url: `${path}/Long Key Natural Area - rp18.jpg`,
   },
   "Baseline Scenario RP30": {
    url: `${path}/Long Key Natural Area - rp30.jpg`,
   },
   "Baseline Scenario RP35": {
    url: `${path}/Long Key Natural Area - rp35.jpg`,
   },
   "Baseline Scenario RP38": {
    url: `${path}/Long Key Natural Area - rp38.jpg`,
   },
   "Baseline Scenario RP42": {
    url: `${path}/Long Key Natural Area - rp42.jpg`,
   },
   "Baseline Scenario RP46": {
    url: `${path}/Long Key Natural Area - rp46.jpg`,
   },
   "Baseline Scenario RP47": {
    url: `${path}/Long Key Natural Area - rp47.jpg`,
   },
   "Baseline Scenario RP49": {
    url: `${path}/Long Key Natural Area - rp49.jpg`,
   },
   "Baseline Scenario VA1": {
    url: `${path}/Long Key Natural Area - va1.jpg`,
   },
   "Baseline Scenario VA3": {
    url: `${path}/Long Key Natural Area - va3.jpg`,
   },

   "Adaptation Suite AS5 RP2": {
    url: `${path}/Long Key Natural Area - AS5_RP2.jpg`,
   },
   "Adaptation Suite AS5 RP3": {
    url: `${path}/Long Key Natural Area - AS5_RP3.jpg`,
   },
   "Adaptation Suite AS5 RP4": {
    url: `${path}/Long Key Natural Area - AS5_RP4.jpg`,
   },
   "Adaptation Suite AS5 RP6": {
    url: `${path}/Long Key Natural Area - AS5_RP6.jpg`,
   },
   "Adaptation Suite AS5 RP7": {
    url: `${path}/Long Key Natural Area - AS5_RP7.jpg`,
   },
   "Adaptation Suite AS5 RP8": {
    url: `${path}/Long Key Natural Area - AS5_RP8.jpg`,
   },
   "Adaptation Suite AS5 RP9": {
    url: `${path}/Long Key Natural Area - AS5_RP9.jpg`,
   },
   "Adaptation Suite AS5 RP10": {
    url: `${path}/Long Key Natural Area - AS5_RP10.jpg`,
   },
   "Adaptation Suite AS5 RP11": {
    url: `${path}/Long Key Natural Area - AS5_RP11.jpg`,
   },
   "Adaptation Suite AS5 RP12": {
    url: `${path}/Long Key Natural Area - AS5_RP12.jpg`,
   },
   "Adaptation Suite AS5 RP13": {
    url: `${path}/Long Key Natural Area - AS5_RP13.jpg`,
   },
   "Adaptation Suite AS5 RP15": {
    url: `${path}/Long Key Natural Area - AS5_RP15.jpg`,
   },
   "Adaptation Suite AS5 RP16": {
    url: `${path}/Long Key Natural Area - AS5_RP16.jpg`,
   },
   "Adaptation Suite AS5 RP17": {
    url: `${path}/Long Key Natural Area - AS5_RP17.jpg`,
   },
   " Adaptation Suite AS5 RP18": {
    url: `${path}/Long Key Natural Area - AS5_RP18.jpg`,
   },
   "Adaptation Suite AS5 RP30": {
    url: `${path}/Long Key Natural Area - AS5_RP30.jpg`,
   },
   "Adaptation Suite AS5 RP35": {
    url: `${path}/Long Key Natural Area - AS5_RP35.jpg`,
   },
   "Adaptation Suite AS5 RP38": {
    url: `${path}/Long Key Natural Area - AS5_RP38.jpg`,
   },
   "Adaptation Suite AS5 RP42": {
    url: `${path}/Long Key Natural Area - AS5_RP42.jpg`,
   },
   "Adaptation Suite AS5 RP46": {
    url: `${path}/Long Key Natural Area - AS5_RP46.jpg`,
   },
   "Adaptation Suite AS5 RP47": {
    url: `${path}/Long Key Natural Area - AS5_RP47.jpg`,
   },
   "Adaptation Suite AS5 RP49": {
    url: `${path}/Long Key Natural Area - AS5_RP49.jpg`,
   },

   "Adaptation Suite AS5b RP10": {
    url: `${path}/Long Key Natural Area - AS5b_RP10.jpg`,
   },
   "Adaptation Suite AS5b RP11": {
    url: `${path}/Long Key Natural Area - AS5b_RP11.jpg`,
   },
   "Adaptation Suite AS5b RP12": {
    url: `${path}/Long Key Natural Area - AS5b_RP12.jpg`,
   },
   "Adaptation Suite AS5b RP13": {
    url: `${path}/Long Key Natural Area - AS5b_RP13.jpg`,
   },
   "Adaptation Suite AS5b RP15": {
    url: `${path}/Long Key Natural Area - AS5b_RP15.jpg`,
   },
   "Adaptation Suite AS5b RP16": {
    url: `${path}/Long Key Natural Area - AS5b_RP16.jpg`,
   },
   "Adaptation Suite AS5b RP17": {
    url: `${path}/Long Key Natural Area - AS5b_RP17.jpg`,
   },
   "Adaptation Suite AS5b RP49": {
    url: `${path}/Long Key Natural Area - AS5b_RP49.jpg`,
   },
  },
  baseline: {
   url: `${path}/Long Key Natural Area - High Resolution.jpg`,
  },
 },
 "Weston Town Center 3": {
  scenario: {
   "Baseline Scenario RP2": {
    url: `${path}/Weston Town Center - RP2.jpg`,
   },
   "Baseline Scenario RP3": {
    url: `${path}/Weston Town Center - RP3.jpg`,
   },
   "Baseline Scenario RP4": {
    url: `${path}/Weston Town Center - RP4.jpg`,
   },
   "Baseline Scenario RP6": {
    url: `${path}/Weston Town Center - RP6.jpg`,
   },
   "Baseline Scenario RP7": {
    url: `${path}/Weston Town Center - RP7.jpg`,
   },
   "Baseline Scenario RP8": {
    url: `${path}/Weston Town Center - RP8.jpg`,
   },
   "Baseline Scenario RP9": {
    url: `${path}/Weston Town Center - RP9.jpg`,
   },
   "Baseline Scenario RP10": {
    url: `${path}/Weston Town Center - RP10.jpg`,
   },
   "Baseline Scenario RP11": {
    url: `${path}/Weston Town Center - RP11.jpg`,
   },
   "Baseline Scenario RP12": {
    url: `${path}/Weston Town Center - RP12.jpg`,
   },
   "Baseline Scenario RP13": {
    url: `${path}/Weston Town Center - RP13.jpg`,
   },
   "Baseline Scenario RP15": {
    url: `${path}/Weston Town Center - RP15.jpg`,
   },
   "Baseline Scenario RP16": {
    url: `${path}/Weston Town Center - RP16.jpg`,
   },
   "Baseline Scenario RP17": {
    url: `${path}/Weston Town Center - RP17.jpg`,
   },
   "Baseline Scenario RP18": {
    url: `${path}/Weston Town Center - RP18.jpg`,
   },
   "Baseline Scenario RP42": {
    url: `${path}/Weston Town Center - RP42.jpg`,
   },
   "Baseline Scenario RP47": {
    url: `${path}/Weston Town Center - RP47.jpg`,
   },
   "Baseline Scenario RP49": {
    url: `${path}/Weston Town Center - RP49.jpg`,
   },
   "Baseline Scenario VA3": {
    url: `${path}/Weston Town Center - VA3.jpg`,
   },

   "Adaptation Suite AS5 RP2": {
    url: `${path}/Weston Town Center - AS5_RP2.jpg`,
   },
   "Adaptation Suite AS5 RP3": {
    url: `${path}/Weston Town Center - AS5_RP3.jpg`,
   },
   "Adaptation Suite AS5 RP4": {
    url: `${path}/Weston Town Center - AS5_RP4.jpg`,
   },
   "Adaptation Suite AS5 RP6": {
    url: `${path}/Weston Town Center - AS5_RP6.jpg`,
   },
   "Adaptation Suite AS5 RP7": {
    url: `${path}/Weston Town Center - AS5_RP7.jpg`,
   },
   "Adaptation Suite AS5 RP8": {
    url: `${path}/Weston Town Center - AS5_RP8.jpg`,
   },
   "Adaptation Suite AS5 RP9": {
    url: `${path}/Weston Town Center - AS5_RP9.jpg`,
   },
   "Adaptation Suite AS5 RP10": {
    url: `${path}/Weston Town Center - AS5_RP10.jpg`,
   },
   "Adaptation Suite AS5 RP11": {
    url: `${path}/Weston Town Center - AS5_RP11.jpg`,
   },
   "Adaptation Suite AS5 RP12": {
    url: `${path}/Weston Town Center - AS5_RP12.jpg`,
   },
   "Adaptation Suite AS5 RP13": {
    url: `${path}/Weston Town Center - AS5_RP13.jpg`,
   },
   "Adaptation Suite AS5 RP15": {
    url: `${path}/Weston Town Center - AS5_RP15.jpg`,
   },
   "Adaptation Suite AS5 RP16": {
    url: `${path}/Weston Town Center - AS5_RP16.jpg`,
   },
   "Adaptation Suite AS5 RP17": {
    url: `${path}/Weston Town Center - AS5_RP17.jpg`,
   },
   " Adaptation Suite AS5 RP18": {
    url: `${path}/Weston Town Center - AS5_RP18.jpg`,
   },
   "Adaptation Suite AS5 RP42": {
    url: `${path}/Weston Town Center - AS5_RP42.jpg`,
   },
   "Adaptation Suite AS5 RP47": {
    url: `${path}/Weston Town Center - AS5_RP47.jpg`,
   },
   "Adaptation Suite AS5 RP49": {
    url: `${path}/Weston Town Center - AS5_RP49.jpg`,
   },

   "AS5b RP2": {
    url: `${path}/Weston Town Center - AS5b_RP2.jpg`,
   },
   "Adaptation Suite AS5b RP3": {
    url: `${path}/Weston Town Center - AS5b_RP3.jpg`,
   },
   "Adaptation Suite AS5b RP4": {
    url: `${path}/Weston Town Center - AS5b_RP4.jpg`,
   },
   "Adaptation Suite AS5b RP6": {
    url: `${path}/Weston Town Center - AS5b_RP6.jpg`,
   },
   "Adaptation Suite AS5b RP7": {
    url: `${path}/Weston Town Center - AS5b_RP7.jpg`,
   },
   "Adaptation Suite AS5b RP8": {
    url: `${path}/Weston Town Center - AS5b_RP8.jpg`,
   },
   "Adaptation Suite AS5b RP9": {
    url: `${path}/Weston Town Center - AS5b_RP9.jpg`,
   },
   "Adaptation Suite AS5b RP10": {
    url: `${path}/Weston Town Center - AS5b_RP10.jpg`,
   },
   "Adaptation Suite AS5b RP11": {
    url: `${path}/Weston Town Center - AS5b_RP11.jpg`,
   },
   "Adaptation Suite AS5b RP12": {
    url: `${path}/Weston Town Center - AS5b_RP12.jpg`,
   },
   "Adaptation Suite AS5b RP13": {
    url: `${path}/Weston Town Center - AS5b_RP13.jpg`,
   },
   "Adaptation Suite AS5b RP15": {
    url: `${path}/Weston Town Center - AS5b_RP15.jpg`,
   },
   "Adaptation Suite AS5b RP16": {
    url: `${path}/Weston Town Center - AS5b_RP16.jpg`,
   },
   "Adaptation Suite AS5b RP17": {
    url: `${path}/Weston Town Center - AS5b_RP17.jpg`,
   },
   "Adaptation Suite AS5b RP18": {
    url: `${path}/Weston Town Center - AS5b_RP18.jpg`,
   },
   "Adaptation Suite AS5b RP42": {
    url: `${path}/Weston Town Center - AS5b_RP42.jpg`,
   },
   "Adaptation Suite AS5b RP47": {
    url: `${path}/Weston Town Center - AS5b_RP47.jpg`,
   },
   "Adaptation Suite AS5b RP49": {
    url: `${path}/Weston Town Center - AS5b_RP49.jpg`,
   },
  },
  baseline: {
   url: `${path}/Weston Town Center - High Resolution.jpg`,
  },
 },
 "Memorial Regional Hospital 2": {
  scenario: {
   "Baseline Scenario RP2": {
    url: `${path}/Memorial Regional Hospital - rp2.jpg`,
   },
   "Baseline Scenario RP3": {
    url: `${path}/Memorial Regional Hospital - rp3.jpg`,
   },
   "Baseline Scenario RP4": {
    url: `${path}/Memorial Regional Hospital - rp4.jpg`,
   },
   "Baseline Scenario RP6": {
    url: `${path}/Memorial Regional Hospital - rp6.jpg`,
   },
   "Baseline Scenario RP7": {
    url: `${path}/Memorial Regional Hospital - rp7.jpg`,
   },
   "Baseline Scenario RP8": {
    url: `${path}/Memorial Regional Hospital - rp8.jpg`,
   },
   "Baseline Scenario RP9": {
    url: `${path}/Memorial Regional Hospital - rp9.jpg`,
   },
   "Baseline Scenario RP10": {
    url: `${path}/Memorial Regional Hospital - rp10.jpg`,
   },
   "Baseline Scenario RP11": {
    url: `${path}/Memorial Regional Hospital - rp11.jpg`,
   },
   "Baseline Scenario RP12": {
    url: `${path}/Memorial Regional Hospital - rp12.jpg`,
   },
   "Baseline Scenario RP13": {
    url: `${path}/Memorial Regional Hospital - rp13.jpg`,
   },
   "Baseline Scenario RP15": {
    url: `${path}/Memorial Regional Hospital - rp15.jpg`,
   },
   "Baseline Scenario RP17": {
    url: `${path}/Memorial Regional Hospital - rp17.jpg`,
   },
   "Baseline Scenario RP18": {
    url: `${path}/Memorial Regional Hospital - rp18.jpg`,
   },
   "Baseline Scenario RP30": {
    url: `${path}/Memorial Regional Hospital - rp30.jpg`,
   },
   "Baseline Scenario RP35": {
    url: `${path}/Memorial Regional Hospital - rp35.jpg`,
   },
   "Baseline Scenario RP38": {
    url: `${path}/Memorial Regional Hospital - rp38.jpg`,
   },
   "Baseline Scenario RP42": {
    url: `${path}/Memorial Regional Hospital - rp42.jpg`,
   },
   "Baseline Scenario RP46": {
    url: `${path}/Memorial Regional Hospital - rp46.jpg`,
   },
   "Baseline Scenario RP47": {
    url: `${path}/Memorial Regional Hospital - rp47.jpg`,
   },
   "Baseline Scenario RP49": {
    url: `${path}/Memorial Regional Hospital - rp49.jpg`,
   },
   "Baseline Scenario VA1": {
    url: `${path}/Memorial Regional Hospital - va1.jpg`,
   },
   "Baseline Scenario VA3": {
    url: `${path}/Memorial Regional Hospital - va3.jpg`,
   },

   "Adaptation Suite AS5 RP2": {
    url: `${path}/Memorial Regional Hospital - AS5_RP2.jpg`,
   },
   "Adaptation Suite AS5 RP3": {
    url: `${path}/Memorial Regional Hospital - AS5_RP3.jpg`,
   },
   "Adaptation Suite AS5 RP4": {
    url: `${path}/Memorial Regional Hospital - AS5_RP4.jpg`,
   },
   "Adaptation Suite AS5 RP6": {
    url: `${path}/Memorial Regional Hospital - AS5_RP6.jpg`,
   },
   "Adaptation Suite AS5 RP7": {
    url: `${path}/Memorial Regional Hospital - AS5_RP7.jpg`,
   },
   "Adaptation Suite AS5 RP8": {
    url: `${path}/Memorial Regional Hospital - AS5_RP8.jpg`,
   },
   "Adaptation Suite AS5 RP9": {
    url: `${path}/Memorial Regional Hospital - AS5_RP9.jpg`,
   },
   "Adaptation Suite AS5 RP10": {
    url: `${path}/Memorial Regional Hospital - AS5_RP10.jpg`,
   },
   "Adaptation Suite AS5 RP11": {
    url: `${path}/Memorial Regional Hospital - AS5_RP11.jpg`,
   },
   "Adaptation Suite AS5 RP12": {
    url: `${path}/Memorial Regional Hospital - AS5_RP12.jpg`,
   },
   "Adaptation Suite AS5 RP13": {
    url: `${path}/Memorial Regional Hospital - AS5_RP13.jpg`,
   },
   "Adaptation Suite AS5 RP15": {
    url: `${path}/Memorial Regional Hospital - AS5_RP15.jpg`,
   },
   "Adaptation Suite AS5 RP16": {
    url: `${path}/Memorial Regional Hospital - AS5_RP16.jpg`,
   },
   "Adaptation Suite AS5 RP17": {
    url: `${path}/Memorial Regional Hospital - AS5_RP17.jpg`,
   },
   " Adaptation Suite AS5 RP18": {
    url: `${path}/Memorial Regional Hospital - AS5_RP18.jpg`,
   },
   "Adaptation Suite AS5 RP30": {
    url: `${path}/Memorial Regional Hospital - AS5_RP30.jpg`,
   },
   "Adaptation Suite AS5 RP35": {
    url: `${path}/Memorial Regional Hospital - AS5_RP35.jpg`,
   },
   "Adaptation Suite AS5 RP38": {
    url: `${path}/Memorial Regional Hospital - AS5_RP38.jpg`,
   },
   "Adaptation Suite AS5 RP42": {
    url: `${path}/Memorial Regional Hospital - AS5_RP42.jpg`,
   },
   "Adaptation Suite AS5 RP46": {
    url: `${path}/Memorial Regional Hospital - AS5_RP46.jpg`,
   },
   "Adaptation Suite AS5 RP47": {
    url: `${path}/Memorial Regional Hospital - AS5_RP47.jpg`,
   },
   "Adaptation Suite AS5 RP49": {
    url: `${path}/Memorial Regional Hospital - AS5_RP49.jpg`,
   },

   "AS5b RP2": {
    url: `${path}/Memorial Regional Hospital - AS5b_RP2.jpg`,
   },
   "Adaptation Suite AS5b RP3": {
    url: `${path}/Memorial Regional Hospital - AS5b_RP3.jpg`,
   },
   "Adaptation Suite AS5b RP4": {
    url: `${path}/Memorial Regional Hospital - AS5b_RP4.jpg`,
   },
   "Adaptation Suite AS5b RP6": {
    url: `${path}/Memorial Regional Hospital - AS5b_RP6.jpg`,
   },
   "Adaptation Suite AS5b RP7": {
    url: `${path}/Memorial Regional Hospital - AS5b_RP7.jpg`,
   },
   "Adaptation Suite AS5b RP8": {
    url: `${path}/Memorial Regional Hospital - AS5b_RP8.jpg`,
   },
   "Adaptation Suite AS5b RP9": {
    url: `${path}/Memorial Regional Hospital - AS5b_RP9.jpg`,
   },
   "Adaptation Suite AS5b RP10": {
    url: `${path}/Memorial Regional Hospital - AS5b_RP10.jpg`,
   },
   "Adaptation Suite AS5b RP11": {
    url: `${path}/Memorial Regional Hospital - AS5b_RP11.jpg`,
   },
   "Adaptation Suite AS5b RP12": {
    url: `${path}/Memorial Regional Hospital - AS5b_RP12.jpg`,
   },
   "Adaptation Suite AS5b RP13": {
    url: `${path}/Memorial Regional Hospital - AS5b_RP13.jpg`,
   },
   "Adaptation Suite AS5b RP15": {
    url: `${path}/Memorial Regional Hospital - AS5b_RP15.jpg`,
   },
   "Adaptation Suite AS5b RP16": {
    url: `${path}/Memorial Regional Hospital - AS5b_RP16.jpg`,
   },
   "Adaptation Suite AS5b RP17": {
    url: `${path}/Memorial Regional Hospital - AS5b_RP17.jpg`,
   },
   "Adaptation Suite AS5b RP18": {
    url: `${path}/Memorial Regional Hospital - AS5b_RP18.jpg`,
   },
   "Adaptation Suite AS5b RP30": {
    url: `${path}/Memorial Regional Hospital - AS5b_RP30.jpg`,
   },
   "Adaptation Suite AS5b RP35": {
    url: `${path}/Memorial Regional Hospital - AS5b_RP35.jpg`,
   },
   "Adaptation Suite AS5b RP38": {
    url: `${path}/Memorial Regional Hospital - AS5b_RP38.jpg`,
   },
   "Adaptation Suite AS5b RP42": {
    url: `${path}/Memorial Regional Hospital - AS5b_RP42.jpg`,
   },
   "Adaptation Suite AS5b RP46": {
    url: `${path}/Memorial Regional Hospital - AS5b_RP46.jpg`,
   },
   "Adaptation Suite AS5b RP47": {
    url: `${path}/Memorial Regional Hospital - AS5b_RP47.jpg`,
   },
   "Adaptation Suite AS5b RP49": {
    url: `${path}/Memorial Regional Hospital - AS5b_RP49.jpg`,
   },
  },
  baseline: {
   url: `${path}/Memorial Regional Hospital .jpg`,
  },
 },
 "Young Circle 1": {
  scenario: {
   "Baseline Scenario RP2": {
    url: `${path}/Young Circle - RP2.jpg`,
   },
   "Baseline Scenario RP3": {
    url: `${path}/Young Circle - RP3.jpg`,
   },
   "Baseline Scenario RP4": {
    url: `${path}/Young Circle - RP4.jpg`,
   },
   "Baseline Scenario RP6": {
    url: `${path}/Young Circle - RP6.jpg`,
   },
   "Baseline Scenario RP7": {
    url: `${path}/Young Circle - RP7.jpg`,
   },
   "Baseline Scenario RP8": {
    url: `${path}/Young Circle - RP8.jpg`,
   },
   "Baseline Scenario RP9": {
    url: `${path}/Young Circle - RP9.jpg`,
   },
   "Baseline Scenario RP10": {
    url: `${path}/Young Circle - RP10.jpg`,
   },
   "Baseline Scenario RP11": {
    url: `${path}/Young Circle - RP11.jpg`,
   },
   "Baseline Scenario RP12": {
    url: `${path}/Young Circle - RP12.jpg`,
   },
   "Baseline Scenario RP13": {
    url: `${path}/Young Circle - RP13.jpg`,
   },
   "Baseline Scenario RP15": {
    url: `${path}/Young Circle - RP15.jpg`,
   },
   "Baseline Scenario RP16": {
    url: `${path}/Young Circle - RP16.jpg`,
   },
   "Baseline Scenario RP17": {
    url: `${path}/Young Circle - RP17.jpg`,
   },
   "Baseline Scenario RP18": {
    url: `${path}/Young Circle - RP18.jpg`,
   },
   "Baseline Scenario RP30": {
    url: `${path}/Young Circle - RP30.jpg`,
   },
   "Baseline Scenario RP35": {
    url: `${path}/Young Circle - RP35.jpg`,
   },
   "Baseline Scenario RP38": {
    url: `${path}/Young Circle - RP38.jpg`,
   },
   "Baseline Scenario RP42": {
    url: `${path}/Young Circle - RP42.jpg`,
   },
   "Baseline Scenario RP46": {
    url: `${path}/Young Circle - RP46.jpg`,
   },
   "Baseline Scenario RP47": {
    url: `${path}/Young Circle - RP47.jpg`,
   },
   "Baseline Scenario RP49": {
    url: `${path}/Young Circle - RP49.jpg`,
   },
   "Baseline Scenario VA1": {
    url: `${path}/Young Circle - VA1.jpg`,
   },
   "Baseline Scenario VA3": {
    url: `${path}/Young Circle - VA3.jpg`,
   },

   "Adaptation Suite AS5 RP2": {
    url: `${path}/Young Circle - AS5_RP2.jpg`,
   },
   "Adaptation Suite AS5 RP3": {
    url: `${path}/Young Circle - AS5_RP3.jpg`,
   },
   "Adaptation Suite AS5 RP4": {
    url: `${path}/Young Circle - AS5_RP4.jpg`,
   },
   "Adaptation Suite AS5 RP6": {
    url: `${path}/Young Circle - AS5_RP6.jpg`,
   },
   "Adaptation Suite AS5 RP7": {
    url: `${path}/Young Circle - AS5_RP7.jpg`,
   },
   "Adaptation Suite AS5 RP8": {
    url: `${path}/Young Circle - AS5_RP8.jpg`,
   },
   "Adaptation Suite AS5 RP9": {
    url: `${path}/Young Circle - AS5_RP9.jpg`,
   },
   "Adaptation Suite AS5 RP10": {
    url: `${path}/Young Circle - AS5_RP10.jpg`,
   },
   "Adaptation Suite AS5 RP11": {
    url: `${path}/Young Circle - AS5_RP11.jpg`,
   },
   "Adaptation Suite AS5 RP12": {
    url: `${path}/Young Circle - AS5_RP12.jpg`,
   },
   "Adaptation Suite AS5 RP13": {
    url: `${path}/Young Circle - AS5_RP13.jpg`,
   },
   "Adaptation Suite AS5 RP15": {
    url: `${path}/Young Circle - AS5_RP15.jpg`,
   },
   "Adaptation Suite AS5 RP16": {
    url: `${path}/Young Circle - AS5_RP16.jpg`,
   },
   "Adaptation Suite AS5 RP17": {
    url: `${path}/Young Circle - AS5_RP17.jpg`,
   },
   " Adaptation Suite AS5 RP18": {
    url: `${path}/Young Circle - AS5_RP18.jpg`,
   },
   "Adaptation Suite AS5 RP30": {
    url: `${path}/Young Circle - AS5_RP30.jpg`,
   },
   "Adaptation Suite AS5 RP35": {
    url: `${path}/Young Circle - AS5_RP35.jpg`,
   },
   "Adaptation Suite AS5 RP38": {
    url: `${path}/Young Circle - AS5_RP38.jpg`,
   },
   "Adaptation Suite AS5 RP42": {
    url: `${path}/Young Circle - AS5_RP42.jpg`,
   },
   "Adaptation Suite AS5 RP46": {
    url: `${path}/Young Circle - AS5_RP46.jpg`,
   },
   "Adaptation Suite AS5 RP47": {
    url: `${path}/Young Circle - AS5_RP47.jpg`,
   },
   "Adaptation Suite AS5 RP49": {
    url: `${path}/Young Circle - AS5_RP49.jpg`,
   },

   "AS5b RP2": {
    url: `${path}/Young Circle - AS5b_RP2.jpg`,
   },
   "Adaptation Suite AS5b RP3": {
    url: `${path}/Young Circle - AS5b_RP3.jpg`,
   },
   "Adaptation Suite AS5b RP4": {
    url: `${path}/Young Circle - AS5b_RP4.jpg`,
   },
   "Adaptation Suite AS5b RP6": {
    url: `${path}/Young Circle - AS5b_RP6.jpg`,
   },
   "Adaptation Suite AS5b RP7": {
    url: `${path}/Young Circle - AS5b_RP7.jpg`,
   },
   "Adaptation Suite AS5b RP8": {
    url: `${path}/Young Circle - AS5b_RP8.jpg`,
   },
   "Adaptation Suite AS5b RP9": {
    url: `${path}/Young Circle - AS5b_RP9.jpg`,
   },
   "Adaptation Suite AS5b RP10": {
    url: `${path}/Young Circle - AS5b_RP10.jpg`,
   },
   "Adaptation Suite AS5b RP11": {
    url: `${path}/Young Circle - AS5b_RP11.jpg`,
   },
   "Adaptation Suite AS5b RP12": {
    url: `${path}/Young Circle - AS5b_RP12.jpg`,
   },
   "Adaptation Suite AS5b RP13": {
    url: `${path}/Young Circle - AS5b_RP13.jpg`,
   },
   "Adaptation Suite AS5b RP15": {
    url: `${path}/Young Circle - AS5b_RP15.jpg`,
   },
   "Adaptation Suite AS5b RP16": {
    url: `${path}/Young Circle - AS5b_RP16.jpg`,
   },
   "Adaptation Suite AS5b RP17": {
    url: `${path}/Young Circle - AS5b_RP17.jpg`,
   },
   "Adaptation Suite AS5b RP18": {
    url: `${path}/Young Circle - AS5b_RP18.jpg`,
   },
   "Adaptation Suite AS5b RP30": {
    url: `${path}/Young Circle - AS5b_RP30.jpg`,
   },
   "Adaptation Suite AS5b RP35": {
    url: `${path}/Young Circle - AS5b_RP35.jpg`,
   },
   "Adaptation Suite AS5b RP38": {
    url: `${path}/Young Circle - AS5b_RP38.jpg`,
   },
   "Adaptation Suite AS5b RP42": {
    url: `${path}/Young Circle - AS5b_RP42.jpg`,
   },
   "Adaptation Suite AS5b RP46": {
    url: `${path}/Young Circle - AS5b_RP46.jpg`,
   },
   "Adaptation Suite AS5b RP47": {
    url: `${path}/Young Circle - AS5b_RP47.jpg`,
   },
   "Adaptation Suite AS5b RP49": {
    url: `${path}/Young Circle - AS5b_RP49.jpg`,
   },
  },
  baseline: {
   url: `${path}/Young Circle - High Resolution.jpg`,
  },
 },
 "North Lakes 3": {
  scenario: {
   "Baseline Scenario RP2": {
    url: `${path}/North Lakes - rp2.jpg`,
   },
   "Baseline Scenario RP3": {
    url: `${path}/North Lakes - rp3.jpg`,
   },
   "Baseline Scenario RP4": {
    url: `${path}/North Lakes - rp4.jpg`,
   },
   "Baseline Scenario RP6": {
    url: `${path}/North Lakes - rp6.jpg`,
   },
   "Baseline Scenario RP7": {
    url: `${path}/North Lakes - rp7.jpg`,
   },
   "Baseline Scenario RP8": {
    url: `${path}/North Lakes - rp8.jpg`,
   },
   "Baseline Scenario RP9": {
    url: `${path}/North Lakes - rp9.jpg`,
   },
   "Baseline Scenario RP10": {
    url: `${path}/North Lakes - rp10.jpg`,
   },
   "Baseline Scenario RP11": {
    url: `${path}/North Lakes - rp11.jpg`,
   },
   "Baseline Scenario RP12": {
    url: `${path}/North Lakes - rp12.jpg`,
   },
   "Baseline Scenario RP13": {
    url: `${path}/North Lakes - rp13.jpg`,
   },
   "Baseline Scenario RP15": {
    url: `${path}/North Lakes - rp15.jpg`,
   },
   "Baseline Scenario RP16": {
    url: `${path}/North Lakes - rp16.jpg`,
   },
   "Baseline Scenario RP17": {
    url: `${path}/North Lakes - rp17.jpg`,
   },
   "Baseline Scenario RP18": {
    url: `${path}/North Lakes - rp18.jpg`,
   },
   //  "Baseline Scenario RP30": {
   //   url: `${path}/North Lakes.jpg`,
   //  },
   "Baseline Scenario RP35": {
    url: `${path}/North Lakes - rp35.jpg`,
   },
   "Baseline Scenario RP38": {
    url: `${path}/North Lakes - rp38.jpg`,
   },
   "Baseline Scenario RP42": {
    url: `${path}/North Lakes - rp42.jpg`,
   },
   "Baseline Scenario RP46": {
    url: `${path}/North Lakes - rp46.jpg`,
   },
   "Baseline Scenario RP47": {
    url: `${path}/North Lakes - rp47.jpg`,
   },
   "Baseline Scenario RP49": {
    url: `${path}/North Lakes - rp49.jpg`,
   },

   "Adaptation Suite AS5 RP2": {
    url: `${path}/North Lakes - AS5_RP2.jpg`,
   },
   "Adaptation Suite AS5 RP3": {
    url: `${path}/North Lakes - AS5_RP3.jpg`,
   },
   "Adaptation Suite AS5 RP4": {
    url: `${path}/North Lakes - AS5_RP4.jpg`,
   },
   "Adaptation Suite AS5 RP6": {
    url: `${path}/North Lakes - AS5_RP6.jpg`,
   },
   "Adaptation Suite AS5 RP7": {
    url: `${path}/North Lakes - AS5_RP7.jpg`,
   },
   "Adaptation Suite AS5 RP8": {
    url: `${path}/North Lakes - AS5_RP8.jpg`,
   },
   "Adaptation Suite AS5 RP9": {
    url: `${path}/North Lakes - AS5_RP9.jpg`,
   },
   "Adaptation Suite AS5 RP10": {
    url: `${path}/North Lakes - AS5_RP10.jpg`,
   },
   "Adaptation Suite AS5 RP11": {
    url: `${path}/North Lakes - AS5_RP11.jpg`,
   },
   "Adaptation Suite AS5 RP12": {
    url: `${path}/North Lakes - AS5_RP12.jpg`,
   },
   "Adaptation Suite AS5 RP13": {
    url: `${path}/North Lakes - AS5_RP13.jpg`,
   },
   "Adaptation Suite AS5 RP15": {
    url: `${path}/North Lakes - AS5_RP15.jpg`,
   },
   "Adaptation Suite AS5 RP16": {
    url: `${path}/North Lakes - AS5_RP16.jpg`,
   },
   "Adaptation Suite AS5 RP17": {
    url: `${path}/North Lakes - AS5_RP17.jpg`,
   },
   " Adaptation Suite AS5 RP18": {
    url: `${path}/North Lakes - AS5_RP18.jpg`,
   },
   "Adaptation Suite AS5 RP38": {
    url: `${path}/North Lakes - AS5_RP38.jpg`,
   },
   "Adaptation Suite AS5 RP49": {
    url: `${path}/North Lakes - AS5_RP49.jpg`,
   },

   "AS5b RP2": {
    url: `${path}/North Lakes - AS5b_RP2.jpg`,
   },
   "Adaptation Suite AS5b RP3": {
    url: `${path}/North Lakes - AS5b_RP3.jpg`,
   },
   "Adaptation Suite AS5b RP4": {
    url: `${path}/North Lakes - AS5b_RP4.jpg`,
   },
   "Adaptation Suite AS5b RP6": {
    url: `${path}/North Lakes - AS5b_RP6.jpg`,
   },
   "Adaptation Suite AS5b RP7": {
    url: `${path}/North Lakes - AS5b_RP7.jpg`,
   },
   "Adaptation Suite AS5b RP8": {
    url: `${path}/North Lakes - AS5b_RP8.jpg`,
   },
   "Adaptation Suite AS5b RP9": {
    url: `${path}/North Lakes - AS5b_RP9.jpg`,
   },
   "Adaptation Suite AS5b RP10": {
    url: `${path}/North Lakes - AS5b_RP10.jpg`,
   },
   "Adaptation Suite AS5b RP11": {
    url: `${path}/North Lakes - AS5b_RP11.jpg`,
   },
   "Adaptation Suite AS5b RP12": {
    url: `${path}/North Lakes - AS5b_RP12.jpg`,
   },
   "Adaptation Suite AS5b RP13": {
    url: `${path}/North Lakes - AS5b_RP13.jpg`,
   },
   "Adaptation Suite AS5b RP15": {
    url: `${path}/North Lakes - AS5b_RP15.jpg`,
   },
   "Adaptation Suite AS5b RP16": {
    url: `${path}/North Lakes - AS5b_RP16.jpg`,
   },
   "Adaptation Suite AS5b RP17": {
    url: `${path}/North Lakes - AS5b_RP17.jpg`,
   },
   "Adaptation Suite AS5b RP18": {
    url: `${path}/North Lakes - AS5b_RP18.jpg`,
   },
  },
  baseline: {
   url: `${path}/North Lakes.jpg`,
  },
 },
 "Le Tub 1": {
  scenario: {
   "Baseline Scenario RP2": {
    url: `${path}/Le Tub - rp2.jpg`,
   },
   "Baseline Scenario RP3": {
    url: `${path}/Le Tub - rp3.jpg`,
   },
   "Baseline Scenario RP4": {
    url: `${path}/Le Tub - rp4.jpg`,
   },
   "Baseline Scenario RP6": {
    url: `${path}/Le Tub - rp6.jpg`,
   },
   "Baseline Scenario RP7": {
    url: `${path}/Le Tub - rp7.jpg`,
   },
   "Baseline Scenario RP8": {
    url: `${path}/Le Tub - rp8.jpg`,
   },
   "Baseline Scenario RP9": {
    url: `${path}/Le Tub - rp9.jpg`,
   },
   "Baseline Scenario RP10": {
    url: `${path}/Le Tub - rp10.jpg`,
   },
   "Baseline Scenario RP11": {
    url: `${path}/Le Tub - rp11.jpg`,
   },
   "Baseline Scenario RP12": {
    url: `${path}/Le Tub - rp12.jpg`,
   },
   "Baseline Scenario RP13": {
    url: `${path}/Le Tub - rp13.jpg`,
   },
   "Baseline Scenario RP15": {
    url: `${path}/Le Tub - rp15.jpg`,
   },
   "Baseline Scenario RP16": {
    url: `${path}/Le Tub - rp16.jpg`,
   },
   "Baseline Scenario RP17": {
    url: `${path}/Le Tub - rp17.jpg`,
   },
   "Baseline Scenario RP18": {
    url: `${path}/Le Tub - rp18.jpg`,
   },
   //  "Baseline Scenario RP30": {
   //   url: `${path}/Le Tub.jpg`, // baseline
   //   // url: `${path}/Le Tub - rp30.jpg`, // does not exist ?
   //  },
   "Baseline Scenario RP35": {
    url: `${path}/Le Tub - rp35.jpg`,
   },
   "Baseline Scenario RP38": {
    url: `${path}/Le Tub - rp38.jpg`,
   },
   "Baseline Scenario RP42": {
    url: `${path}/Le Tub - rp42.jpg`,
   },
   "Baseline Scenario RP46": {
    url: `${path}/Le Tub - rp46.jpg`,
   },
   "Baseline Scenario RP47": {
    url: `${path}/Le Tub - rp47.jpg`,
   },
   "Baseline Scenario RP49": {
    url: `${path}/Le Tub - rp49.jpg`,
   },

   "Adaptation Suite AS5 RP4": {
    url: `${path}/Le Tub - AS5_RP4.jpg`,
   },
   "Adaptation Suite AS5 RP6": {
    url: `${path}/Le Tub - AS5_RP6.jpg`,
   },
   "Adaptation Suite AS5 RP7": {
    url: `${path}/Le Tub - AS5_RP7.jpg`,
   },
   "Adaptation Suite AS5 RP8": {
    url: `${path}/Le Tub - AS5_RP8.jpg`,
   },
   "Adaptation Suite AS5 RP9": {
    url: `${path}/Le Tub - AS5_RP9.jpg`,
   },
   "Adaptation Suite AS5 RP10": {
    url: `${path}/Le Tub - AS5_RP10.jpg`,
   },
   "Adaptation Suite AS5 RP11": {
    url: `${path}/Le Tub - AS5_RP11.jpg`,
   },
   "Adaptation Suite AS5 RP12": {
    url: `${path}/Le Tub - AS5_RP12.jpg`,
   },
   "Adaptation Suite AS5 RP13": {
    url: `${path}/Le Tub - AS5_RP13.jpg`,
   },
   "Adaptation Suite AS5 RP15": {
    url: `${path}/Le Tub - AS5_RP15.jpg`,
   },
   "Adaptation Suite AS5 RP16": {
    url: `${path}/Le Tub - AS5_RP16.jpg`,
   },
   "Adaptation Suite AS5 RP17": {
    url: `${path}/Le Tub - AS5_RP17.jpg`,
   },
   " Adaptation Suite AS5 RP18": {
    url: `${path}/Le Tub - AS5_RP18.jpg`,
   },
   "Adaptation Suite AS5 RP35": {
    url: `${path}/Le Tub - AS5_RP35.jpg`,
   },
   "Adaptation Suite AS5 RP35": {
    url: `${path}/Le Tub - AS5_RP49.jpg`,
   },

   "Adaptation Suite AS5b RP4": {
    url: `${path}/Le Tub - AS5b_RP4.jpg`,
   },
   "Adaptation Suite AS5b RP6": {
    url: `${path}/Le Tub - AS5b_RP6.jpg`,
   },
   "Adaptation Suite AS5b RP7": {
    url: `${path}/Le Tub - AS5b_RP7.jpg`,
   },
   "Adaptation Suite AS5b RP8": {
    url: `${path}/Le Tub - AS5b_RP8.jpg`,
   },
   "Adaptation Suite AS5b RP9": {
    url: `${path}/Le Tub - AS5b_RP9.jpg`,
   },
   "Adaptation Suite AS5b RP11": {
    url: `${path}/Le Tub - AS5b_RP11.jpg`,
   },
   "Adaptation Suite AS5b RP12": {
    url: `${path}/Le Tub - AS5b_RP12.jpg`,
   },
   "Adaptation Suite AS5b RP13": {
    url: `${path}/Le Tub - AS5b_RP13.jpg`,
   },
   "Adaptation Suite AS5b RP15": {
    url: `${path}/Le Tub - AS5b_RP15.jpg`,
   },
   "Adaptation Suite AS5b RP16": {
    url: `${path}/Le Tub - AS5b_RP16.jpg`,
   },
   "Adaptation Suite AS5b RP17": {
    url: `${path}/Le Tub - AS5b_RP17.jpg`,
   },
   "Adaptation Suite AS5b RP18": {
    url: `${path}/Le Tub - AS5b_RP18.jpg`,
   },
  },
  baseline: {
   url: `${path}/Le Tub.jpg`,
  },
 },
 "Fire Station 1": {
  scenario: {
   "Baseline Scenario RP2": {
    url: `${path}/Fire Station - rp2.jpg`,
   },
   "Baseline Scenario RP3": {
    url: `${path}/Fire Station - rp3.jpg`,
   },
   "Baseline Scenario RP4": {
    url: `${path}/Fire Station - rp4.jpg`,
   },
   "Baseline Scenario RP6": {
    url: `${path}/Fire Station - rp6.jpg`,
   },
   "Baseline Scenario RP7": {
    url: `${path}/Fire Station - rp7.jpg`,
   },
   "Baseline Scenario RP8": {
    url: `${path}/Fire Station - rp8.jpg`,
   },
   "Baseline Scenario RP9": {
    url: `${path}/Fire Station - rp9.jpg`,
   },
   "Baseline Scenario RP10": {
    url: `${path}/Fire Station - rp10.jpg`,
   },
   "Baseline Scenario RP11": {
    url: `${path}/Fire Station - rp11.jpg`,
   },
   "Baseline Scenario RP12": {
    url: `${path}/Fire Station - rp12.jpg`,
   },
   "Baseline Scenario RP13": {
    url: `${path}/Fire Station - rp13.jpg`,
   },
   "Baseline Scenario RP15": {
    url: `${path}/Fire Station - rp15.jpg`,
   },
   "Baseline Scenario RP16": {
    url: `${path}/Fire Station - rp16.jpg`,
   },
   "Baseline Scenario RP17": {
    url: `${path}/Fire Station - rp17.jpg`,
   },
   "Baseline Scenario RP18": {
    url: `${path}/Fire Station - rp18.jpg`,
   },
   "Baseline Scenario RP30": {
    url: `${path}/Fire Station - rp30.jpg`,
   },
   "Baseline Scenario RP35": {
    url: `${path}/Fire Station - rp35.jpg`,
   },
   "Baseline Scenario RP38": {
    url: `${path}/Fire Station - rp38.jpg`,
   },
   "Baseline Scenario RP42": {
    url: `${path}/Fire Station - rp42.jpg`,
   },
   "Baseline Scenario RP46": {
    url: `${path}/Fire Station - rp46.jpg`,
   },
   "Baseline Scenario RP47": {
    url: `${path}/Fire Station - rp47.jpg`,
   },
   "Baseline Scenario RP49": {
    url: `${path}/Fire Station - rp49.jpg`,
   },
   "Baseline Scenario VA1": {
    url: `${path}/Fire Station - va1.jpg`,
   },
   "Baseline Scenario VA3": {
    url: `${path}/Fire Station - va3.jpg`,
   },

   "Adaptation Suite AS5 RP2": {
    url: `${path}/Fire Station - AS5_RP2.jpg`,
   },
   "Adaptation Suite AS5 RP3": {
    url: `${path}/Fire Station - AS5_RP3.jpg`,
   },
   "Adaptation Suite AS5 RP4": {
    url: `${path}/Fire Station - AS5_RP4.jpg`,
   },
   "Adaptation Suite AS5 RP6": {
    url: `${path}/Fire Station - AS5_RP6.jpg`,
   },
   "Adaptation Suite AS5 RP7": {
    url: `${path}/Fire Station - AS5_RP7.jpg`,
   },
   "Adaptation Suite AS5 RP8": {
    url: `${path}/Fire Station - AS5_RP8.jpg`,
   },
   "Adaptation Suite AS5 RP9": {
    url: `${path}/Fire Station - AS5_RP9.jpg`,
   },
   "Adaptation Suite AS5 RP10": {
    url: `${path}/Fire Station - AS5_RP10.jpg`,
   },
   "Adaptation Suite AS5 RP11": {
    url: `${path}/Fire Station - AS5_RP11.jpg`,
   },
   "Adaptation Suite AS5 RP12": {
    url: `${path}/Fire Station - AS5_RP12.jpg`,
   },
   "Adaptation Suite AS5 RP13": {
    url: `${path}/Fire Station - AS5_RP13.jpg`,
   },
   "Adaptation Suite AS5 RP15": {
    url: `${path}/Fire Station - AS5_RP15.jpg`,
   },
   "Adaptation Suite AS5 RP16": {
    url: `${path}/Fire Station - AS5_RP16.jpg`,
   },
   "Adaptation Suite AS5 RP17": {
    url: `${path}/Fire Station - AS5_RP17.jpg`,
   },
   " Adaptation Suite AS5 RP18": {
    url: `${path}/Fire Station - AS5_RP18.jpg`,
   },
   "Adaptation Suite AS5 RP30": {
    url: `${path}/Fire Station - AS5_RP30.jpg`,
   },
   "Adaptation Suite AS5 RP35": {
    url: `${path}/Fire Station - AS5_RP35.jpg`,
   },
   "Adaptation Suite AS5 RP38": {
    url: `${path}/Fire Station - AS5_RP38.jpg`,
   },
   "Adaptation Suite AS5 RP42": {
    url: `${path}/Fire Station - AS5_RP42.jpg`,
   },
   "Adaptation Suite AS5 RP46": {
    url: `${path}/Fire Station - AS5_RP46.jpg`,
   },
   "Adaptation Suite AS5 RP47": {
    url: `${path}/Fire Station - AS5_RP47.jpg`,
   },
   "Adaptation Suite AS5 RP49": {
    url: `${path}/Fire Station - AS5_RP49.jpg`,
   },

   "AS5b RP2": {
    url: `${path}/Fire Station - AS5b_RP2.jpg`,
   },
   "Adaptation Suite AS5b RP3": {
    url: `${path}/Fire Station - AS5b_RP3.jpg`,
   },
   "Adaptation Suite AS5b RP4": {
    url: `${path}/Fire Station - AS5b_RP4.jpg`,
   },
   "Adaptation Suite AS5b RP6": {
    url: `${path}/Fire Station - AS5b_RP6.jpg`,
   },
   "Adaptation Suite AS5b RP7": {
    url: `${path}/Fire Station - AS5b_RP7.jpg`,
   },
   "Adaptation Suite AS5b RP8": {
    url: `${path}/Fire Station - AS5b_RP8.jpg`,
   },
   "Adaptation Suite AS5b RP9": {
    url: `${path}/Fire Station - AS5b_RP9.jpg`,
   },
   "Adaptation Suite AS5b RP10": {
    url: `${path}/Fire Station - AS5b_RP10.jpg`,
   },
   "Adaptation Suite AS5b RP11": {
    url: `${path}/Fire Station - AS5b_RP11.jpg`,
   },
   "Adaptation Suite AS5b RP12": {
    url: `${path}/Fire Station - AS5b_RP12.jpg`,
   },
   "Adaptation Suite AS5b RP13": {
    url: `${path}/Fire Station - AS5b_RP13.jpg`,
   },
   "Adaptation Suite AS5b RP15": {
    url: `${path}/Fire Station - AS5b_RP15.jpg`,
   },
   "Adaptation Suite AS5b RP16": {
    url: `${path}/Fire Station - AS5b_RP16.jpg`,
   },
   "Adaptation Suite AS5b RP17": {
    url: `${path}/Fire Station - AS5b_RP17.jpg`,
   },
   "Adaptation Suite AS5b RP18": {
    url: `${path}/Fire Station - AS5b_RP18.jpg`,
   },
   "Adaptation Suite AS5b RP42": {
    url: `${path}/Fire Station - AS5b_RP42.jpg`,
   },
   "Adaptation Suite AS5b RP47": {
    url: `${path}/Fire Station - AS5b_RP47.jpg`,
   },
   "Adaptation Suite AS5b RP49": {
    url: `${path}/Fire Station - AS5b_RP49.jpg`,
   },
  },
  baseline: {
   url: `${path}/Fire Station-Hallandale.jpg`,
  },
 },
 "Panera 1": {
  scenario: {
   "Baseline Scenario RP2": {
    url: `${path}/Panera-Hallandale - rp2.jpg`,
   },
   "Baseline Scenario RP3": {
    url: `${path}/Panera-Hallandale - rp3.jpg`,
   },
   "Baseline Scenario RP4": {
    url: `${path}/Panera-Hallandale - rp4.jpg`,
   },
   "Baseline Scenario RP6": {
    url: `${path}/Panera-Hallandale - rp6.jpg`,
   },
   "Baseline Scenario RP7": {
    url: `${path}/Panera-Hallandale - rp7.jpg`,
   },
   "Baseline Scenario RP8": {
    url: `${path}/Panera-Hallandale - rp8.jpg`,
   },
   "Baseline Scenario RP11": {
    url: `${path}/Panera-Hallandale - rp11.jpg`,
   },
   "Baseline Scenario RP12": {
    url: `${path}/Panera-Hallandale - rp12.jpg`,
   },
   "Baseline Scenario RP13": {
    url: `${path}/Panera-Hallandale - rp13.jpg`,
   },
   "Baseline Scenario RP15": {
    url: `${path}/Panera-Hallandale - rp15.jpg`,
   },
   "Baseline Scenario RP16": {
    url: `${path}/Panera-Hallandale - rp16.jpg`,
   },
   "Baseline Scenario RP17": {
    url: `${path}/Panera-Hallandale - rp17.jpg`,
   },
   "Baseline Scenario RP18": {
    url: `${path}/Panera-Hallandale - rp18.jpg`,
   },
   "Baseline Scenario RP49": {
    url: `${path}/Panera-Hallandale - rp49.jpg`,
   },
   "Baseline Scenario VA3": {
    url: `${path}/Panera-Hallandale - va3.jpg`,
   },

   "Adaptation Suite AS5 RP4": {
    url: `${path}/Panera-Hallandale - AS5_RP4.jpg`,
   },
   "Adaptation Suite AS5 RP6": {
    url: `${path}/Panera-Hallandale - AS5_RP6.jpg`,
   },
   "Adaptation Suite AS5 RP7": {
    url: `${path}/Panera-Hallandale - AS5_RP7.jpg`,
   },
   "Adaptation Suite AS5 RP8": {
    url: `${path}/Panera-Hallandale - AS5_RP8.jpg`,
   },
   "Adaptation Suite AS5 RP9": {
    url: `${path}/Panera-Hallandale - AS5_RP9.jpg`,
   },
   "Adaptation Suite AS5 RP13": {
    url: `${path}/Panera-Hallandale - AS5_RP13.jpg`,
   },
   "Adaptation Suite AS5 RP15": {
    url: `${path}/Panera-Hallandale - AS5_RP15.jpg`,
   },
   "Adaptation Suite AS5 RP16": {
    url: `${path}/Panera-Hallandale - AS5_RP16.jpg`,
   },
   "Adaptation Suite AS5 RP17": {
    url: `${path}/Panera-Hallandale - AS5_RP17.jpg`,
   },
   " Adaptation Suite AS5 RP18": {
    url: `${path}/Panera-Hallandale - AS5_RP18.jpg`,
   },

   "Adaptation Suite AS5b RP15": {
    url: `${path}/Panera-Hallandale - AS5b_RP15.jpg`,
   },
   "Adaptation Suite AS5b RP16": {
    url: `${path}/Panera-Hallandale - AS5b_RP16.jpg`,
   },
   "Adaptation Suite AS5b RP17": {
    url: `${path}/Panera-Hallandale - AS5b_RP17.jpg`,
   },
   "Adaptation Suite AS5b RP18": {
    url: `${path}/Panera-Hallandale - AS5b_RP18.jpg`,
   },
  },
  baseline: {
   url: `${path}/Panera-Hallandale.jpg`,
  },
 },
 "Gulfstream Park 2": {
  scenario: {
   "Baseline Scenario RP2": {
    url: `${path}/Gulfstream Park - rp2.jpg`,
   },
   "Baseline Scenario RP3": {
    url: `${path}/Gulfstream Park - rp3.jpg`,
   },
   "Baseline Scenario RP4": {
    url: `${path}/Gulfstream Park - rp4.jpg`,
   },
   "Baseline Scenario RP6": {
    url: `${path}/Gulfstream Park - rp6.jpg`,
   },
   "Baseline Scenario RP7": {
    url: `${path}/Gulfstream Park - rp7.jpg`,
   },
   "Baseline Scenario RP8": {
    url: `${path}/Gulfstream Park - rp8.jpg`,
   },
   "Baseline Scenario RP9": {
    url: `${path}/Gulfstream Park - rp9.jpg`,
   },
   "Baseline Scenario RP10": {
    url: `${path}/Gulfstream Park - rp10.jpg`,
   },
   "Baseline Scenario RP11": {
    url: `${path}/Gulfstream Park - rp11.jpg`,
   },
   "Baseline Scenario RP12": {
    url: `${path}/Gulfstream Park - rp12.jpg`,
   },
   "Baseline Scenario RP13": {
    url: `${path}/Gulfstream Park - rp13.jpg`,
   },
   "Baseline Scenario RP15": {
    url: `${path}/Gulfstream Park - rp15.jpg`,
   },
   "Baseline Scenario RP16": {
    url: `${path}/Gulfstream Park - rp16.jpg`,
   },
   "Baseline Scenario RP17": {
    url: `${path}/Gulfstream Park - rp17.jpg`,
   },
   "Baseline Scenario RP18": {
    url: `${path}/Gulfstream Park - rp18.jpg`,
   },
   "Baseline Scenario RP30": {
    url: `${path}/Gulfstream Park - rp30.jpg`,
   },
   "Baseline Scenario RP35": {
    url: `${path}/Gulfstream Park - rp35.jpg`,
   },
   "Baseline Scenario RP38": {
    url: `${path}/Gulfstream Park - rp38.jpg`,
   },
   "Baseline Scenario RP42": {
    url: `${path}/Gulfstream Park - rp42.jpg`,
   },
   "Baseline Scenario RP46": {
    url: `${path}/Gulfstream Park - rp46.jpg`,
   },
   "Baseline Scenario RP47": {
    url: `${path}/Gulfstream Park - rp47.jpg`,
   },
   "Baseline Scenario RP49": {
    url: `${path}/Gulfstream Park - rp49.jpg`,
   },
   "Baseline Scenario VA1": {
    url: `${path}/Gulfstream Park - va1.jpg`,
   },
   "Baseline Scenario VA3": {
    url: `${path}/Gulfstream Park - va3.jpg`,
   },

   "Adaptation Suite AS5 RP2": {
    url: `${path}/Gulfstream Park - AS5_RP2.jpg`,
   },
   "Adaptation Suite AS5 RP3": {
    url: `${path}/Gulfstream Park - AS5_RP3.jpg`,
   },
   "Adaptation Suite AS5 RP4": {
    url: `${path}/Gulfstream Park - AS5_RP4.jpg`,
   },
   "Adaptation Suite AS5 RP6": {
    url: `${path}/Gulfstream Park - AS5_RP6.jpg`,
   },
   "Adaptation Suite AS5 RP7": {
    url: `${path}/Gulfstream Park - AS5_RP7.jpg`,
   },
   "Adaptation Suite AS5 RP8": {
    url: `${path}/Gulfstream Park - AS5_RP8.jpg`,
   },
   "Adaptation Suite AS5 RP9": {
    url: `${path}/Gulfstream Park - AS5_RP9.jpg`,
   },
   "Adaptation Suite AS5 RP10": {
    url: `${path}/Gulfstream Park - AS5_RP10.jpg`,
   },
   "Adaptation Suite AS5 RP11": {
    url: `${path}/Gulfstream Park - AS5_RP11.jpg`,
   },
   "Adaptation Suite AS5 RP12": {
    url: `${path}/Gulfstream Park - AS5_RP12.jpg`,
   },
   "Adaptation Suite AS5 RP13": {
    url: `${path}/Gulfstream Park - AS5_RP13.jpg`,
   },
   "Adaptation Suite AS5 RP15": {
    url: `${path}/Gulfstream Park - AS5_RP15.jpg`,
   },
   "Adaptation Suite AS5 RP16": {
    url: `${path}/Gulfstream Park - AS5_RP16.jpg`,
   },
   "Adaptation Suite AS5 RP17": {
    url: `${path}/Gulfstream Park - AS5_RP17.jpg`,
   },
   " Adaptation Suite AS5 RP18": {
    url: `${path}/Gulfstream Park - AS5_RP18.jpg`,
   },
   "Adaptation Suite AS5 RP42": {
    url: `${path}/Gulfstream Park - AS5_RP42.jpg`,
   },
   "Adaptation Suite AS5 RP47": {
    url: `${path}/Gulfstream Park - AS5_RP47.jpg`,
   },
   "Adaptation Suite AS5 RP49": {
    url: `${path}/Gulfstream Park - AS5_RP49.jpg`,
   },

   "AS5b RP2": {
    url: `${path}/Gulfstream Park - AS5b_RP2.jpg`,
   },
   "Adaptation Suite AS5b RP3": {
    url: `${path}/Gulfstream Park - AS5b_RP3.jpg`,
   },
   "Adaptation Suite AS5b RP4": {
    url: `${path}/Gulfstream Park - AS5b_RP4.jpg`,
   },
   "Adaptation Suite AS5b RP10": {
    url: `${path}/Gulfstream Park - AS5b_RP10.jpg`,
   },
   "Adaptation Suite AS5b RP11": {
    url: `${path}/Gulfstream Park - AS5b_RP11.jpg`,
   },
   "Adaptation Suite AS5b RP12": {
    url: `${path}/Gulfstream Park - AS5b_RP12.jpg`,
   },
   "Adaptation Suite AS5b RP13": {
    url: `${path}/Gulfstream Park - AS5b_RP13.jpg`,
   },
   "Adaptation Suite AS5b RP15": {
    url: `${path}/Gulfstream Park - AS5b_RP15.jpg`,
   },
   "Adaptation Suite AS5b RP16": {
    url: `${path}/Gulfstream Park - AS5b_RP16.jpg`,
   },
   "Adaptation Suite AS5b RP17": {
    url: `${path}/Gulfstream Park - AS5b_RP17.jpg`,
   },
   "Adaptation Suite AS5b RP49": {
    url: `${path}/Gulfstream Park - AS5b_RP49.jpg`,
   },
  },
  baseline: {
   url: `${path}/Gulfstream Park  .jpg`,
  },
 },
 "Miramar Cultural Center 2": {
  scenario: {
   "Baseline Scenario RP2": {
    url: `${path}/Miramar Cultural Center - rp2.jpg`,
   },
   "Baseline Scenario RP3": {
    url: `${path}/Miramar Cultural Center - rp3.jpg`,
   },
   "Baseline Scenario RP4": {
    url: `${path}/Miramar Cultural Center - rp4.jpg`,
   },
   "Baseline Scenario RP6": {
    url: `${path}/Miramar Cultural Center - rp6.jpg`,
   },
   "Baseline Scenario RP7": {
    url: `${path}/Miramar Cultural Center - rp7.jpg`,
   },
   "Baseline Scenario RP8": {
    url: `${path}/Miramar Cultural Center - rp8.jpg`,
   },
   "Baseline Scenario RP9": {
    url: `${path}/Miramar Cultural Center - rp9.jpg`,
   },
   "Baseline Scenario RP10": {
    url: `${path}/Miramar Cultural Center - rp10.jpg`,
   },
   "Baseline Scenario RP11": {
    url: `${path}/Miramar Cultural Center - rp11.jpg`,
   },
   "Baseline Scenario RP12": {
    url: `${path}/Miramar Cultural Center - rp12.jpg`,
   },
   "Baseline Scenario RP13": {
    url: `${path}/Miramar Cultural Center - rp13.jpg`,
   },
   "Baseline Scenario RP15": {
    url: `${path}/Miramar Cultural Center - rp15.jpg`,
   },
   "Baseline Scenario RP17": {
    url: `${path}/Miramar Cultural Center - rp17.jpg`,
   },
   "Baseline Scenario RP18": {
    url: `${path}/Miramar Cultural Center - rp18.jpg`,
   },
   "Baseline Scenario RP30": {
    url: `${path}/Miramar Cultural Center - rp30.jpg`,
   },
   "Baseline Scenario RP35": {
    url: `${path}/Miramar Cultural Center - rp35.jpg`,
   },
   "Baseline Scenario RP38": {
    url: `${path}/Miramar Cultural Center - rp38.jpg`,
   },
   "Baseline Scenario RP42": {
    url: `${path}/Miramar Cultural Center - rp42.jpg`,
   },
   "Baseline Scenario RP46": {
    url: `${path}/Miramar Cultural Center - rp46.jpg`,
   },
   "Baseline Scenario RP47": {
    url: `${path}/Miramar Cultural Center - rp47.jpg`,
   },
   "Baseline Scenario RP49": {
    url: `${path}/Miramar Cultural Center - rp49.jpg`,
   },
   "Baseline Scenario VA1": {
    url: `${path}/Miramar Cultural Center - va1.jpg`,
   },
   "Baseline Scenario VA3": {
    url: `${path}/Miramar Cultural Center - va3.jpg`,
   },

   "Adaptation Suite AS5 RP2": {
    url: `${path}/Miramar Cultural Center - AS5_RP2.jpg`,
   },
   "Adaptation Suite AS5 RP3": {
    url: `${path}/Miramar Cultural Center - AS5_RP3.jpg`,
   },
   "Adaptation Suite AS5 RP4": {
    url: `${path}/Miramar Cultural Center - AS5_RP4.jpg`,
   },
   "Adaptation Suite AS5 RP6": {
    url: `${path}/Miramar Cultural Center - AS5_RP6.jpg`,
   },
   "Adaptation Suite AS5 RP7": {
    url: `${path}/Miramar Cultural Center - AS5_RP7.jpg`,
   },
   "Adaptation Suite AS5 RP8": {
    url: `${path}/Miramar Cultural Center - AS5_RP8.jpg`,
   },
   "Adaptation Suite AS5 RP9": {
    url: `${path}/Miramar Cultural Center - AS5_RP9.jpg`,
   },
   "Adaptation Suite AS5 RP10": {
    url: `${path}/Miramar Cultural Center - AS5_RP10.jpg`,
   },
   "Adaptation Suite AS5 RP11": {
    url: `${path}/Miramar Cultural Center - AS5_RP11.jpg`,
   },
   "Adaptation Suite AS5 RP12": {
    url: `${path}/Miramar Cultural Center - AS5_RP12.jpg`,
   },
   "Adaptation Suite AS5 RP13": {
    url: `${path}/Miramar Cultural Center - AS5_RP13.jpg`,
   },
   "Adaptation Suite AS5 RP15": {
    url: `${path}/Miramar Cultural Center - AS5_RP15.jpg`,
   },
   "Adaptation Suite AS5 RP16": {
    url: `${path}/Miramar Cultural Center - AS5_RP16.jpg`,
   },
   "Adaptation Suite AS5 RP17": {
    url: `${path}/Miramar Cultural Center - AS5_RP17.jpg`,
   },
   " Adaptation Suite AS5 RP18": {
    url: `${path}/Miramar Cultural Center - AS5_RP18.jpg`,
   },
   "Adaptation Suite AS5 RP30": {
    url: `${path}/Miramar Cultural Center - AS5_RP30.jpg`,
   },
   "Adaptation Suite AS5 RP35": {
    url: `${path}/Miramar Cultural Center - AS5_RP35.jpg`,
   },
   "Adaptation Suite AS5 RP38": {
    url: `${path}/Miramar Cultural Center - AS5_RP38.jpg`,
   },
   "Adaptation Suite AS5 RP42": {
    url: `${path}/Miramar Cultural Center - AS5_RP42.jpg`,
   },
   "Adaptation Suite AS5 RP46": {
    url: `${path}/Miramar Cultural Center - AS5_RP46.jpg`,
   },
   "Adaptation Suite AS5 RP47": {
    url: `${path}/Miramar Cultural Center - AS5_RP47.jpg`,
   },
   "Adaptation Suite AS5 RP49": {
    url: `${path}/Miramar Cultural Center - AS5_RP49.jpg`,
   },

   "AS5b RP2": {
    url: `${path}/Miramar Cultural Center - AS5b_RP2.jpg`,
   },
   "Adaptation Suite AS5b RP3": {
    url: `${path}/Miramar Cultural Center - AS5b_RP3.jpg`,
   },
   "Adaptation Suite AS5b RP4": {
    url: `${path}/Miramar Cultural Center - AS5b_RP4.jpg`,
   },
   "Adaptation Suite AS5b RP6": {
    url: `${path}/Miramar Cultural Center - AS5b_RP6.jpg`,
   },
   "Adaptation Suite AS5b RP7": {
    url: `${path}/Miramar Cultural Center - AS5b_RP7.jpg`,
   },
   "Adaptation Suite AS5b RP8": {
    url: `${path}/Miramar Cultural Center - AS5b_RP8.jpg`,
   },
   "Adaptation Suite AS5b RP9": {
    url: `${path}/Miramar Cultural Center - AS5b_RP9.jpg`,
   },
   "Adaptation Suite AS5b RP10": {
    url: `${path}/Miramar Cultural Center - AS5b_RP10.jpg`,
   },
   "Adaptation Suite AS5b RP11": {
    url: `${path}/Miramar Cultural Center - AS5b_RP11.jpg`,
   },
   "Adaptation Suite AS5b RP12": {
    url: `${path}/Miramar Cultural Center - AS5b_RP12.jpg`,
   },
   "Adaptation Suite AS5b RP13": {
    url: `${path}/Miramar Cultural Center - AS5b_RP13.jpg`,
   },
   "Adaptation Suite AS5b RP15": {
    url: `${path}/Miramar Cultural Center - AS5b_RP15.jpg`,
   },
   "Adaptation Suite AS5b RP16": {
    url: `${path}/Miramar Cultural Center - AS5b_RP16.jpg`,
   },
   "Adaptation Suite AS5b RP17": {
    url: `${path}/Miramar Cultural Center - AS5b_RP17.jpg`,
   },
   "Adaptation Suite AS5b RP18": {
    url: `${path}/Miramar Cultural Center - AS5b_RP18.jpg`,
   },
   "Adaptation Suite AS5b RP30": {
    url: `${path}/Miramar Cultural Center - AS5b_RP30.jpg`,
   },
   "Adaptation Suite AS5b RP35": {
    url: `${path}/Miramar Cultural Center - AS5b_RP35.jpg`,
   },
   "Adaptation Suite AS5b RP38": {
    url: `${path}/Miramar Cultural Center - AS5b_RP38.jpg`,
   },
   "Adaptation Suite AS5b RP42": {
    url: `${path}/Miramar Cultural Center - AS5b_RP42.jpg`,
   },
   "Adaptation Suite AS5b RP46": {
    url: `${path}/Miramar Cultural Center - AS5b_RP46.jpg`,
   },
   "Adaptation Suite AS5b RP47": {
    url: `${path}/Miramar Cultural Center - AS5b_RP47.jpg`,
   },
   "Adaptation Suite AS5b RP49": {
    url: `${path}/Miramar Cultural Center - AS5b_RP49.jpg`,
   },
  },
  baseline: {
   url: `${path}/Miramar Cultural Center - High Resolution.jpg`,
  },
 },
 "Perry Airport 3": {
  scenario: {
   "Baseline Scenario RP2": {
    url: `${path}/Perry Airport - RP2.jpg`,
   },
   "Baseline Scenario RP3": {
    url: `${path}/Perry Airport - RP3.jpg`,
   },
   "Baseline Scenario RP4": {
    url: `${path}/Perry Airport - RP4.jpg`,
   },
   "Baseline Scenario RP6": {
    url: `${path}/Perry Airport - RP6.jpg`,
   },
   "Baseline Scenario RP7": {
    url: `${path}/Perry Airport - RP7.jpg`,
   },
   "Baseline Scenario RP8": {
    url: `${path}/Perry Airport - RP8.jpg`,
   },
   "Baseline Scenario RP9": {
    url: `${path}/Perry Airport - RP9.jpg`,
   },
   "Baseline Scenario RP10": {
    url: `${path}/Perry Airport - RP10.jpg`,
   },
   "Baseline Scenario RP11": {
    url: `${path}/Perry Airport - RP11.jpg`,
   },
   "Baseline Scenario RP12": {
    url: `${path}/Perry Airport - RP12.jpg`,
   },
   "Baseline Scenario RP13": {
    url: `${path}/Perry Airport - RP13.jpg`,
   },
   "Baseline Scenario RP15": {
    url: `${path}/Perry Airport - RP15.jpg`,
   },
   "Baseline Scenario RP16": {
    url: `${path}/Perry Airport - RP16.jpg`,
   },
   "Baseline Scenario RP17": {
    url: `${path}/Perry Airport - RP17.jpg`,
   },
   "Baseline Scenario RP18": {
    url: `${path}/Perry Airport - RP18.jpg`,
   },
   "Baseline Scenario RP49": {
    url: `${path}/Perry Airport - RP49.jpg`,
   },
   "Baseline Scenario VA3": {
    url: `${path}/Perry Airport - VA3.jpg`,
   },

   "Adaptation Suite AS5 RP2": {
    url: `${path}/Perry Airport - AS5_RP2.jpg`,
   },
   "Adaptation Suite AS5 RP3": {
    url: `${path}/Perry Airport - AS5_RP3.jpg`,
   },
   "Adaptation Suite AS5 RP6": {
    url: `${path}/Perry Airport - AS5_RP6.jpg`,
   },
   "Adaptation Suite AS5 RP8": {
    url: `${path}/Perry Airport - AS5_RP8.jpg`,
   },
   "Adaptation Suite AS5 RP9": {
    url: `${path}/Perry Airport - AS5_RP9.jpg`,
   },
   "Adaptation Suite AS5 RP11": {
    url: `${path}/Perry Airport - AS5_RP11.jpg`,
   },
   "Adaptation Suite AS5 RP12": {
    url: `${path}/Perry Airport - AS5_RP12.jpg`,
   },
   "Adaptation Suite AS5 RP13": {
    url: `${path}/Perry Airport - AS5_RP13.jpg`,
   },
   "Adaptation Suite AS5 RP15": {
    url: `${path}/Perry Airport - AS5_RP15.jpg`,
   },
   "Adaptation Suite AS5 RP16": {
    url: `${path}/Perry Airport - AS5_RP16.jpg`,
   },
   "Adaptation Suite AS5 RP17": {
    url: `${path}/Perry Airport - AS5_RP17.jpg`,
   },
   "Adaptation Suite AS5 RP18": {
    url: `${path}/Perry Airport - AS5_RP18.jpg`,
   },
   "Adaptation Suite AS5 RP49": {
    url: `${path}/Perry Airport - AS5_RP49.jpg`,
   },

   "Adaptation Suite AS5b RP2": {
    url: `${path}/Perry Airport - AS5b_RP2.jpg`,
   },
   "Adaptation Suite AS5b RP3": {
    url: `${path}/Perry Airport - AS5b_RP3.jpg`,
   },
   "Adaptation Suite AS5b RP6": {
    url: `${path}/Perry Airport - AS5b_RP6.jpg`,
   },
   "Adaptation Suite AS5b RP8": {
    url: `${path}/Perry Airport - AS5b_RP8.jpg`,
   },
   "Adaptation Suite AS5b RP9": {
    url: `${path}/Perry Airport - AS5b_RP9.jpg`,
   },
   "Adaptation Suite AS5b RP11": {
    url: `${path}/Perry Airport - AS5b_RP11.jpg`,
   },
   "Adaptation Suite AS5b RP12": {
    url: `${path}/Perry Airport - AS5b_RP12.jpg`,
   },
   "Adaptation Suite AS5b RP13": {
    url: `${path}/Perry Airport - AS5b_RP13.jpg`,
   },
   "Adaptation Suite AS5b RP15": {
    url: `${path}/Perry Airport - AS5b_RP15.jpg`,
   },
   "Adaptation Suite AS5b RP16": {
    url: `${path}/Perry Airport - AS5b_RP16.jpg`,
   },
   "Adaptation Suite AS5b RP17": {
    url: `${path}/Perry Airport - AS5b_RP17.jpg`,
   },
   "Adaptation Suite AS5b RP18": {
    url: `${path}/Perry Airport - AS5b_RP18.jpg`,
   },
   "Adaptation Suite AS5b RP49": {
    url: `${path}/Perry Airport - AS5b_RP49.jpg`,
   },
  },
  baseline: {
   url: `${path}/Perry Airport - High Resolution.jpg`,
  },
 },

 "Pembroke Garden Mall 2": {
  scenario: {
   "Baseline Scenario RP2": {
    url: `${path}/Pembroke Garden Mall - RP2.jpg`,
   },
   "Baseline Scenario RP3": {
    url: `${path}/Pembroke Garden Mall - RP3.jpg`,
   },
   "Baseline Scenario RP4": {
    url: `${path}/Pembroke Garden Mall - RP4.jpg`,
   },
   "Baseline Scenario RP6": {
    url: `${path}/Pembroke Garden Mall - RP6.jpg`,
   },
   "Baseline Scenario RP7": {
    url: `${path}/Pembroke Garden Mall - RP7.jpg`,
   },
   "Baseline Scenario RP8": {
    url: `${path}/Pembroke Garden Mall - RP8.jpg`,
   },
   "Baseline Scenario RP9": {
    url: `${path}/Pembroke Garden Mall - RP9.jpg`,
   },
   "Baseline Scenario RP10": {
    url: `${path}/Pembroke Garden Mall - RP10.jpg`,
   },
   "Baseline Scenario RP11": {
    url: `${path}/Pembroke Garden Mall - RP11.jpg`,
   },
   "Baseline Scenario RP12": {
    url: `${path}/Pembroke Garden Mall - RP12.jpg`,
   },
   "Baseline Scenario RP13": {
    url: `${path}/Pembroke Garden Mall - RP13.jpg`,
   },
   "Baseline Scenario RP15": {
    url: `${path}/Pembroke Garden Mall - RP15.jpg`,
   },
   "Baseline Scenario RP16": {
    url: `${path}/Pembroke Garden Mall - RP16.jpg`,
   },
   "Baseline Scenario RP17": {
    url: `${path}/Pembroke Garden Mall - RP17.jpg`,
   },
   "Baseline Scenario RP18": {
    url: `${path}/Pembroke Garden Mall - RP18.jpg`,
   },
   "Baseline Scenario RP30": {
    url: `${path}/Pembroke Garden Mall - RP30.jpg`,
   },
   "Baseline Scenario RP35": {
    url: `${path}/Pembroke Garden Mall - RP35.jpg`,
   },
   "Baseline Scenario RP38": {
    url: `${path}/Pembroke Garden Mall - RP38.jpg`,
   },
   "Baseline Scenario RP42": {
    url: `${path}/Pembroke Garden Mall - RP42.jpg`,
   },
   "Baseline Scenario RP46": {
    url: `${path}/Pembroke Garden Mall - RP46.jpg`,
   },
   "Baseline Scenario RP47": {
    url: `${path}/Pembroke Garden Mall - RP47.jpg`,
   },
   "Baseline Scenario RP49": {
    url: `${path}/Pembroke Garden Mall - RP49.jpg`,
   },
   "Baseline Scenario VA1": {
    url: `${path}/Pembroke Garden Mall - Va1_c.jpg`,
   },
   "Baseline Scenario VA3": {
    url: `${path}/Pembroke Garden Mall - VA3.jpg`,
   },

   "Adaptation Suite AS5 RP2": {
    url: `${path}/Pembroke Garden Mall - AS5_RP2.jpg`,
   },
   "Adaptation Suite AS5 RP3": {
    url: `${path}/Pembroke Garden Mall - AS5_RP3.jpg`,
   },
   "Adaptation Suite AS5 RP4": {
    url: `${path}/Pembroke Garden Mall - AS5_RP4.jpg`,
   },
   "Adaptation Suite AS5 RP6": {
    url: `${path}/Pembroke Garden Mall - AS5_RP6.jpg`,
   },
   "Adaptation Suite AS5 RP7": {
    url: `${path}/Pembroke Garden Mall - AS5_RP7.jpg`,
   },
   "Adaptation Suite AS5 RP8": {
    url: `${path}/Pembroke Garden Mall - AS5_RP8.jpg`,
   },
   "Adaptation Suite AS5 RP9": {
    url: `${path}/Pembroke Garden Mall - AS5_RP9.jpg`,
   },
   "Adaptation Suite AS5 RP10": {
    url: `${path}/Pembroke Garden Mall - AS5_RP10.jpg`,
   },
   "Adaptation Suite AS5 RP11": {
    url: `${path}/Pembroke Garden Mall - AS5_RP11.jpg`,
   },
   "Adaptation Suite AS5 RP12": {
    url: `${path}/Pembroke Garden Mall - AS5_RP12.jpg`,
   },
   "Adaptation Suite AS5 RP13": {
    url: `${path}/Pembroke Garden Mall - AS5_RP13.jpg`,
   },
   "Adaptation Suite AS5 RP15": {
    url: `${path}/Pembroke Garden Mall - AS5_RP15.jpg`,
   },
   "Adaptation Suite AS5 RP16": {
    url: `${path}/Pembroke Garden Mall - AS5_RP16.jpg`,
   },
   "Adaptation Suite AS5 RP17": {
    url: `${path}/Pembroke Garden Mall - AS5_RP17.jpg`,
   },
   " Adaptation Suite AS5 RP18": {
    url: `${path}/Pembroke Garden Mall - AS5_RP18.jpg`,
   },
   "Adaptation Suite AS5 RP30": {
    url: `${path}/Pembroke Garden Mall - AS5_RP30.jpg`,
   },
   "Adaptation Suite AS5 RP35": {
    url: `${path}/Pembroke Garden Mall - AS5_RP35.jpg`,
   },
   "Adaptation Suite AS5 RP38": {
    url: `${path}/Pembroke Garden Mall - AS5_RP38.jpg`,
   },
   "Adaptation Suite AS5 RP42": {
    url: `${path}/Pembroke Garden Mall - AS5_RP42.jpg`,
   },
   "Adaptation Suite AS5 RP46": {
    url: `${path}/Pembroke Garden Mall - AS5_RP46.jpg`,
   },
   "Adaptation Suite AS5 RP47": {
    url: `${path}/Pembroke Garden Mall - AS5_RP47.jpg`,
   },
   "Adaptation Suite AS5 RP49": {
    url: `${path}/Pembroke Garden Mall - AS5_RP49.jpg`,
   },

   "AS5b RP2": {
    url: `${path}/Pembroke Garden Mall - AS5b_RP2.jpg`,
   },
   "Adaptation Suite AS5b RP3": {
    url: `${path}/Pembroke Garden Mall - AS5b_RP3.jpg`,
   },
   "Adaptation Suite AS5b RP4": {
    url: `${path}/Pembroke Garden Mall - AS5b_RP4.jpg`,
   },
   "Adaptation Suite AS5b RP6": {
    url: `${path}/Pembroke Garden Mall - AS5b_RP6.jpg`,
   },
   "Adaptation Suite AS5b RP7": {
    url: `${path}/Pembroke Garden Mall - AS5b_RP7.jpg`,
   },
   "Adaptation Suite AS5b RP8": {
    url: `${path}/Pembroke Garden Mall - AS5b_RP8.jpg`,
   },
   "Adaptation Suite AS5b RP9": {
    url: `${path}/Pembroke Garden Mall - AS5b_RP9.jpg`,
   },
   "Adaptation Suite AS5b RP10": {
    url: `${path}/Pembroke Garden Mall - AS5b_RP10.jpg`,
   },
   "Adaptation Suite AS5b RP11": {
    url: `${path}/Pembroke Garden Mall - AS5b_RP11.jpg`,
   },
   "Adaptation Suite AS5b RP12": {
    url: `${path}/Pembroke Garden Mall - AS5b_RP12.jpg`,
   },
   "Adaptation Suite AS5b RP13": {
    url: `${path}/Pembroke Garden Mall - AS5b_RP13.jpg`,
   },
   "Adaptation Suite AS5b RP15": {
    url: `${path}/Pembroke Garden Mall - AS5b_RP15.jpg`,
   },
   "Adaptation Suite AS5b RP16": {
    url: `${path}/Pembroke Garden Mall - AS5b_RP16.jpg`,
   },
   "Adaptation Suite AS5b RP17": {
    url: `${path}/Pembroke Garden Mall - AS5b_RP17.jpg`,
   },
   "Adaptation Suite AS5b RP18": {
    url: `${path}/Pembroke Garden Mall - AS5b_RP18.jpg`,
   },
   "Adaptation Suite AS5b RP30": {
    url: `${path}/Pembroke Garden Mall - AS5b_RP30.jpg`,
   },
   "Adaptation Suite AS5b RP35": {
    url: `${path}/Pembroke Garden Mall - AS5b_RP35.jpg`,
   },
   "Adaptation Suite AS5b RP38": {
    url: `${path}/Pembroke Garden Mall - AS5b_RP38.jpg`,
   },
   "Adaptation Suite AS5b RP42": {
    url: `${path}/Pembroke Garden Mall - AS5b_RP42.jpg`,
   },
   "Adaptation Suite AS5b RP46": {
    url: `${path}/Pembroke Garden Mall - AS5b_RP46.jpg`,
   },
   "Adaptation Suite AS5b RP47": {
    url: `${path}/Pembroke Garden Mall - AS5b_RP47.jpg`,
   },
   "Adaptation Suite AS5b RP49": {
    url: `${path}/Pembroke Garden Mall - AS5b_RP49.jpg`,
   },
  },
  baseline: {
   url: `${path}/Pembroke Garden Mall - High Resolution.jpg`,
  },
 },
};
